
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ilpIi", function(module, exports) {

var $9HrqM = parcelRequire("9HrqM");
$parcel$exportWildcard(module.exports, $9HrqM);

});
parcelRegister("9HrqM", function(module, exports) {

$parcel$export(module.exports, "setLogLevel", () => $70fd6868680e912c$export$c622e99c0ce7b1c9);
$parcel$export(module.exports, "_logWarn", () => $70fd6868680e912c$export$86cd73f49cc6e0bb);
$parcel$export(module.exports, "_debugAssert", () => $70fd6868680e912c$export$1d2b90eea9bba017);
$parcel$export(module.exports, "FirestoreError", () => $70fd6868680e912c$export$8fada0bf726bf278);
$parcel$export(module.exports, "_EmptyAuthCredentialsProvider", () => $70fd6868680e912c$export$65ffa50b6039c992);
$parcel$export(module.exports, "_EmptyAppCheckTokenProvider", () => $70fd6868680e912c$export$b342cec01954510f);
$parcel$export(module.exports, "_AutoId", () => $70fd6868680e912c$export$253bcaa5572dcc83);
$parcel$export(module.exports, "_FieldPath", () => $70fd6868680e912c$export$b7871852b967eaf1);
$parcel$export(module.exports, "_DocumentKey", () => $70fd6868680e912c$export$afc2e57c475b7810);
$parcel$export(module.exports, "_validateIsNotUsedTogether", () => $70fd6868680e912c$export$8731e8d1617cddb1);
$parcel$export(module.exports, "_cast", () => $70fd6868680e912c$export$572106fb5803752c);
$parcel$export(module.exports, "Timestamp", () => $70fd6868680e912c$export$d9bcbd5e1ff81430);
$parcel$export(module.exports, "_isBase64Available", () => $70fd6868680e912c$export$cbfc1605afde699b);
$parcel$export(module.exports, "_ByteString", () => $70fd6868680e912c$export$67460cdabfa21253);
$parcel$export(module.exports, "_DatabaseId", () => $70fd6868680e912c$export$4c3ccc07620ae30a);
$parcel$export(module.exports, "connectFirestoreEmulator", () => $70fd6868680e912c$export$966a03d25297d115);
$parcel$export(module.exports, "Query", () => $70fd6868680e912c$export$62297b13309008b2);
$parcel$export(module.exports, "DocumentReference", () => $70fd6868680e912c$export$6be62b059fb12175);
$parcel$export(module.exports, "CollectionReference", () => $70fd6868680e912c$export$ab5a1a47940a200e);
$parcel$export(module.exports, "collection", () => $70fd6868680e912c$export$bf5175b0c24981cd);
$parcel$export(module.exports, "collectionGroup", () => $70fd6868680e912c$export$473d82a73f88c107);
$parcel$export(module.exports, "doc", () => $70fd6868680e912c$export$2a111da947c407d2);
$parcel$export(module.exports, "refEqual", () => $70fd6868680e912c$export$62a32f2da6187d11);
$parcel$export(module.exports, "queryEqual", () => $70fd6868680e912c$export$49b1d0de6ba30f41);
$parcel$export(module.exports, "LoadBundleTask", () => $70fd6868680e912c$export$6cac12425252ec14);
$parcel$export(module.exports, "CACHE_SIZE_UNLIMITED", () => $70fd6868680e912c$export$3e714f2ae27d2df4);
$parcel$export(module.exports, "Firestore", () => $70fd6868680e912c$export$d0e2b3272814ce82);
$parcel$export(module.exports, "initializeFirestore", () => $70fd6868680e912c$export$9061557f3e3b42f9);
$parcel$export(module.exports, "getFirestore", () => $70fd6868680e912c$export$f06a05d14c3a6678);
$parcel$export(module.exports, "ensureFirestoreConfigured", () => $70fd6868680e912c$export$8da5fbea04405656);
$parcel$export(module.exports, "enableIndexedDbPersistence", () => $70fd6868680e912c$export$cebe3b626a79c5f3);
$parcel$export(module.exports, "enableMultiTabIndexedDbPersistence", () => $70fd6868680e912c$export$6d4c055e91302ab9);
$parcel$export(module.exports, "clearIndexedDbPersistence", () => $70fd6868680e912c$export$b4f5899b4e28cf7b);
$parcel$export(module.exports, "waitForPendingWrites", () => $70fd6868680e912c$export$50b5113fd6653025);
$parcel$export(module.exports, "enableNetwork", () => $70fd6868680e912c$export$ee6bdee8287ecc5f);
$parcel$export(module.exports, "disableNetwork", () => $70fd6868680e912c$export$f35b708ad73d52eb);
$parcel$export(module.exports, "terminate", () => $70fd6868680e912c$export$9aff22d1ec357a14);
$parcel$export(module.exports, "loadBundle", () => $70fd6868680e912c$export$4b8b93c690c9810b);
$parcel$export(module.exports, "namedQuery", () => $70fd6868680e912c$export$169d2c6fe0f7f4ea);
$parcel$export(module.exports, "AggregateField", () => $70fd6868680e912c$export$fada2345be8928cf);
$parcel$export(module.exports, "AggregateQuerySnapshot", () => $70fd6868680e912c$export$40257fef64be808b);
$parcel$export(module.exports, "Bytes", () => $70fd6868680e912c$export$9f55f2e2bf8c2fc1);
$parcel$export(module.exports, "FieldPath", () => $70fd6868680e912c$export$a1a8fea822d17659);
$parcel$export(module.exports, "documentId", () => $70fd6868680e912c$export$bf6e62266977b8eb);
$parcel$export(module.exports, "FieldValue", () => $70fd6868680e912c$export$c58bc8ee7ecc248d);
$parcel$export(module.exports, "GeoPoint", () => $70fd6868680e912c$export$f9f719d1b6419c4);
$parcel$export(module.exports, "VectorValue", () => $70fd6868680e912c$export$994bb3d317350b37);
$parcel$export(module.exports, "QueryConstraint", () => $70fd6868680e912c$export$b0e86f2c7431df4e);
$parcel$export(module.exports, "query", () => $70fd6868680e912c$export$2fa187e846a241c4);
$parcel$export(module.exports, "QueryCompositeFilterConstraint", () => $70fd6868680e912c$export$6bbc7aef0717f3d2);
$parcel$export(module.exports, "QueryFieldFilterConstraint", () => $70fd6868680e912c$export$f765fc5789dfd439);
$parcel$export(module.exports, "where", () => $70fd6868680e912c$export$9c59b80dda569a6e);
$parcel$export(module.exports, "or", () => $70fd6868680e912c$export$252bb8b3bbdf6749);
$parcel$export(module.exports, "and", () => $70fd6868680e912c$export$21c0ac7fe1cef1b8);
$parcel$export(module.exports, "QueryOrderByConstraint", () => $70fd6868680e912c$export$65a9ba8bbd6ed9e3);
$parcel$export(module.exports, "orderBy", () => $70fd6868680e912c$export$f18af21d6f4dafd8);
$parcel$export(module.exports, "QueryLimitConstraint", () => $70fd6868680e912c$export$49bb5356ca788047);
$parcel$export(module.exports, "limit", () => $70fd6868680e912c$export$ee37e834aaad6f7e);
$parcel$export(module.exports, "limitToLast", () => $70fd6868680e912c$export$f823b3589f69d3b8);
$parcel$export(module.exports, "QueryStartAtConstraint", () => $70fd6868680e912c$export$d92e2830aca1d816);
$parcel$export(module.exports, "startAt", () => $70fd6868680e912c$export$859941c5fc8eba6b);
$parcel$export(module.exports, "startAfter", () => $70fd6868680e912c$export$dd8dee5f7b804673);
$parcel$export(module.exports, "QueryEndAtConstraint", () => $70fd6868680e912c$export$fd1782fd870d1e06);
$parcel$export(module.exports, "endBefore", () => $70fd6868680e912c$export$57203950645b8b11);
$parcel$export(module.exports, "endAt", () => $70fd6868680e912c$export$28ec54a8428bdb3f);
$parcel$export(module.exports, "AbstractUserDataWriter", () => $70fd6868680e912c$export$2cd31cfe6f6866e9);
$parcel$export(module.exports, "sum", () => $70fd6868680e912c$export$8a63f25cc62965f1);
$parcel$export(module.exports, "average", () => $70fd6868680e912c$export$cc6710ee5f037d57);
$parcel$export(module.exports, "count", () => $70fd6868680e912c$export$85b9a36db797e02b);
$parcel$export(module.exports, "aggregateFieldEqual", () => $70fd6868680e912c$export$31fa8ec66e0239ad);
$parcel$export(module.exports, "aggregateQuerySnapshotEqual", () => $70fd6868680e912c$export$104f59389a332076);
$parcel$export(module.exports, "SnapshotMetadata", () => $70fd6868680e912c$export$99d61448206ab5cd);
$parcel$export(module.exports, "DocumentSnapshot", () => $70fd6868680e912c$export$acab0e6ef25eb301);
$parcel$export(module.exports, "QueryDocumentSnapshot", () => $70fd6868680e912c$export$6d4d04e42af6b03c);
$parcel$export(module.exports, "documentSnapshotFromJSON", () => $70fd6868680e912c$export$bbac1bdeb8972634);
$parcel$export(module.exports, "QuerySnapshot", () => $70fd6868680e912c$export$8f21149d8133945c);
$parcel$export(module.exports, "querySnapshotFromJSON", () => $70fd6868680e912c$export$5bed7af38da9d026);
$parcel$export(module.exports, "snapshotEqual", () => $70fd6868680e912c$export$f243a5d948512846);
$parcel$export(module.exports, "getDoc", () => $70fd6868680e912c$export$11eb3b5ef9574821);
$parcel$export(module.exports, "getDocFromCache", () => $70fd6868680e912c$export$a58bd92642f7fb58);
$parcel$export(module.exports, "getDocFromServer", () => $70fd6868680e912c$export$35dd759aed9686b4);
$parcel$export(module.exports, "getDocs", () => $70fd6868680e912c$export$81d3477bd73c86ef);
$parcel$export(module.exports, "getDocsFromCache", () => $70fd6868680e912c$export$3fd010f18eac1dd);
$parcel$export(module.exports, "getDocsFromServer", () => $70fd6868680e912c$export$ec7d9e44f349c77b);
$parcel$export(module.exports, "setDoc", () => $70fd6868680e912c$export$5ff77ddaff3c9e12);
$parcel$export(module.exports, "executeWrite", () => $70fd6868680e912c$export$1945f8fec9dda613);
$parcel$export(module.exports, "updateDoc", () => $70fd6868680e912c$export$22d1fdd1e73faff2);
$parcel$export(module.exports, "deleteDoc", () => $70fd6868680e912c$export$a4f20481fae8f78b);
$parcel$export(module.exports, "addDoc", () => $70fd6868680e912c$export$a13890143fb1c2dd);
$parcel$export(module.exports, "onSnapshot", () => $70fd6868680e912c$export$d36370812fb26935);
$parcel$export(module.exports, "onSnapshotResume", () => $70fd6868680e912c$export$a1ef90ed3b4a87fa);
$parcel$export(module.exports, "onSnapshotsInSync", () => $70fd6868680e912c$export$9dff4f5aba83e348);
$parcel$export(module.exports, "getCountFromServer", () => $70fd6868680e912c$export$b1de1b12889d0afb);
$parcel$export(module.exports, "getAggregateFromServer", () => $70fd6868680e912c$export$a51511de2fae49b3);
$parcel$export(module.exports, "persistentSingleTabManager", () => $70fd6868680e912c$export$d5f96a3c009e86ac);
$parcel$export(module.exports, "memoryEagerGarbageCollector", () => $70fd6868680e912c$export$574728f3be606189);
$parcel$export(module.exports, "memoryLruGarbageCollector", () => $70fd6868680e912c$export$2340f88905cc0c23);
$parcel$export(module.exports, "memoryLocalCache", () => $70fd6868680e912c$export$72ef71adb739a32c);
$parcel$export(module.exports, "persistentLocalCache", () => $70fd6868680e912c$export$51b321e43d5331d5);
$parcel$export(module.exports, "persistentMultipleTabManager", () => $70fd6868680e912c$export$57e9d290b0b4dc04);
$parcel$export(module.exports, "WriteBatch", () => $70fd6868680e912c$export$d94ed661b1cfd435);
$parcel$export(module.exports, "Transaction", () => $70fd6868680e912c$export$febc5573c75cefb0);
$parcel$export(module.exports, "runTransaction", () => $70fd6868680e912c$export$3c54e006bf9c93b7);
$parcel$export(module.exports, "deleteField", () => $70fd6868680e912c$export$2bbad96c62fdba3e);
$parcel$export(module.exports, "serverTimestamp", () => $70fd6868680e912c$export$3ff8e7e00c3264b7);
$parcel$export(module.exports, "arrayUnion", () => $70fd6868680e912c$export$f62af892fd92610c);
$parcel$export(module.exports, "arrayRemove", () => $70fd6868680e912c$export$30a014203d0d7e4f);
$parcel$export(module.exports, "increment", () => $70fd6868680e912c$export$a2647aa13413c947);
$parcel$export(module.exports, "vector", () => $70fd6868680e912c$export$6074e20ba5c64bef);
$parcel$export(module.exports, "writeBatch", () => $70fd6868680e912c$export$44cd1c9d57edd9b1);
$parcel$export(module.exports, "setIndexConfiguration", () => $70fd6868680e912c$export$ff1663c0c1304f1a);
$parcel$export(module.exports, "PersistentCacheIndexManager", () => $70fd6868680e912c$export$cf4db3c220e88bd8);
$parcel$export(module.exports, "getPersistentCacheIndexManager", () => $70fd6868680e912c$export$61c6347b57bdfa06);
$parcel$export(module.exports, "enablePersistentCacheIndexAutoCreation", () => $70fd6868680e912c$export$9b2c0a7aacbcd151);
$parcel$export(module.exports, "disablePersistentCacheIndexAutoCreation", () => $70fd6868680e912c$export$5b460d5f48076743);
$parcel$export(module.exports, "deleteAllPersistentCacheIndexes", () => $70fd6868680e912c$export$72809fc2fc5083d5);
$parcel$export(module.exports, "_internalQueryToProtoQueryTarget", () => $70fd6868680e912c$export$b22c6725d8899bb4);
$parcel$export(module.exports, "_internalAggregationQueryToProtoRunAggregationQueryRequest", () => $70fd6868680e912c$export$5bcaa7c32a88925e);
$parcel$export(module.exports, "_TestingHooks", () => $70fd6868680e912c$export$3ab3ff3652492b82);

var $7xvHX = parcelRequire("7xvHX");

var $eryG9 = parcelRequire("eryG9");

var $5Z2ef = parcelRequire("5Z2ef");

var $gMVVg = parcelRequire("gMVVg");

var $cozvr = parcelRequire("cozvr");

var $4rHck = parcelRequire("4rHck");

var $6ZWSX = parcelRequire("6ZWSX");
var $70fd6868680e912c$require$Buffer = $6ZWSX.Buffer;
const $70fd6868680e912c$var$F = "@firebase/firestore", $70fd6868680e912c$var$M = "4.8.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $70fd6868680e912c$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $70fd6868680e912c$var$User.UNAUTHENTICATED = new $70fd6868680e912c$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$70fd6868680e912c$var$User.GOOGLE_CREDENTIALS = new $70fd6868680e912c$var$User("google-credentials-uid"), $70fd6868680e912c$var$User.FIRST_PARTY = new $70fd6868680e912c$var$User("first-party-uid"), $70fd6868680e912c$var$User.MOCK_USER = new $70fd6868680e912c$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $70fd6868680e912c$var$x = "11.10.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$O = new (0, $5Z2ef.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $70fd6868680e912c$var$__PRIVATE_getLogLevel() {
    return $70fd6868680e912c$var$O.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $70fd6868680e912c$export$c622e99c0ce7b1c9(e) {
    $70fd6868680e912c$var$O.setLogLevel(e);
}
function $70fd6868680e912c$var$__PRIVATE_logDebug(e, ...t) {
    if ($70fd6868680e912c$var$O.logLevel <= (0, $5Z2ef.LogLevel).DEBUG) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$O.debug(`Firestore (${$70fd6868680e912c$var$x}): ${e}`, ...n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_logError(e, ...t) {
    if ($70fd6868680e912c$var$O.logLevel <= (0, $5Z2ef.LogLevel).ERROR) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$O.error(`Firestore (${$70fd6868680e912c$var$x}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $70fd6868680e912c$export$86cd73f49cc6e0bb(e, ...t) {
    if ($70fd6868680e912c$var$O.logLevel <= (0, $5Z2ef.LogLevel).WARN) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$O.warn(`Firestore (${$70fd6868680e912c$var$x}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $70fd6868680e912c$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$fail(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $70fd6868680e912c$var$__PRIVATE__fail(e, r, n);
}
function $70fd6868680e912c$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$70fd6868680e912c$var$x}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $70fd6868680e912c$var$__PRIVATE_logError(r), new Error(r);
}
function $70fd6868680e912c$var$__PRIVATE_hardAssert(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $70fd6868680e912c$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $70fd6868680e912c$export$1d2b90eea9bba017(e, t) {
    e || $70fd6868680e912c$var$fail(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $70fd6868680e912c$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$N = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $70fd6868680e912c$export$8fada0bf726bf278 extends (0, $gMVVg.FirebaseError) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($70fd6868680e912c$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $70fd6868680e912c$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $70fd6868680e912c$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $70fd6868680e912c$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $70fd6868680e912c$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($70fd6868680e912c$var$__PRIVATE_hardAssert("string" == typeof t.accessToken, 31837, {
                l: t
            }), new $70fd6868680e912c$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(null === e || "string" == typeof e, 2055, {
            h: e
        }), new $70fd6868680e912c$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $70fd6868680e912c$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n, this.type = "FirstParty", this.user = $70fd6868680e912c$var$User.FIRST_PARTY, this.A = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ R() {
        return this.I ? this.I() : null;
    }
    get headers() {
        this.A.set("X-Goog-AuthUser", this.P);
        // Use array notation to prevent minification
        const e = this.R();
        return e && this.A.set("Authorization", e), this.T && this.A.set("X-Goog-Iam-Authorization-Token", this.T), this.A;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $70fd6868680e912c$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n;
    }
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$__PRIVATE_FirstPartyToken(this.P, this.T, this.I));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($70fd6868680e912c$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $70fd6868680e912c$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $70fd6868680e912c$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, $7xvHX._isFirebaseServerApp)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new $70fd6868680e912c$var$AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($70fd6868680e912c$var$__PRIVATE_hardAssert("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new $70fd6868680e912c$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $70fd6868680e912c$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $70fd6868680e912c$export$253bcaa5572dcc83 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $70fd6868680e912c$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(e, t) {
    let n = 0;
    for(; n < e.length && n < t.length;){
        const r = e.codePointAt(n), i = t.codePointAt(n);
        if (r !== i) {
            if (r < 128 && i < 128) // ASCII comparison
            return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r, i);
            {
                // Lazy instantiate TextEncoder
                const s = $70fd6868680e912c$var$__PRIVATE_newTextEncoder(), o = $70fd6868680e912c$var$__PRIVATE_compareByteArrays$1(s.encode($70fd6868680e912c$var$__PRIVATE_getUtf8SafeSubstring(e, n)), s.encode($70fd6868680e912c$var$__PRIVATE_getUtf8SafeSubstring(t, n)));
                // UTF-8 encode the character at index i for byte comparison.
                return 0 !== o ? o : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r, i);
            }
        }
        // Increment by 2 for surrogate pairs, 1 otherwise
        n += r > 65535 ? 2 : 1;
    }
    // Compare lengths if all characters are equal
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
function $70fd6868680e912c$var$__PRIVATE_getUtf8SafeSubstring(e, t) {
    return e.codePointAt(t) > 65535 ? e.substring(t, t + 2) : e.substring(t, t + 1);
}
function $70fd6868680e912c$var$__PRIVATE_compareByteArrays$1(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n)if (e[n] !== t[n]) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e[n], t[n]);
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
/** Helper to compare arrays using isEqual(). */ function $70fd6868680e912c$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$B = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $70fd6868680e912c$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $70fd6868680e912c$var$fail(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $70fd6868680e912c$var$fail(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $70fd6868680e912c$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $70fd6868680e912c$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $70fd6868680e912c$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $70fd6868680e912c$var$BasePath.isNumericId(e), r = $70fd6868680e912c$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $70fd6868680e912c$var$BasePath.extractNumericId(e).compare($70fd6868680e912c$var$BasePath.extractNumericId(t)) : $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $cozvr.Integer).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $70fd6868680e912c$var$ResourcePath extends $70fd6868680e912c$var$BasePath {
    construct(e, t, n) {
        return new $70fd6868680e912c$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $70fd6868680e912c$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $70fd6868680e912c$var$ResourcePath([]);
    }
}
const $70fd6868680e912c$var$L = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $70fd6868680e912c$export$b7871852b967eaf1 extends $70fd6868680e912c$var$BasePath {
    construct(e, t, n) {
        return new $70fd6868680e912c$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $70fd6868680e912c$var$L.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $70fd6868680e912c$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $70fd6868680e912c$var$B;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([
            $70fd6868680e912c$var$B
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $70fd6868680e912c$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $70fd6868680e912c$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $70fd6868680e912c$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $70fd6868680e912c$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $70fd6868680e912c$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(e) {
    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(e) {
    if ($70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $70fd6868680e912c$var$__PRIVATE_isPlainObject(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $70fd6868680e912c$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $70fd6868680e912c$var$fail(12329, {
        type: typeof e
    });
}
function $70fd6868680e912c$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $70fd6868680e912c$var$__PRIVATE_valueDescription(e);
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $70fd6868680e912c$var$property(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json A JSON object to validate.
 * @param scheme a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_validateJSON(e, t) {
    if (!$70fd6868680e912c$var$__PRIVATE_isPlainObject(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const o = e[r];
        if (i && typeof o !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && o !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $70fd6868680e912c$var$k = -62135596800, $70fd6868680e912c$var$q = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $70fd6868680e912c$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $70fd6868680e912c$var$q);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $70fd6868680e912c$var$k) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $70fd6868680e912c$var$q;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $70fd6868680e912c$export$d9bcbd5e1ff81430._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($70fd6868680e912c$var$__PRIVATE_validateJSON(e, $70fd6868680e912c$export$d9bcbd5e1ff81430._jsonSchema)) return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $70fd6868680e912c$var$k;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$70fd6868680e912c$export$d9bcbd5e1ff81430._jsonSchemaVersion = "firestore/timestamp/1.0", $70fd6868680e912c$export$d9bcbd5e1ff81430._jsonSchema = {
    type: $70fd6868680e912c$var$property("string", $70fd6868680e912c$export$d9bcbd5e1ff81430._jsonSchemaVersion),
    seconds: $70fd6868680e912c$var$property("number"),
    nanoseconds: $70fd6868680e912c$var$property("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $70fd6868680e912c$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $70fd6868680e912c$var$SnapshotVersion(e);
    }
    static min() {
        return new $70fd6868680e912c$var$SnapshotVersion(new $70fd6868680e912c$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $70fd6868680e912c$var$SnapshotVersion(new $70fd6868680e912c$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $70fd6868680e912c$var$Q = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $70fd6868680e912c$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $70fd6868680e912c$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $70fd6868680e912c$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $70fd6868680e912c$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $70fd6868680e912c$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $70fd6868680e912c$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $70fd6868680e912c$var$IndexState(0, $70fd6868680e912c$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $70fd6868680e912c$export$d9bcbd5e1ff81430(n + 1, 0) : new $70fd6868680e912c$export$d9bcbd5e1ff81430(n, r));
    return new $70fd6868680e912c$var$IndexOffset(i, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $70fd6868680e912c$var$IndexOffset(e.readTime, e.key, $70fd6868680e912c$var$Q);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $70fd6868680e912c$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), $70fd6868680e912c$var$Q);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$SnapshotVersion.max(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), $70fd6868680e912c$var$Q);
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$$ = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $70fd6868680e912c$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $70fd6868680e912c$var$N.FAILED_PRECONDITION || e.message !== $70fd6868680e912c$var$$) throw e;
    $70fd6868680e912c$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $70fd6868680e912c$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $70fd6868680e912c$var$fail(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $70fd6868680e912c$var$PersistencePromise ? t : $70fd6868680e912c$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $70fd6868680e912c$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $70fd6868680e912c$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $70fd6868680e912c$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $70fd6868680e912c$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $70fd6868680e912c$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $70fd6868680e912c$var$U = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.S = new $70fd6868680e912c$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.S.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.S.reject(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.S.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.S.reject(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get D() {
        return this.S.promise;
    }
    abort(e) {
        e && this.S.reject(e), this.aborted || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    v() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $70fd6868680e912c$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "Removing database:", e);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest((0, $gMVVg.getGlobal)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static C() {
        if (!(0, $gMVVg.isIndexedDBAvailable)()) return !1;
        if ($70fd6868680e912c$var$__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $gMVVg.getUA)(), t = $70fd6868680e912c$var$__PRIVATE_SimpleDb.M(e), n = 0 < t && t < 10, r = $70fd6868680e912c$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        var e;
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static N(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static M(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.B = n, this.L = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $70fd6868680e912c$var$__PRIVATE_SimpleDb.M((0, $gMVVg.getUA)()) && $70fd6868680e912c$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async k(e) {
        return this.db || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                if (null !== this.L && this.L !== e.oldVersion) // This thrown error will get passed to the `onerror` callback
                // registered above, and will then be propagated correctly.
                throw new Error(`refusing to open IndexedDB database due to potential corruption of the IndexedDB database data; this corruption could be caused by clicking the "clear site data" button in a web browser; try reloading the web page to re-initialize the IndexedDB database: lastClosedDbVersion=${this.L}, event.oldVersion=${e.oldVersion}, event.newVersion=${e.newVersion}, db.version=${t.version}`);
                this.B.q(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "Database upgrade to version " + this.version + " complete");
                });
            };
        }), this.db.addEventListener("close", (e)=>{
            const t = e.target;
            this.L = t.version;
        }, {
            passive: !0
        })), this.db.addEventListener("versionchange", (e)=>{
            var t;
            // Notify the listener if another tab attempted to delete the IndexedDb
            // database, such as by calling clearIndexedDbPersistence().
            null === e.newVersion && ($70fd6868680e912c$export$86cd73f49cc6e0bb('Received "versionchange" event with newVersion===null; notifying the registered DatabaseDeletedListener, if any'), null === (t = this.databaseDeletedListener) || void 0 === t || t.call(this));
        }, {
            passive: !0
        }), this.db;
    }
    setDatabaseDeletedListener(e) {
        if (this.databaseDeletedListener) throw new Error("setDatabaseDeletedListener() may only be called once, and it has already been called");
        this.databaseDeletedListener = e;
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.k(e);
                const t = $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.v(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $70fd6868680e912c$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.D, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $70fd6868680e912c$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $70fd6868680e912c$var$__PRIVATE_IterationController {
    constructor(e){
        this.$ = e, this.U = !1, this.K = null;
    }
    get isDone() {
        return this.U;
    }
    get W() {
        return this.K;
    }
    set cursor(e) {
        this.$ = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.U = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ G(e) {
        this.K = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.$.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError extends $70fd6868680e912c$export$8fada0bf726bf278 {
    constructor(e, t){
        super($70fd6868680e912c$var$N.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $70fd6868680e912c$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "ADD", this.store.name, e, e);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "DELETE", this.store.name, e);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "COUNT", this.store.name);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.count());
    }
    j(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.J(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ H(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $70fd6868680e912c$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    Y(e, t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$U, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.Z = !1;
        const r = this.cursor(n);
        return this.J(r, (e, t, n)=>n.delete());
    }
    X(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.J(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ ee(e) {
        const t = this.cursor({});
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    J(e, t) {
        const n = [];
        return new $70fd6868680e912c$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $70fd6868680e912c$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $70fd6868680e912c$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $70fd6868680e912c$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.W ? i.continue() : i.continue(s.W);
            };
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.Z ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $70fd6868680e912c$var$__PRIVATE_wrapRequest(e) {
    return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $70fd6868680e912c$var$K = !1;
function $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_SimpleDb.M((0, $gMVVg.getUA)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $70fd6868680e912c$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $70fd6868680e912c$var$K || ($70fd6868680e912c$var$K = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $70fd6868680e912c$var$W = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $70fd6868680e912c$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.te = t, this.task = null;
    }
    start() {
        this.ne(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    ne(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$W, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.te.re();
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$W, `Documents written: ${e}`);
            } catch (e) {
                $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$W, "Ignoring IndexedDB error during index backfill: ", e) : await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.ne(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $70fd6868680e912c$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async re(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.ie(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ ie(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $70fd6868680e912c$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$W, `Processing collection: ${t}`), this.se(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ se(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.oe(r, n)).next((n)=>($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$W, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ oe(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $70fd6868680e912c$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $70fd6868680e912c$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this._e(e), this.ae = (e)=>t.writeSequenceNumber(e));
    }
    _e(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ae && this.ae(e), e;
    }
}
$70fd6868680e912c$var$__PRIVATE_ListenSequence.ue = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $70fd6868680e912c$var$G = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $70fd6868680e912c$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $70fd6868680e912c$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$70fd6868680e912c$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$z = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $70fd6868680e912c$var$__PRIVATE_encodeSeparator(t)), t = $70fd6868680e912c$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $70fd6868680e912c$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $70fd6868680e912c$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $70fd6868680e912c$var$z:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $70fd6868680e912c$var$__PRIVATE_encodeSeparator(e) {
    return e + $70fd6868680e912c$var$z + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(t >= 2, 64408, {
        path: e
    }), 2 === t) return $70fd6868680e912c$var$__PRIVATE_hardAssert(e.charAt(0) === $70fd6868680e912c$var$z && "" === e.charAt(1), 56145, {
        path: e
    }), $70fd6868680e912c$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($70fd6868680e912c$var$z, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $70fd6868680e912c$var$fail(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $70fd6868680e912c$var$fail(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $70fd6868680e912c$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$j = "remoteDocuments", $70fd6868680e912c$var$J = "owner", $70fd6868680e912c$var$H = "owner", $70fd6868680e912c$var$Y = "mutationQueues", $70fd6868680e912c$var$Z = "userId", $70fd6868680e912c$var$X = "mutations", $70fd6868680e912c$var$ee = "batchId", $70fd6868680e912c$var$te = "userMutationsIndex", $70fd6868680e912c$var$ne = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $70fd6868680e912c$var$re = {}, $70fd6868680e912c$var$ie = "documentMutations", $70fd6868680e912c$var$se = "remoteDocumentsV14", $70fd6868680e912c$var$oe = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $70fd6868680e912c$var$_e = "documentKeyIndex", $70fd6868680e912c$var$ae = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $70fd6868680e912c$var$ue = "collectionGroupIndex", $70fd6868680e912c$var$ce = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $70fd6868680e912c$var$le = "remoteDocumentGlobal", $70fd6868680e912c$var$he = "remoteDocumentGlobalKey", $70fd6868680e912c$var$Pe = "targets", $70fd6868680e912c$var$Te = "queryTargetsIndex", $70fd6868680e912c$var$Ie = [
    "canonicalId",
    "targetId"
], $70fd6868680e912c$var$de = "targetDocuments", $70fd6868680e912c$var$Ee = [
    "targetId",
    "path"
], $70fd6868680e912c$var$Ae = "documentTargetsIndex", $70fd6868680e912c$var$Re = [
    "path",
    "targetId"
], $70fd6868680e912c$var$Ve = "targetGlobalKey", $70fd6868680e912c$var$me = "targetGlobal", $70fd6868680e912c$var$fe = "collectionParents", $70fd6868680e912c$var$ge = [
    "collectionId",
    "parent"
], $70fd6868680e912c$var$pe = "clientMetadata", $70fd6868680e912c$var$ye = "clientId", $70fd6868680e912c$var$we = "bundles", $70fd6868680e912c$var$Se = "bundleId", $70fd6868680e912c$var$be = "namedQueries", $70fd6868680e912c$var$De = "name", $70fd6868680e912c$var$ve = "indexConfiguration", $70fd6868680e912c$var$Ce = "indexId", $70fd6868680e912c$var$Fe = "collectionGroupIndex", $70fd6868680e912c$var$Me = "collectionGroup", $70fd6868680e912c$var$xe = "indexState", $70fd6868680e912c$var$Oe = [
    "indexId",
    "uid"
], $70fd6868680e912c$var$Ne = "sequenceNumberIndex", $70fd6868680e912c$var$Be = [
    "uid",
    "sequenceNumber"
], $70fd6868680e912c$var$Le = "indexEntries", $70fd6868680e912c$var$ke = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $70fd6868680e912c$var$qe = "documentKeyIndex", $70fd6868680e912c$var$Qe = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $70fd6868680e912c$var$$e = "documentOverlays", $70fd6868680e912c$var$Ue = [
    "userId",
    "collectionPath",
    "documentId"
], $70fd6868680e912c$var$Ke = "collectionPathOverlayIndex", $70fd6868680e912c$var$We = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $70fd6868680e912c$var$Ge = "collectionGroupOverlayIndex", $70fd6868680e912c$var$ze = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $70fd6868680e912c$var$je = "globals", $70fd6868680e912c$var$Je = "name", $70fd6868680e912c$var$He = [
    $70fd6868680e912c$var$Y,
    $70fd6868680e912c$var$X,
    $70fd6868680e912c$var$ie,
    $70fd6868680e912c$var$j,
    $70fd6868680e912c$var$Pe,
    $70fd6868680e912c$var$J,
    $70fd6868680e912c$var$me,
    $70fd6868680e912c$var$de,
    $70fd6868680e912c$var$pe,
    $70fd6868680e912c$var$le,
    $70fd6868680e912c$var$fe,
    $70fd6868680e912c$var$we,
    $70fd6868680e912c$var$be
], $70fd6868680e912c$var$Ye = [
    ...$70fd6868680e912c$var$He,
    $70fd6868680e912c$var$$e
], $70fd6868680e912c$var$Ze = [
    $70fd6868680e912c$var$Y,
    $70fd6868680e912c$var$X,
    $70fd6868680e912c$var$ie,
    $70fd6868680e912c$var$se,
    $70fd6868680e912c$var$Pe,
    $70fd6868680e912c$var$J,
    $70fd6868680e912c$var$me,
    $70fd6868680e912c$var$de,
    $70fd6868680e912c$var$pe,
    $70fd6868680e912c$var$le,
    $70fd6868680e912c$var$fe,
    $70fd6868680e912c$var$we,
    $70fd6868680e912c$var$be,
    $70fd6868680e912c$var$$e
], $70fd6868680e912c$var$Xe = $70fd6868680e912c$var$Ze, $70fd6868680e912c$var$et = [
    ...$70fd6868680e912c$var$Xe,
    $70fd6868680e912c$var$ve,
    $70fd6868680e912c$var$xe,
    $70fd6868680e912c$var$Le
], $70fd6868680e912c$var$tt = $70fd6868680e912c$var$et, $70fd6868680e912c$var$nt = [
    ...$70fd6868680e912c$var$et,
    $70fd6868680e912c$var$je
], $70fd6868680e912c$var$rt = $70fd6868680e912c$var$nt;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction extends $70fd6868680e912c$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.ce = e, this.currentSequenceNumber = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_getStore(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return $70fd6868680e912c$var$__PRIVATE_SimpleDb.N(n.ce, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $70fd6868680e912c$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $70fd6868680e912c$var$__PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $70fd6868680e912c$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $70fd6868680e912c$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $70fd6868680e912c$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $70fd6868680e912c$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $70fd6868680e912c$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $70fd6868680e912c$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $70fd6868680e912c$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $70fd6868680e912c$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $70fd6868680e912c$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $70fd6868680e912c$var$LLRBNode.RED, this.left = null != r ? r : $70fd6868680e912c$var$LLRBNode.EMPTY, this.right = null != i ? i : $70fd6868680e912c$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $70fd6868680e912c$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $70fd6868680e912c$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $70fd6868680e912c$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $70fd6868680e912c$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $70fd6868680e912c$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $70fd6868680e912c$var$fail(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $70fd6868680e912c$var$fail(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $70fd6868680e912c$var$fail(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$70fd6868680e912c$var$LLRBNode.EMPTY = null, $70fd6868680e912c$var$LLRBNode.RED = !0, $70fd6868680e912c$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$70fd6868680e912c$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $70fd6868680e912c$var$fail(57766);
    }
    get value() {
        throw $70fd6868680e912c$var$fail(16141);
    }
    get color() {
        throw $70fd6868680e912c$var$fail(16727);
    }
    get left() {
        throw $70fd6868680e912c$var$fail(29726);
    }
    get right() {
        throw $70fd6868680e912c$var$fail(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $70fd6868680e912c$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $70fd6868680e912c$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $70fd6868680e912c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $70fd6868680e912c$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $70fd6868680e912c$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $70fd6868680e912c$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $70fd6868680e912c$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $70fd6868680e912c$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $70fd6868680e912c$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($70fd6868680e912c$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $70fd6868680e912c$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $70fd6868680e912c$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $70fd6868680e912c$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $70fd6868680e912c$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $70fd6868680e912c$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $70fd6868680e912c$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $70fd6868680e912c$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $70fd6868680e912c$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $70fd6868680e912c$export$67460cdabfa21253("");
const $70fd6868680e912c$var$it = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $70fd6868680e912c$var$it.exec(e);
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e) : $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $70fd6868680e912c$var$st = "server_timestamp", $70fd6868680e912c$var$ot = "__type__", $70fd6868680e912c$var$_t = "__previous_value__", $70fd6868680e912c$var$at = "__local_write_time__";
function $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {})[$70fd6868680e912c$var$ot]) || void 0 === n ? void 0 : n.stringValue) === $70fd6868680e912c$var$st;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$70fd6868680e912c$var$_t];
    return $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(t) ? $70fd6868680e912c$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$70fd6868680e912c$var$at].timestampValue);
    return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a, u){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a, this.isUsingEmulator = u;
    }
}
/** The default database name for a project. */ const $70fd6868680e912c$var$ut = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $70fd6868680e912c$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || $70fd6868680e912c$var$ut;
    }
    static empty() {
        return new $70fd6868680e912c$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return this.database === $70fd6868680e912c$var$ut;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$ct = "__type__", $70fd6868680e912c$var$lt = "__max__", $70fd6868680e912c$var$ht = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $70fd6868680e912c$var$lt
            }
        }
    }
}, $70fd6868680e912c$var$Pt = "__vector__", $70fd6868680e912c$var$Tt = "value", $70fd6868680e912c$var$It = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $70fd6868680e912c$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $70fd6868680e912c$var$fail(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $70fd6868680e912c$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $70fd6868680e912c$var$__PRIVATE_typeOrder(e);
    if (n !== $70fd6868680e912c$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e).isEqual($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($70fd6868680e912c$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $70fd6868680e912c$var$__PRIVATE_isNegativeZero(n) === $70fd6868680e912c$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $70fd6868680e912c$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($70fd6868680e912c$var$__PRIVATE_objectSize(n) !== $70fd6868680e912c$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$70fd6868680e912c$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $70fd6868680e912c$var$fail(52216, {
                left: e
            });
    }
}
function $70fd6868680e912c$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t));
}
function $70fd6868680e912c$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $70fd6868680e912c$var$__PRIVATE_typeOrder(e), r = $70fd6868680e912c$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareTimestamps($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e), $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e), r = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_primitiveComparator($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.latitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.longitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                var n, r, i, s;
                const o = e.fields || {}, _ = t.fields || {}, a = null === (n = o[$70fd6868680e912c$var$Tt]) || void 0 === n ? void 0 : n.arrayValue, u = null === (r = _[$70fd6868680e912c$var$Tt]) || void 0 === r ? void 0 : r.arrayValue, c = $70fd6868680e912c$var$__PRIVATE_primitiveComparator((null === (i = null == a ? void 0 : a.values) || void 0 === i ? void 0 : i.length) || 0, (null === (s = null == u ? void 0 : u.values) || void 0 === s ? void 0 : s.length) || 0);
                if (0 !== c) return c;
                return $70fd6868680e912c$var$__PRIVATE_compareArrays(a, u);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $70fd6868680e912c$var$ht.mapValue && t === $70fd6868680e912c$var$ht.mapValue) return 0;
                if (e === $70fd6868680e912c$var$ht.mapValue) return 1;
                if (t === $70fd6868680e912c$var$ht.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $70fd6868680e912c$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $70fd6868680e912c$var$fail(23264, {
                le: n
            });
    }
}
function $70fd6868680e912c$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, t);
    const n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e), r = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(t), i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $70fd6868680e912c$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $70fd6868680e912c$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $70fd6868680e912c$var$canonicalId(e) {
    return $70fd6868680e912c$var$__PRIVATE_canonifyValue(e);
}
function $70fd6868680e912c$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $70fd6868680e912c$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $70fd6868680e912c$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$70fd6868680e912c$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $70fd6868680e912c$var$fail(61005, {
        value: e
    });
}
function $70fd6868680e912c$var$__PRIVATE_estimateByteSize(e) {
    switch($70fd6868680e912c$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $70fd6868680e912c$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $70fd6868680e912c$var$fail(13486, {
                value: e
            });
    }
}
function $70fd6868680e912c$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $70fd6868680e912c$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $70fd6868680e912c$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $70fd6868680e912c$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $70fd6868680e912c$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $70fd6868680e912c$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) {
    var t, n;
    return (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {})[$70fd6868680e912c$var$ct]) || void 0 === n ? void 0 : n.stringValue) === $70fd6868680e912c$var$Pt;
}
/** Creates a deep copy of `source`. */ function $70fd6868680e912c$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $70fd6868680e912c$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $70fd6868680e912c$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $70fd6868680e912c$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $70fd6868680e912c$var$lt;
}
const $70fd6868680e912c$var$dt = {
    mapValue: {
        fields: {
            [$70fd6868680e912c$var$ct]: {
                stringValue: $70fd6868680e912c$var$Pt
            },
            [$70fd6868680e912c$var$Tt]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $70fd6868680e912c$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $70fd6868680e912c$var$It : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $70fd6868680e912c$var$__PRIVATE_refValue($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? $70fd6868680e912c$var$dt : {
        mapValue: {}
    } : $70fd6868680e912c$var$fail(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $70fd6868680e912c$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $70fd6868680e912c$var$__PRIVATE_refValue($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $70fd6868680e912c$var$dt : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $70fd6868680e912c$var$ht : $70fd6868680e912c$var$fail(61959, {
        value: e
    });
}
function $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $70fd6868680e912c$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $70fd6868680e912c$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $70fd6868680e912c$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$70fd6868680e912c$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $70fd6868680e912c$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $70fd6868680e912c$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $70fd6868680e912c$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $70fd6868680e912c$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $70fd6868680e912c$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $70fd6868680e912c$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $70fd6868680e912c$var$ObjectValue($70fd6868680e912c$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $70fd6868680e912c$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $70fd6868680e912c$var$forEach(e.fields, (e, n)=>{
        const r = new $70fd6868680e912c$export$b7871852b967eaf1([
            e
        ]);
        if ($70fd6868680e912c$var$__PRIVATE_isMapValue(n)) {
            const e = $70fd6868680e912c$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $70fd6868680e912c$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $70fd6868680e912c$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $70fd6868680e912c$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $70fd6868680e912c$var$SnapshotVersion.min(), /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $70fd6868680e912c$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $70fd6868680e912c$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $70fd6868680e912c$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $70fd6868680e912c$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $70fd6868680e912c$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $70fd6868680e912c$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $70fd6868680e912c$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $70fd6868680e912c$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $70fd6868680e912c$export$afc2e57c475b7810.comparator($70fd6868680e912c$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $70fd6868680e912c$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $70fd6868680e912c$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$70fd6868680e912c$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $70fd6868680e912c$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Filter {
}
class $70fd6868680e912c$var$FieldFilter extends $70fd6868680e912c$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $70fd6868680e912c$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $70fd6868680e912c$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $70fd6868680e912c$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $70fd6868680e912c$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_KeyFieldInFilter(e, n) : new $70fd6868680e912c$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($70fd6868680e912c$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $70fd6868680e912c$var$__PRIVATE_typeOrder(this.value) === $70fd6868680e912c$var$__PRIVATE_typeOrder(t) && this.matchesComparison($70fd6868680e912c$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $70fd6868680e912c$var$fail(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $70fd6868680e912c$var$CompositeFilter extends $70fd6868680e912c$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.he = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $70fd6868680e912c$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.he || (this.he = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.he;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e) && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $70fd6868680e912c$var$CompositeFilter) return !1;
    return !0;
}
function $70fd6868680e912c$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $70fd6868680e912c$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $70fd6868680e912c$var$canonicalId(e.value);
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $70fd6868680e912c$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $70fd6868680e912c$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $70fd6868680e912c$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $70fd6868680e912c$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $70fd6868680e912c$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $70fd6868680e912c$var$fail(19439);
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $70fd6868680e912c$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $70fd6868680e912c$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$70fd6868680e912c$var$canonicalId(e.value)}`;
    }(e) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($70fd6868680e912c$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $70fd6868680e912c$var$__PRIVATE_KeyFieldFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $70fd6868680e912c$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $70fd6868680e912c$var$__PRIVATE_KeyFieldInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $70fd6868680e912c$var$__PRIVATE_KeyFieldNotInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e)=>$70fd6868680e912c$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $70fd6868680e912c$var$__PRIVATE_ArrayContainsFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $70fd6868680e912c$var$isArray(t) && $70fd6868680e912c$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $70fd6868680e912c$var$__PRIVATE_InFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $70fd6868680e912c$var$__PRIVATE_NotInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $70fd6868680e912c$var$__PRIVATE_ArrayContainsAnyFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$70fd6868680e912c$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.Pe = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $70fd6868680e912c$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $70fd6868680e912c$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $70fd6868680e912c$var$__PRIVATE_canonifyTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (null === t.Pe) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), t.Pe = e;
    }
    return t.Pe;
}
function $70fd6868680e912c$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$70fd6868680e912c$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$70fd6868680e912c$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$70fd6868680e912c$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $70fd6868680e912c$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $70fd6868680e912c$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $70fd6868680e912c$var$It, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $70fd6868680e912c$var$It, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $70fd6868680e912c$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $70fd6868680e912c$var$It;
        }
        $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $70fd6868680e912c$var$ht, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $70fd6868680e912c$var$ht, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $70fd6868680e912c$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $70fd6868680e912c$var$ht;
        }
        $70fd6868680e912c$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $70fd6868680e912c$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Te = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.de = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $70fd6868680e912c$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $70fd6868680e912c$var$__PRIVATE_newQueryForPath(e) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (null === t.Te) {
        t.Te = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.Te.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.Te.push(new $70fd6868680e912c$var$OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($70fd6868680e912c$export$b7871852b967eaf1.keyField().canonicalString()) || t.Te.push(new $70fd6868680e912c$var$OrderBy($70fd6868680e912c$export$b7871852b967eaf1.keyField(), n));
    }
    return t.Te;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $70fd6868680e912c$var$__PRIVATE_queryToTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.Ie || (t.Ie = $70fd6868680e912c$var$__PRIVATE__queryToTarget(t, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))), t.Ie;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.de || // Do not include implicit order-bys for aggregate queries.
    (t.de = $70fd6868680e912c$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.de;
}
function $70fd6868680e912c$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $70fd6868680e912c$var$OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $70fd6868680e912c$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $70fd6868680e912c$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_queryEquals(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_targetEquals($70fd6868680e912c$var$__PRIVATE_queryToTarget(e), $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $70fd6868680e912c$var$__PRIVATE_canonifyQuery(e) {
    return `${$70fd6868680e912c$var$__PRIVATE_canonifyTarget($70fd6868680e912c$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $70fd6868680e912c$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($70fd6868680e912c$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $70fd6868680e912c$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $70fd6868680e912c$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e)){
            const e = $70fd6868680e912c$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $70fd6868680e912c$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $70fd6868680e912c$var$__PRIVATE_valueCompare(r, i) : $70fd6868680e912c$var$fail(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $70fd6868680e912c$var$fail(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $70fd6868680e912c$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $70fd6868680e912c$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $70fd6868680e912c$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Et = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap() {
    return $70fd6868680e912c$var$Et;
}
const $70fd6868680e912c$var$At = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$documentMap(...e) {
    let t = $70fd6868680e912c$var$At;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $70fd6868680e912c$var$At;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $70fd6868680e912c$var$__PRIVATE_newOverlayMap() {
    return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
}
function $70fd6868680e912c$var$__PRIVATE_newMutationMap() {
    return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
}
function $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap() {
    return new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $70fd6868680e912c$var$Rt = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
const $70fd6868680e912c$var$Vt = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$__PRIVATE_documentKeySet(...e) {
    let t = $70fd6868680e912c$var$Vt;
    for (const n of e)t = t.add(n);
    return t;
}
const $70fd6868680e912c$var$mt = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
function $70fd6868680e912c$var$__PRIVATE_targetIdSet() {
    return $70fd6868680e912c$var$mt;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $70fd6868680e912c$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $70fd6868680e912c$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $70fd6868680e912c$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $70fd6868680e912c$var$toNumber(e, t) {
    return $70fd6868680e912c$var$isSafeInteger(t) ? $70fd6868680e912c$var$__PRIVATE_toInteger(t) : $70fd6868680e912c$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $70fd6868680e912c$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$70fd6868680e912c$var$ot]: {
                    stringValue: $70fd6868680e912c$var$st
                },
                [$70fd6868680e912c$var$at]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(t) && (t = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$70fd6868680e912c$var$_t] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $70fd6868680e912c$var$asNumber(n) + $70fd6868680e912c$var$asNumber(e.Ee);
        return $70fd6868680e912c$var$isInteger(n) && $70fd6868680e912c$var$isInteger(e.Ee) ? $70fd6868680e912c$var$__PRIVATE_toInteger(r) : $70fd6868680e912c$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $70fd6868680e912c$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform extends $70fd6868680e912c$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Ee = t;
    }
}
function $70fd6868680e912c$var$asNumber(e) {
    return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $70fd6868680e912c$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $70fd6868680e912c$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_arrayEquals(e.elements, t.elements, $70fd6868680e912c$var$__PRIVATE_valueEquals) : e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation ? $70fd6868680e912c$var$__PRIVATE_valueEquals(e.Ee, t.Ee) : e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform && t instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $70fd6868680e912c$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $70fd6868680e912c$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $70fd6868680e912c$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $70fd6868680e912c$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $70fd6868680e912c$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $70fd6868680e912c$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e.key, $70fd6868680e912c$var$Precondition.none()) : new $70fd6868680e912c$var$__PRIVATE_SetMutation(e.key, e.data, $70fd6868680e912c$var$Precondition.none());
    {
        const n = e.data, r = $70fd6868680e912c$var$ObjectValue.empty();
        let i = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e.key, r, new $70fd6868680e912c$var$FieldMask(i.toArray()), $70fd6868680e912c$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($70fd6868680e912c$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $70fd6868680e912c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $70fd6868680e912c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($70fd6868680e912c$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $70fd6868680e912c$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $70fd6868680e912c$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$70fd6868680e912c$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $70fd6868680e912c$var$__PRIVATE_SetMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_PatchMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $70fd6868680e912c$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $70fd6868680e912c$var$__PRIVATE_hardAssert(e.length === n.length, 32656, {
        Ae: n.length,
        Re: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $70fd6868680e912c$var$__PRIVATE_DeleteMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_VerifyMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $70fd6868680e912c$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $70fd6868680e912c$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $70fd6868680e912c$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($70fd6868680e912c$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t)) && $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $70fd6868680e912c$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(e.mutations.length === n.length, 58842, {
            Ve: e.mutations.length,
            me: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $70fd6868680e912c$var$Rt;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $70fd6868680e912c$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $70fd6868680e912c$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $70fd6868680e912c$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $70fd6868680e912c$var$ft, $70fd6868680e912c$var$gt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $70fd6868680e912c$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $70fd6868680e912c$var$N.OK:
            return $70fd6868680e912c$var$fail(64938);
        case $70fd6868680e912c$var$N.CANCELLED:
        case $70fd6868680e912c$var$N.UNKNOWN:
        case $70fd6868680e912c$var$N.DEADLINE_EXCEEDED:
        case $70fd6868680e912c$var$N.RESOURCE_EXHAUSTED:
        case $70fd6868680e912c$var$N.INTERNAL:
        case $70fd6868680e912c$var$N.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $70fd6868680e912c$var$N.UNAUTHENTICATED:
            return !1;
        case $70fd6868680e912c$var$N.INVALID_ARGUMENT:
        case $70fd6868680e912c$var$N.NOT_FOUND:
        case $70fd6868680e912c$var$N.ALREADY_EXISTS:
        case $70fd6868680e912c$var$N.PERMISSION_DENIED:
        case $70fd6868680e912c$var$N.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $70fd6868680e912c$var$N.ABORTED:
        case $70fd6868680e912c$var$N.OUT_OF_RANGE:
        case $70fd6868680e912c$var$N.UNIMPLEMENTED:
        case $70fd6868680e912c$var$N.DATA_LOSS:
            return !0;
        default:
            return $70fd6868680e912c$var$fail(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $70fd6868680e912c$var$__PRIVATE_logError("GRPC error has no .code"), $70fd6868680e912c$var$N.UNKNOWN;
    switch(e){
        case $70fd6868680e912c$var$ft.OK:
            return $70fd6868680e912c$var$N.OK;
        case $70fd6868680e912c$var$ft.CANCELLED:
            return $70fd6868680e912c$var$N.CANCELLED;
        case $70fd6868680e912c$var$ft.UNKNOWN:
            return $70fd6868680e912c$var$N.UNKNOWN;
        case $70fd6868680e912c$var$ft.DEADLINE_EXCEEDED:
            return $70fd6868680e912c$var$N.DEADLINE_EXCEEDED;
        case $70fd6868680e912c$var$ft.RESOURCE_EXHAUSTED:
            return $70fd6868680e912c$var$N.RESOURCE_EXHAUSTED;
        case $70fd6868680e912c$var$ft.INTERNAL:
            return $70fd6868680e912c$var$N.INTERNAL;
        case $70fd6868680e912c$var$ft.UNAVAILABLE:
            return $70fd6868680e912c$var$N.UNAVAILABLE;
        case $70fd6868680e912c$var$ft.UNAUTHENTICATED:
            return $70fd6868680e912c$var$N.UNAUTHENTICATED;
        case $70fd6868680e912c$var$ft.INVALID_ARGUMENT:
            return $70fd6868680e912c$var$N.INVALID_ARGUMENT;
        case $70fd6868680e912c$var$ft.NOT_FOUND:
            return $70fd6868680e912c$var$N.NOT_FOUND;
        case $70fd6868680e912c$var$ft.ALREADY_EXISTS:
            return $70fd6868680e912c$var$N.ALREADY_EXISTS;
        case $70fd6868680e912c$var$ft.PERMISSION_DENIED:
            return $70fd6868680e912c$var$N.PERMISSION_DENIED;
        case $70fd6868680e912c$var$ft.FAILED_PRECONDITION:
            return $70fd6868680e912c$var$N.FAILED_PRECONDITION;
        case $70fd6868680e912c$var$ft.ABORTED:
            return $70fd6868680e912c$var$N.ABORTED;
        case $70fd6868680e912c$var$ft.OUT_OF_RANGE:
            return $70fd6868680e912c$var$N.OUT_OF_RANGE;
        case $70fd6868680e912c$var$ft.UNIMPLEMENTED:
            return $70fd6868680e912c$var$N.UNIMPLEMENTED;
        case $70fd6868680e912c$var$ft.DATA_LOSS:
            return $70fd6868680e912c$var$N.DATA_LOSS;
        default:
            return $70fd6868680e912c$var$fail(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($70fd6868680e912c$var$gt = $70fd6868680e912c$var$ft || ($70fd6868680e912c$var$ft = {}))[$70fd6868680e912c$var$gt.OK = 0] = "OK", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.CANCELLED = 1] = "CANCELLED", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.UNKNOWN = 2] = "UNKNOWN", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.NOT_FOUND = 5] = "NOT_FOUND", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.ABORTED = 10] = "ABORTED", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.INTERNAL = 13] = "INTERNAL", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.UNAVAILABLE = 14] = "UNAVAILABLE", $70fd6868680e912c$var$gt[$70fd6868680e912c$var$gt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $70fd6868680e912c$var$pt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$yt = new (0, $cozvr.Integer)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $cozvr.Md5);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $70fd6868680e912c$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $cozvr.Integer)([
            n,
            r
        ], 0),
        new (0, $cozvr.Integer)([
            i,
            s
        ], 0)
    ];
}
class $70fd6868680e912c$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.fe = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.ge = (0, $cozvr.Integer).fromNumber(this.fe);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    pe(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $cozvr.Integer).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($70fd6868680e912c$var$yt) && (r = new (0, $cozvr.Integer)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.ge).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    ye(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.fe) return !1;
        const t = $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $70fd6868680e912c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.pe(n, r, e);
            if (!this.ye(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $70fd6868680e912c$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.fe) return;
        const t = $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $70fd6868680e912c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.pe(n, r, e);
            this.we(t);
        }
    }
    we(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $70fd6868680e912c$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $70fd6868680e912c$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $70fd6868680e912c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $70fd6868680e912c$var$RemoteEvent($70fd6868680e912c$var$SnapshotVersion.min(), r, new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $70fd6868680e912c$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $70fd6868680e912c$var$TargetChange(n, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet(), $70fd6868680e912c$var$__PRIVATE_documentKeySet(), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Se = e, this.removedTargetIds = t, this.key = n, this.be = r;
    }
}
class $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.De = t;
    }
}
class $70fd6868680e912c$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $70fd6868680e912c$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ve = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Ce = $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Fe = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.Me = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.xe = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.Me;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Fe;
    }
    /** Whether this target has pending target adds or target removes. */ get Oe() {
        return 0 !== this.ve;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Ne() {
        return this.xe;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Be(e) {
        e.approximateByteSize() > 0 && (this.xe = !0, this.Fe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ Le() {
        let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), t = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), n = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.Ce.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $70fd6868680e912c$var$fail(38017, {
                        changeType: i
                    });
            }
        }), new $70fd6868680e912c$var$TargetChange(this.Fe, this.Me, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ ke() {
        this.xe = !1, this.Ce = $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap();
    }
    qe(e, t) {
        this.xe = !0, this.Ce = this.Ce.insert(e, t);
    }
    Qe(e) {
        this.xe = !0, this.Ce = this.Ce.remove(e);
    }
    $e() {
        this.ve += 1;
    }
    Ue() {
        this.ve -= 1, $70fd6868680e912c$var$__PRIVATE_hardAssert(this.ve >= 0, 3241, {
            ve: this.ve
        });
    }
    Ke() {
        this.xe = !0, this.Me = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $70fd6868680e912c$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.We = e, /** The internal state of all tracked targets. */ this.Ge = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ze = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), this.je = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.Je = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.He = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ye(e) {
        for (const t of e.Se)e.be && e.be.isFoundDocument() ? this.Ze(t, e.be) : this.Xe(t, e.key, e.be);
        for (const t of e.removedTargetIds)this.Xe(t, e.key, e.be);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ et(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.tt(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.nt(t) && n.Be(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ue(), n.Oe || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.ke(), n.Be(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ue(), n.Oe || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.nt(t) && (n.Ke(), n.Be(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.nt(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.rt(t), n.Be(e.resumeToken));
                    break;
                default:
                    $70fd6868680e912c$var$fail(56790, {
                        state: e.state
                    });
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Ge.forEach((e, n)=>{
            this.nt(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ it(e) {
        const t = e.targetId, n = e.De.count, r = this.st(t);
        if (r) {
            const i = r.target;
            if ($70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $70fd6868680e912c$export$afc2e57c475b7810(i.path);
                    this.Xe(t, e, $70fd6868680e912c$var$MutableDocument.newNoDocument(e, $70fd6868680e912c$var$SnapshotVersion.min()));
                } else $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === n, 20013, {
                    expectedCount: n
                });
            } else {
                const r = this.ot(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this._t(e), i = n ? this.ut(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.rt(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.He = this.He.insert(t, e);
                    }
                    null == $70fd6868680e912c$var$pt || $70fd6868680e912c$var$pt.ct(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        var s, o, _, a, u, c;
                        const l = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, h = t.unchangedNames;
                        h && (l.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                            mightContain: (e)=>{
                                var t;
                                return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            }
                        });
                        return l;
                    }(r, e.De, this.We.lt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ _t(e) {
        const t = e.De.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $70fd6868680e912c$var$__PRIVATE_Base64DecodeError) return $70fd6868680e912c$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $70fd6868680e912c$var$BloomFilter(s, r, i);
        } catch (e) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb(e instanceof $70fd6868680e912c$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.fe ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ ut(e, t, n) {
        return t.De.count === n - this.ht(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ ht(e, t) {
        const n = this.We.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.We.lt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.Xe(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Pt(e) {
        const t = new Map;
        this.Ge.forEach((n, r)=>{
            const i = this.st(r);
            if (i) {
                if (n.current && $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $70fd6868680e912c$export$afc2e57c475b7810(i.target.path);
                    this.Tt(t).has(r) || this.It(r, t) || this.Xe(r, t, $70fd6868680e912c$var$MutableDocument.newNoDocument(t, e));
                }
                n.Ne && (t.set(r, n.Le()), n.ke());
            }
        });
        let n = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Je.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.st(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.ze.forEach((t, n)=>n.setReadTime(e));
        const r = new $70fd6868680e912c$var$RemoteEvent(e, t, this.He, this.ze, n);
        return this.ze = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), this.je = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), this.Je = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), this.He = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ze(e, t) {
        if (!this.nt(e)) return;
        const n = this.It(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.tt(e).qe(t.key, n), this.ze = this.ze.insert(t.key, t), this.je = this.je.insert(t.key, this.Tt(t.key).add(e)), this.Je = this.Je.insert(t.key, this.dt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Xe(e, t, n) {
        if (!this.nt(e)) return;
        const r = this.tt(e);
        this.It(e, t) ? r.qe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Qe(t), this.Je = this.Je.insert(t, this.dt(t).delete(e)), this.Je = this.Je.insert(t, this.dt(t).add(e)), n && (this.ze = this.ze.insert(t, n));
    }
    removeTarget(e) {
        this.Ge.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ ot(e) {
        const t = this.tt(e).Le();
        return this.We.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ $e(e) {
        this.tt(e).$e();
    }
    tt(e) {
        let t = this.Ge.get(e);
        return t || (t = new $70fd6868680e912c$var$__PRIVATE_TargetState, this.Ge.set(e, t)), t;
    }
    dt(e) {
        let t = this.Je.get(e);
        return t || (t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    Tt(e) {
        let t = this.je.get(e);
        return t || (t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.je = this.je.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ nt(e) {
        const t = null !== this.st(e);
        return t || $70fd6868680e912c$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ st(e) {
        const t = this.Ge.get(e);
        return t && t.Oe ? null : this.We.Et(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ rt(e) {
        this.Ge.set(e, new $70fd6868680e912c$var$__PRIVATE_TargetState);
        this.We.getRemoteKeysForTarget(e).forEach((t)=>{
            this.Xe(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ It(e, t) {
        return this.We.getRemoteKeysForTarget(e).has(t);
    }
}
function $70fd6868680e912c$var$__PRIVATE_documentTargetMap() {
    return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
function $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap() {
    return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
const $70fd6868680e912c$var$wt = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $70fd6868680e912c$var$St = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $70fd6868680e912c$var$bt = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $70fd6868680e912c$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $70fd6868680e912c$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ /**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $70fd6868680e912c$var$__PRIVATE_toVersion(e, t) {
    return $70fd6868680e912c$var$toTimestamp(e, t.toTimestamp());
}
function $70fd6868680e912c$var$__PRIVATE_fromVersion(e) {
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e, 49232), $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $70fd6868680e912c$var$__PRIVATE_toResourceName(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $70fd6868680e912c$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $70fd6868680e912c$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $70fd6868680e912c$var$__PRIVATE_fromResourceName(e) {
    const t = $70fd6868680e912c$var$ResourcePath.fromString(e);
    return $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $70fd6868680e912c$var$__PRIVATE_toName(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $70fd6868680e912c$var$fromName(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $70fd6868680e912c$var$__PRIVATE_fromQueryPath(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $70fd6868680e912c$var$ResourcePath.emptyPath() : $70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $70fd6868680e912c$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $70fd6868680e912c$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $70fd6868680e912c$var$fromName(e, t.name), i = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), o = new $70fd6868680e912c$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $70fd6868680e912c$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $70fd6868680e912c$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $70fd6868680e912c$var$fromName(e, t.found.name), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.found.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), s = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $70fd6868680e912c$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.missing, 3894), $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.readTime, 22933);
        const n = $70fd6868680e912c$var$fromName(e, t.missing), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime);
        return $70fd6868680e912c$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $70fd6868680e912c$var$fail(7234, {
        result: t
    });
}
function $70fd6868680e912c$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $70fd6868680e912c$var$fail(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t, 58123), $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(t || "")) : ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $70fd6868680e912c$require$Buffer || t instanceof Uint8Array, 16193), $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $70fd6868680e912c$var$N.UNKNOWN : $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $70fd6868680e912c$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $70fd6868680e912c$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $70fd6868680e912c$var$fromName(e, r.document.name), s = $70fd6868680e912c$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(r.document.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), _ = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $70fd6868680e912c$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $70fd6868680e912c$var$fromName(e, r.document), s = r.readTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(r.readTime) : $70fd6868680e912c$var$SnapshotVersion.min(), o = $70fd6868680e912c$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $70fd6868680e912c$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $70fd6868680e912c$var$fail(11601, {
            At: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $70fd6868680e912c$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $70fd6868680e912c$var$toMutation(e, t) {
    let n;
    if (t instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation) n = {
        update: $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_DeleteMutation) n = {
        delete: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation) n = {
        update: $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $70fd6868680e912c$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $70fd6868680e912c$var$__PRIVATE_VerifyMutation)) return $70fd6868680e912c$var$fail(16599, {
            Rt: t.type
        });
        n = {
            verify: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Ee
            };
            throw $70fd6868680e912c$var$fail(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $70fd6868680e912c$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $70fd6868680e912c$var$fail(27497);
    }(e, t.precondition)), n;
}
function $70fd6868680e912c$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $70fd6868680e912c$var$Precondition.updateTime($70fd6868680e912c$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $70fd6868680e912c$var$Precondition.exists(e.exists) : $70fd6868680e912c$var$Precondition.none();
    }(t.currentDocument) : $70fd6868680e912c$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $70fd6868680e912c$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $70fd6868680e912c$var$fail(16584, {
                proto: t
            });
            const r = $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $70fd6868680e912c$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $70fd6868680e912c$var$fromName(e, t.update.name), s = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $70fd6868680e912c$var$FieldMask(t.map((e)=>$70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $70fd6868680e912c$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $70fd6868680e912c$var$fromName(e, t.delete);
        return new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $70fd6868680e912c$var$fromName(e, t.verify);
        return new $70fd6868680e912c$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $70fd6868680e912c$var$fail(1463, {
        proto: t
    });
}
function $70fd6868680e912c$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(e.updateTime) : $70fd6868680e912c$var$__PRIVATE_fromVersion(t);
            return n.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $70fd6868680e912c$var$__PRIVATE_fromVersion(t)), new $70fd6868680e912c$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $70fd6868680e912c$var$__PRIVATE_toFilter($70fd6868680e912c$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $70fd6868680e912c$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        Vt: n,
        parent: i
    };
}
function $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { Vt: i, parent: s } = $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        ft: o,
        parent: s
    };
}
function $70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $70fd6868680e912c$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_fromFilter(e);
        if (t instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $70fd6868680e912c$var$OrderBy($70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $70fd6868680e912c$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $70fd6868680e912c$var$Bound(n, t);
    }(n.endAt)), $70fd6868680e912c$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $70fd6868680e912c$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $70fd6868680e912c$var$fail(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $70fd6868680e912c$var$fail(61313);
            default:
                return $70fd6868680e912c$var$fail(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $70fd6868680e912c$var$FieldFilter.create($70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $70fd6868680e912c$var$fail(58110);
                default:
                    return $70fd6868680e912c$var$fail(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $70fd6868680e912c$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $70fd6868680e912c$var$fail(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $70fd6868680e912c$var$fail(30097, {
        filter: e
    });
}
function $70fd6868680e912c$var$__PRIVATE_toDirection(e) {
    return $70fd6868680e912c$var$wt[e];
}
function $70fd6868680e912c$var$__PRIVATE_toOperatorName(e) {
    return $70fd6868680e912c$var$St[e];
}
function $70fd6868680e912c$var$__PRIVATE_toCompositeOperatorName(e) {
    return $70fd6868680e912c$var$bt[e];
}
function $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e) {
    return $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $70fd6868680e912c$var$__PRIVATE_toFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($70fd6868680e912c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($70fd6868680e912c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($70fd6868680e912c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($70fd6868680e912c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                op: $70fd6868680e912c$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$70fd6868680e912c$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $70fd6868680e912c$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $70fd6868680e912c$var$fail(54877, {
        filter: e
    });
}
function $70fd6868680e912c$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $70fd6868680e912c$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $70fd6868680e912c$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $70fd6868680e912c$var$SnapshotVersion.min(), s = $70fd6868680e912c$var$SnapshotVersion.min(), o = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $70fd6868680e912c$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.gt = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $70fd6868680e912c$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $70fd6868680e912c$var$__PRIVATE_fromDocument(e.gt, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $70fd6868680e912c$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $70fd6868680e912c$var$fail(56709);
        {
            const e = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $70fd6868680e912c$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $70fd6868680e912c$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $70fd6868680e912c$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.gt, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $70fd6868680e912c$var$fail(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$70fd6868680e912c$var$__PRIVATE_fromMutation(e.gt, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$70fd6868680e912c$var$__PRIVATE_fromMutation(e.gt, t)), i = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $70fd6868680e912c$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $70fd6868680e912c$var$__PRIVATE_fromDbTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $70fd6868680e912c$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === t, 1966, {
            count: t
        }), $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath($70fd6868680e912c$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $70fd6868680e912c$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $70fd6868680e912c$var$__PRIVATE_toDbTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e.gt, t.target) : $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e.gt, t.target).Vt;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $70fd6868680e912c$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $70fd6868680e912c$var$Overlay(t.largestBatchId, $70fd6868680e912c$var$__PRIVATE_fromMutation(e.gt, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $70fd6868680e912c$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp($70fd6868680e912c$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp($70fd6868680e912c$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $70fd6868680e912c$var$__PRIVATE_bundlesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$we);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$be);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static yt(e, t) {
        const n = t.uid || "";
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).get($70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $70fd6868680e912c$var$Overlay(t, i);
            r.push(this.wt(e, s));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).Y($70fd6868680e912c$var$Ke, r));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).j($70fd6868680e912c$var$Ke, s).next((e)=>{
            for (const t of e){
                const e = $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).X({
            index: $70fd6868680e912c$var$Ge,
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    wt(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $70fd6868680e912c$var$toMutation(e.gt, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$$e);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbGlobalsCache {
    St(e) {
        return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$je);
    }
    getSessionToken(e) {
        return this.St(e).get("sessionToken").next((e)=>{
            const t = null == e ? void 0 : e.value;
            return t ? $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(t) : $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.St(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ bt(e, t) {
        this.Dt(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.vt();
    }
    Dt(e, t) {
        if ("nullValue" in e) this.Ct(t, 5);
        else if ("booleanValue" in e) this.Ct(t, 10), t.Ft(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Ct(t, 15), t.Ft($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Ct(t, 13) : (this.Ct(t, 15), $70fd6868680e912c$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.Ft(0) : t.Ft(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Ct(t, 20), "string" == typeof n && (n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(n)), t.Mt(`${n.seconds || ""}`), t.Ft(n.nanos || 0);
        } else if ("stringValue" in e) this.xt(e.stringValue, t), this.Ot(t);
        else if ("bytesValue" in e) this.Ct(t, 30), t.Nt($70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Ot(t);
        else if ("referenceValue" in e) this.Bt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Ct(t, 45), t.Ft(n.latitude || 0), t.Ft(n.longitude || 0);
        } else "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) ? this.Ct(t, Number.MAX_SAFE_INTEGER) : $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? this.Lt(e.mapValue, t) : (this.kt(e.mapValue, t), this.Ot(t)) : "arrayValue" in e ? (this.qt(e.arrayValue, t), this.Ot(t)) : $70fd6868680e912c$var$fail(19022, {
            Qt: e
        });
    }
    xt(e, t) {
        this.Ct(t, 25), this.$t(e, t);
    }
    $t(e, t) {
        t.Mt(e);
    }
    kt(e, t) {
        const n = e.fields || {};
        this.Ct(t, 55);
        for (const e of Object.keys(n))this.xt(e, t), this.Dt(n[e], t);
    }
    Lt(e, t) {
        var n, r;
        const i = e.fields || {};
        this.Ct(t, 53);
        // Vectors sort first by length
        const s = $70fd6868680e912c$var$Tt, o = (null === (r = null === (n = i[s].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.length) || 0;
        this.Ct(t, 15), t.Ft($70fd6868680e912c$var$__PRIVATE_normalizeNumber(o)), // Vectors then sort by position value
        this.xt(s, t), this.Dt(i[s], t);
    }
    qt(e, t) {
        const n = e.values || [];
        this.Ct(t, 50);
        for (const e of n)this.Dt(e, t);
    }
    Bt(e, t) {
        this.Ct(t, 37);
        $70fd6868680e912c$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.Ct(t, 60), this.$t(e, t);
        });
    }
    Ct(e, t) {
        e.Ft(t);
    }
    Ot(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Ft(2);
    }
}
$70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ut = new $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $70fd6868680e912c$var$Dt = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $70fd6868680e912c$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $70fd6868680e912c$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Kt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Wt(n.value), n = t.next();
        this.Gt();
    }
    zt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.jt(n.value), n = t.next();
        this.Jt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Ht(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Wt(e);
            else if (e < 2048) this.Wt(960 | e >>> 6), this.Wt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Wt(480 | e >>> 12), this.Wt(128 | 63 & e >>> 6), this.Wt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Wt(240 | e >>> 18), this.Wt(128 | 63 & e >>> 12), this.Wt(128 | 63 & e >>> 6), this.Wt(128 | 63 & e);
            }
        }
        this.Gt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Yt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.jt(e);
            else if (e < 2048) this.jt(960 | e >>> 6), this.jt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.jt(480 | e >>> 12), this.jt(128 | 63 & e >>> 6), this.jt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.jt(240 | e >>> 18), this.jt(128 | 63 & e >>> 12), this.jt(128 | 63 & e >>> 6), this.jt(128 | 63 & e);
            }
        }
        this.Jt();
    }
    Zt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.Xt(e), n = $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(t);
        this.en(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    tn(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.Xt(e), n = $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(t);
        this.en(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ nn() {
        this.rn($70fd6868680e912c$var$Dt), this.rn(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ sn() {
        this._n($70fd6868680e912c$var$Dt), this._n(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.en(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ an() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Xt(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Wt(e) {
        const t = 255 & e;
        0 === t ? (this.rn(0), this.rn(255)) : t === $70fd6868680e912c$var$Dt ? (this.rn($70fd6868680e912c$var$Dt), this.rn(0)) : this.rn(t);
    }
    /** Writes a single byte descending to the buffer.  */ jt(e) {
        const t = 255 & e;
        0 === t ? (this._n(0), this._n(255)) : t === $70fd6868680e912c$var$Dt ? (this._n($70fd6868680e912c$var$Dt), this._n(0)) : this._n(e);
    }
    Gt() {
        this.rn(0), this.rn(1);
    }
    Jt() {
        this._n(0), this._n(1);
    }
    rn(e) {
        this.en(1), this.buffer[this.position++] = e;
    }
    _n(e) {
        this.en(1), this.buffer[this.position++] = ~e;
    }
    en(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $70fd6868680e912c$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.un = e;
    }
    Nt(e) {
        this.un.Kt(e);
    }
    Mt(e) {
        this.un.Ht(e);
    }
    Ft(e) {
        this.un.Zt(e);
    }
    vt() {
        this.un.nn();
    }
}
class $70fd6868680e912c$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.un = e;
    }
    Nt(e) {
        this.un.zt(e);
    }
    Mt(e) {
        this.un.Yt(e);
    }
    Ft(e) {
        this.un.tn(e);
    }
    vt() {
        this.un.sn();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.un = new $70fd6868680e912c$var$__PRIVATE_OrderedCodeWriter, this.cn = new $70fd6868680e912c$var$__PRIVATE_AscendingIndexByteEncoder(this.un), this.ln = new $70fd6868680e912c$var$__PRIVATE_DescendingIndexByteEncoder(this.un);
    }
    seed(e) {
        this.un.seed(e);
    }
    hn(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.cn : this.ln;
    }
    an() {
        return this.un.an();
    }
    reset() {
        this.un.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $70fd6868680e912c$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.Pn = e, this.Tn = t, this.In = n, this.dn = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ En() {
        const e = this.dn.length, t = 0 === e || 255 === this.dn[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.dn, 0), t !== e ? n.set([
            0
        ], this.dn.length) : ++n[n.length - 1], new $70fd6868680e912c$var$__PRIVATE_IndexEntry(this.Pn, this.Tn, this.In, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    An(e, t, n) {
        return {
            indexId: this.Pn,
            uid: e,
            arrayValue: $70fd6868680e912c$var$__PRIVATE_encodeKeySafeBytes(this.In),
            directionalValue: $70fd6868680e912c$var$__PRIVATE_encodeKeySafeBytes(this.dn),
            orderedDocumentKey: $70fd6868680e912c$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    Rn(e, t, n) {
        const r = this.An(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.Pn - t.Pn;
    return 0 !== n ? n : (n = $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e.In, t.In), 0 !== n ? n : (n = $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e.dn, t.dn), 0 !== n ? n : $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.Tn, t.Tn)));
}
function $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $70fd6868680e912c$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $gMVVg.isSafariOrWebkit)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $70fd6868680e912c$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Vn = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$export$b7871852b967eaf1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.mn = e.orderBy, this.fn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Vn = this.Vn.add(e) : this.fn.push(e);
        }
    }
    get gn() {
        return this.Vn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ pn(e) {
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId, 49279), this.gn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.yn(t)) return !1;
        const n = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.yn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.Vn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.Vn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.wn(e, t) || !this.Sn(this.mn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.mn.length || !this.Sn(this.mn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ bn() {
        if (this.gn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        const t = [];
        for (const n of this.fn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $70fd6868680e912c$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $70fd6868680e912c$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.mn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $70fd6868680e912c$var$IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $70fd6868680e912c$var$FieldIndex($70fd6868680e912c$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $70fd6868680e912c$var$IndexState.empty());
    }
    yn(e) {
        for (const t of this.fn)if (this.wn(t, e)) return !0;
        return !1;
    }
    wn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    Sn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $70fd6868680e912c$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter, 20012), e instanceof $70fd6868680e912c$var$FieldFilter) {
        if (e instanceof $70fd6868680e912c$var$__PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t)=>$70fd6868680e912c$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t))) || [];
            return $70fd6868680e912c$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const r = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_computeInExpansion(e));
    return $70fd6868680e912c$var$CompositeFilter.create(r, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $70fd6868680e912c$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm($70fd6868680e912c$var$__PRIVATE_computeInExpansion(e));
    return $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(t) || $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(e) || $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(t) && !$70fd6868680e912c$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter, 34018), e instanceof $70fd6868680e912c$var$FieldFilter) return e;
    if (1 === e.filters.length) return $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $70fd6868680e912c$var$CompositeFilter.create(t, e.op);
    return n = $70fd6868680e912c$var$__PRIVATE_applyAssociation(n), $70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($70fd6868680e912c$var$__PRIVATE_hardAssert(n instanceof $70fd6868680e912c$var$CompositeFilter, 64498), $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $70fd6868680e912c$var$__PRIVATE_hardAssert(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t)));
}
function $70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter, 38388), $70fd6868680e912c$var$__PRIVATE_hardAssert(t instanceof $70fd6868680e912c$var$FieldFilter || t instanceof $70fd6868680e912c$var$CompositeFilter, 25473), // FieldFilter FieldFilter
    n = e instanceof $70fd6868680e912c$var$FieldFilter ? t instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $70fd6868680e912c$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $70fd6868680e912c$var$FieldFilter ? $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0, 48005), $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e) && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(t)) return $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, r));
        return $70fd6868680e912c$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $70fd6868680e912c$var$__PRIVATE_applyAssociation(n);
}
function $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t));
        return $70fd6868680e912c$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $70fd6868680e912c$var$__PRIVATE_applyAssociation(e) {
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter, 11850), e instanceof $70fd6868680e912c$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $70fd6868680e912c$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$70fd6868680e912c$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $70fd6868680e912c$var$FieldFilter ? r.push(t) : t instanceof $70fd6868680e912c$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $70fd6868680e912c$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Dn = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Dn.add(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Dn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$vt = "IndexedDbIndexManager", $70fd6868680e912c$var$Ct = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.vn = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Cn = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), (e, t)=>$70fd6868680e912c$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.vn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.vn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r)
            };
            return $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e).j(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($70fd6868680e912c$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e), i = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), n = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return t.Y().next(()=>n.Y()).next(()=>r.Y());
    }
    createTargetIndexes(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.Fn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher(t).bn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.Fn(t), (t)=>this.Mn(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                const r = [];
                return $70fd6868680e912c$var$PersistencePromise.forEach(i, (i, s)=>{
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$70fd6868680e912c$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $70fd6868680e912c$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $70fd6868680e912c$var$Bound(n, r);
                    }(s, i), c = this.xn(i, s, a), l = this.xn(i, s, u), h = this.On(i, s, _), P = this.Nn(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $70fd6868680e912c$var$PersistencePromise.forEach(P, (i)=>n.H(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $70fd6868680e912c$var$PersistencePromise.resolve(null);
        });
    }
    Fn(e) {
        let t = this.Cn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $70fd6868680e912c$var$__PRIVATE_getDnfTerms($70fd6868680e912c$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Cn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ Nn(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Bn(t[c / a]) : $70fd6868680e912c$var$Ct, l = this.Ln(e, _, n[c % a], r), h = this.kn(e, _, i[c % a], s), P = o.map((t)=>this.Ln(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ Ln(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_IndexEntry(e, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.En();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ kn(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_IndexEntry(e, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.En() : i;
    }
    Mn(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.pn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.Fn(t);
        return $70fd6868680e912c$var$PersistencePromise.forEach(r, (t)=>this.Mn(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ qn(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        for (const r of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.hn(r.kind);
            $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, i);
        }
        return n.an();
    }
    /** Encodes a single value to the ascending index format. */ Bn(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        return $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, t.hn(0 /* IndexKind.ASCENDING */ )), t.an();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ Qn(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        return $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt($70fd6868680e912c$var$__PRIVATE_refValue(this.databaseId, t), n.hn(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.an();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ On(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.$n(t, s.fieldPath) && $70fd6868680e912c$var$isArray(e)) r = this.Un(r, s, e);
            else {
                const t = n.hn(s.kind);
                $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, t);
            }
        }
        return this.Kn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ xn(e, t, n) {
        return this.On(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ Kn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].an();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Un(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.an()), $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, r.hn(t.kind)), i.push(r);
        }
        return i;
    }
    $n(e, t) {
        return !!e.filters.find((e)=>e instanceof $70fd6868680e912c$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return (t ? n.j($70fd6868680e912c$var$Fe, IDBKeyRange.bound(t, t)) : n.j()).next((e)=>{
            const t = [];
            return $70fd6868680e912c$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $70fd6868680e912c$var$IndexState(t.sequenceNumber, new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.readTime), new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $70fd6868680e912c$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $70fd6868680e912c$var$IndexSegment($70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $70fd6868680e912c$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), i = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return this.Wn(e).next((e)=>r.j($70fd6868680e912c$var$Fe, IDBKeyRange.bound(t, t)).next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>i.put($70fd6868680e912c$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $70fd6868680e912c$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $70fd6868680e912c$var$PersistencePromise.forEach(i, (n)=>this.Gn(e, t, n).next((t)=>{
                        const i = this.zn(r, n);
                        return t.isEqual(i) ? $70fd6868680e912c$var$PersistencePromise.resolve() : this.jn(e, r, n, t, i);
                    }))));
        });
    }
    Jn(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e).put(r.An(this.uid, this.Qn(n, t.key), t.key));
    }
    Hn(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e).delete(r.Rn(this.uid, this.Qn(n, t.key), t.key));
    }
    Gn(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        let i = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_indexEntryComparator);
        return r.X({
            index: $70fd6868680e912c$var$qe,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $70fd6868680e912c$var$__PRIVATE_encodeKeySafeBytes(this.Qn(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(n.indexId, t, $70fd6868680e912c$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $70fd6868680e912c$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ zn(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_indexEntryComparator);
        const r = this.qn(t, e);
        if (null == r) return n;
        const i = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($70fd6868680e912c$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Bn(i), r));
        } else n = n.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(t.indexId, e.key, $70fd6868680e912c$var$Ct, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ jn(e, t, n, r, i) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s)) : (_ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $70fd6868680e912c$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.Jn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Hn(e, t, n, r));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(s);
    }
    Wn(e) {
        let t = 1;
        return $70fd6868680e912c$var$__PRIVATE_indexStateStore(e).X({
            index: $70fd6868680e912c$var$Ne,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(i, e), s = $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.En();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.En());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Yn(r[e], r[e + 1])) return [];
            const t = r[e].Rn(this.uid, $70fd6868680e912c$var$Ct, $70fd6868680e912c$export$afc2e57c475b7810.empty()), n = r[e + 1].Rn(this.uid, $70fd6868680e912c$var$Ct, $70fd6868680e912c$export$afc2e57c475b7810.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Yn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.mapArray(this.Fn(t), (t)=>this.Mn(e, t).next((e)=>e || $70fd6868680e912c$var$fail(44426))).next($70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$fe);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Le);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$ve);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexStateStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$xe);
}
function $70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $70fd6868680e912c$var$__PRIVATE_hardAssert(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $70fd6868680e912c$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Ft = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $70fd6868680e912c$var$Mt = 41943040;
class $70fd6868680e912c$var$LruParams {
    static withCacheSize(e) {
        return new $70fd6868680e912c$var$LruParams(e, $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $70fd6868680e912c$var$removeMutationBatch(e, t, n) {
    const r = e.store($70fd6868680e912c$var$X), i = e.store($70fd6868680e912c$var$ie), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.X({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === _, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $70fd6868680e912c$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $70fd6868680e912c$var$fail(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $70fd6868680e912c$var$LruParams.DEFAULT = new $70fd6868680e912c$var$LruParams($70fd6868680e912c$var$Mt, $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $70fd6868680e912c$var$LruParams.DISABLED = new $70fd6868680e912c$var$LruParams(-1, 0, 0);
class $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Zn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static yt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $70fd6868680e912c$var$__PRIVATE_hardAssert("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).X({
            index: $70fd6868680e912c$var$te,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e), s = $70fd6868680e912c$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $70fd6868680e912c$var$__PRIVATE_hardAssert("number" == typeof o, 49019);
            const _ = new $70fd6868680e912c$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$70fd6868680e912c$var$toMutation(e.gt, t)), i = n.mutations.map((t)=>$70fd6868680e912c$var$toMutation(e.gt, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $70fd6868680e912c$var$re));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Zn[o] = _.keys();
            }), $70fd6868680e912c$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Xn(e, t) {
        return this.Zn[t] ? $70fd6868680e912c$var$PersistencePromise.resolve(this.Zn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Zn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).X({
            index: $70fd6868680e912c$var$te,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($70fd6868680e912c$var$__PRIVATE_hardAssert(t.batchId >= n, 47524, {
                er: n
            }), i = $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $70fd6868680e912c$var$G;
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).X({
            index: $70fd6868680e912c$var$te,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $70fd6868680e912c$var$G
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).j($70fd6868680e912c$var$te, t).next((e)=>e.map((e)=>$70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).X({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $70fd6868680e912c$var$fail(61480, {
                    tr: n,
                    batchId: a
                });
                $70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).X({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r).next(()=>this.nr(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).X({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.nr(e, o));
    }
    nr(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $70fd6868680e912c$var$fail(35274, {
                    batchId: t
                });
                $70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $70fd6868680e912c$var$removeMutationBatch(e.ce, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.rr(t.batchId);
            }), $70fd6868680e912c$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    rr(e) {
        delete this.Zn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $70fd6868680e912c$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).X({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $70fd6868680e912c$var$__PRIVATE_hardAssert(0 === r.length, 56720, {
                    ir: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ sr(e) {
        return $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $70fd6868680e912c$var$G,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).X({
        range: s,
        Z: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$X);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$ie);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Y);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this._r = e;
    }
    next() {
        return this._r += 2, this._r;
    }
    static ar() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(0);
    }
    static ur() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.cr(e).next((t)=>{
            const n = new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.lr(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.cr(e).next((e)=>$70fd6868680e912c$var$SnapshotVersion.fromTimestamp(new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.cr(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.cr(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.lr(e, r)));
    }
    addTargetData(e, t) {
        return this.hr(e, t).next(()=>this.cr(e).next((n)=>(n.targetCount += 1, this.Pr(t, n), this.lr(e, n))));
    }
    updateTargetData(e, t) {
        return this.hr(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$70fd6868680e912c$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.cr(e)).next((t)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(t.targetCount > 0, 8065), t.targetCount -= 1, this.lr(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).X((s, o)=>{
            const _ = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).X((e, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    cr(e) {
        return $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e).get($70fd6868680e912c$var$Ve).next((e)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(null !== e, 2888), e));
    }
    lr(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e).put($70fd6868680e912c$var$Ve, t);
    }
    hr(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).put($70fd6868680e912c$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Pr(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.cr(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $70fd6868680e912c$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).X({
            range: r,
            index: $70fd6868680e912c$var$Te
        }, (e, n, r)=>{
            const s = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $70fd6868680e912c$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>{
            const i = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path);
            return $70fd6868680e912c$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        let i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return r.X({
            range: n,
            Z: !0
        }, (e, t, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e[1]), s = new $70fd6868680e912c$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).X({
            index: $70fd6868680e912c$var$Ae,
            Z: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    Et(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $70fd6868680e912c$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $70fd6868680e912c$var$__PRIVATE_targetsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Pe);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$me);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$de);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$xt = "LruGarbageCollector", $70fd6868680e912c$var$Ot = 1048576;
function $70fd6868680e912c$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $70fd6868680e912c$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $70fd6868680e912c$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Tr = e, this.buffer = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_bufferEntryComparator), this.Ir = 0;
    }
    dr() {
        return ++this.Ir;
    }
    Er(e) {
        const t = [
            e,
            this.dr()
        ];
        if (this.buffer.size < this.Tr) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $70fd6868680e912c$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $70fd6868680e912c$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Ar = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Rr(6e4);
    }
    stop() {
        this.Ar && (this.Ar.cancel(), this.Ar = null);
    }
    get started() {
        return null !== this.Ar;
    }
    Rr(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$xt, `Garbage collection scheduled in ${e}ms`), this.Ar = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Ar = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$xt, "Ignoring IndexedDB error during garbage collection: ", e) : await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Rr(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $70fd6868680e912c$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Vr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Vr.mr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$__PRIVATE_ListenSequence.ue);
        const n = new $70fd6868680e912c$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Vr.forEachTarget(e, (e)=>n.Er(e.sequenceNumber)).next(()=>this.Vr.gr(e, (e)=>n.Er(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Vr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Vr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$Ft)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $70fd6868680e912c$var$Ft) : this.pr(e, t));
    }
    getCacheSize(e) {
        return this.Vr.getCacheSize(e);
    }
    pr(e, t) {
        let n, r, i, s, o, _, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, _ = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $5Z2ef.LogLevel).DEBUG) $70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (_ - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - _) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $70fd6868680e912c$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $70fd6868680e912c$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    mr(e) {
        const t = this.yr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    yr(e) {
        let t = 0;
        return this.gr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    gr(e, t) {
        return this.wr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Sr(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e).ee((r)=>$70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $70fd6868680e912c$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.wr(e, (s, o)=>{
            if (o <= t) {
                const t = this.Sr(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $70fd6868680e912c$var$SnapshotVersion.min()), $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ wr(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        let r, i = $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue;
        return n.X({
            index: $70fd6868680e912c$var$Ae
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue && t(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue && t(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $70fd6868680e912c$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.br(e, n)));
    }
    getEntry(e, t) {
        let n = $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t);
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $70fd6868680e912c$var$_e,
            range: IDBKeyRange.only($70fd6868680e912c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.Dr(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ vr(e, t) {
        let n = {
            size: 0,
            document: $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t)
        };
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $70fd6868680e912c$var$_e,
            range: IDBKeyRange.only($70fd6868680e912c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.Dr(t, r),
                size: $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return this.Cr(e, t, (e, t)=>{
            const r = this.Dr(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ Fr(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), r = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        return this.Cr(e, t, (e, t)=>{
            const i = this.Dr(e, t);
            n = n.insert(e, i), r = r.insert(e, $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Mr: r
            }));
    }
    Cr(e, t, n) {
        if (t.isEmpty()) return $70fd6868680e912c$var$PersistencePromise.resolve();
        let r = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($70fd6868680e912c$var$__PRIVATE_dbKey(r.first()), $70fd6868680e912c$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $70fd6868680e912c$var$_e,
            range: i
        }, (e, t, r)=>{
            const i = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $70fd6868680e912c$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.G($70fd6868680e912c$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).j(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            null == i || i.incrementDocumentReadCount(e.length);
            let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.Dr($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($70fd6868680e912c$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        const s = $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(t, $70fd6868680e912c$var$IndexOffset.max());
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $70fd6868680e912c$var$ue,
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.Dr($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e).get($70fd6868680e912c$var$he).next((e)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(!!e, 20021), e));
    }
    br(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e).put($70fd6868680e912c$var$he, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Dr(e, t) {
        if (t) {
            const e = $70fd6868680e912c$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($70fd6868680e912c$var$SnapshotVersion.min()))) return e;
        }
        return $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.Or = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Nr = new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Nr.get(i);
            if (t.push(this.Or.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(this.Or.serializer, s);
                r = r.add(i.path.popLast());
                const a = $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.Or.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(this.Or.serializer, s.convertToNoDocument($70fd6868680e912c$var$SnapshotVersion.min()));
                t.push(this.Or.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.Or.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.Or.updateMetadata(e, n)), $70fd6868680e912c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Or.vr(e, t).next((e)=>(this.Nr.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Or.Fr(e, t).next(({ documents: e, Mr: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Nr.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$le);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$se);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $70fd6868680e912c$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $70fd6868680e912c$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $70fd6868680e912c$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $70fd6868680e912c$var$FieldMask.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $70fd6868680e912c$var$__PRIVATE_documentKeySet()) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $70fd6868680e912c$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $70fd6868680e912c$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        const s = $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $70fd6868680e912c$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>{
                var n;
                return o.set(e, new $70fd6868680e912c$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $70fd6868680e912c$var$SortedMap((e, t)=>e - t), i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $70fd6868680e912c$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $70fd6868680e912c$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $70fd6868680e912c$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $70fd6868680e912c$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = $70fd6868680e912c$var$Q, _ = i;
            return s.next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $70fd6868680e912c$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $70fd6868680e912c$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $70fd6868680e912c$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $70fd6868680e912c$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$70fd6868680e912c$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $70fd6868680e912c$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $70fd6868680e912c$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $70fd6868680e912c$var$FieldMask.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $70fd6868680e912c$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Br = new Map, this.Lr = new Map;
    }
    getBundleMetadata(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Br.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Br.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $70fd6868680e912c$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Lr.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Lr.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $70fd6868680e912c$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator), this.kr = new Map;
    }
    getOverlay(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.wt(e, t, r);
        }), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.kr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.kr.delete(n)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $70fd6868680e912c$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $70fd6868680e912c$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(o);
    }
    wt(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.kr.get(r.largestBatchId).delete(n.key);
            this.kr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $70fd6868680e912c$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.kr.get(t);
        void 0 === i && (i = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.kr.set(t, i)), this.kr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $70fd6868680e912c$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.qr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.Qr), // A set of outstanding references to a document sorted by target id.
        this.$r = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.Ur);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.qr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, t);
        this.qr = this.qr.add(n), this.$r = this.$r.add(n);
    }
    /** Add references to the given document keys for the given ID. */ Kr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Wr(new $70fd6868680e912c$var$__PRIVATE_DocReference(e, t));
    }
    Gr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ zr(e) {
        const t = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath([])), n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.$r.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Wr(e), i.push(e.key);
        }), i;
    }
    jr() {
        this.qr.forEach((e)=>this.Wr(e));
    }
    Wr(e) {
        this.qr = this.qr.delete(e), this.$r = this.$r.delete(e);
    }
    Jr(e) {
        const t = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath([])), n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e + 1);
        let i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.$r.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, 0), n = this.qr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $70fd6868680e912c$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.Hr = t;
    }
    /** Compare by key then by ID */ static Qr(e, t) {
        return $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key) || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr);
    }
    /** Compare by ID then by key */ static Ur(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.er = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Yr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.Qr);
    }
    checkEmpty(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.er;
        this.er++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $70fd6868680e912c$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.Yr = this.Yr.add(new $70fd6868680e912c$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $70fd6868680e912c$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Zr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Xr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $70fd6868680e912c$var$G : this.er - 1);
    }
    getAllMutationBatches(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, 0), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.Yr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Zr(e.Hr);
            i.push(t);
        }), $70fd6868680e912c$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, 0), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.Yr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.Hr);
            });
        }), $70fd6868680e912c$var$PersistencePromise.resolve(this.ei(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $70fd6868680e912c$var$__PRIVATE_DocReference(new $70fd6868680e912c$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return this.Yr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.Hr)), !0);
        }, s), $70fd6868680e912c$var$PersistencePromise.resolve(this.ei(o));
    }
    ei(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Zr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(0 === this.ti(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.Yr;
        return $70fd6868680e912c$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $70fd6868680e912c$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.Yr = n;
        });
    }
    rr(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, 0), r = this.Yr.firstAfterOrEqual(n);
        return $70fd6868680e912c$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ti(e, t) {
        return this.Xr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ Xr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Zr(e) {
        const t = this.Xr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.ni = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.ni(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $70fd6868680e912c$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e));
        }), $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $70fd6868680e912c$export$afc2e57c475b7810(s.child("__id-9223372036854775808__")), _ = this.docs.getIteratorFrom(o);
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator($70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $70fd6868680e912c$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $70fd6868680e912c$var$fail(9500);
    }
    ri(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.Or = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.Or.addEntry(e, r)) : this.Or.removeEntry(n);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.Or.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.Or.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.ii = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), $70fd6868680e912c$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $70fd6868680e912c$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.si = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.oi = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this._i = $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator.ar();
    }
    forEachTarget(e, t) {
        return this.ii.forEach((e, n)=>t(n)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.si);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this._i.next(), $70fd6868680e912c$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.si && (this.si = t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    hr(e) {
        this.ii.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this._i = new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.si && (this.si = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.hr(t), this.targetCount += 1, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.hr(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.ii.delete(t.target), this.oi.zr(t.targetId), this.targetCount -= 1, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.ii.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.ii.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.ii.get(t) || null;
        return $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.oi.Kr(t, n), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.oi.Gr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.oi.zr(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.oi.Jr(t);
        return $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.oi.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.ai = {}, this.overlays = {}, this.ui = new $70fd6868680e912c$var$__PRIVATE_ListenSequence(0), this.ci = !1, this.ci = !0, this.li = new $70fd6868680e912c$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.hi = new $70fd6868680e912c$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $70fd6868680e912c$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.Pi(e)), this.serializer = new $70fd6868680e912c$var$__PRIVATE_LocalSerializer(t), this.Ti = new $70fd6868680e912c$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.ci = !1, Promise.resolve();
    }
    get started() {
        return this.ci;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $70fd6868680e912c$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.ai[e.toKey()];
        return n || (n = new $70fd6868680e912c$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.ai[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.li;
    }
    getTargetCache() {
        return this.hi;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Ti;
    }
    runTransaction(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $70fd6868680e912c$var$__PRIVATE_MemoryTransaction(this.ui.next());
        return this.referenceDelegate.Ii(), n(r).next((e)=>this.referenceDelegate.di(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Ei(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.or(Object.values(this.ai).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryTransaction extends $70fd6868680e912c$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Ai = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Ri = null;
    }
    static Vi(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get mi() {
        if (this.Ri) return this.Ri;
        throw $70fd6868680e912c$var$fail(60996);
    }
    addReference(e, t, n) {
        return this.Ai.addReference(n, t), this.mi.delete(n.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Ai.removeReference(n, t), this.mi.add(n.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.mi.add(t.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Ai.zr(t.targetId).forEach((e)=>this.mi.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.mi.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Ii() {
        this.Ri = new Set;
    }
    di(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.mi, (n)=>{
            const r = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(n);
            return this.fi(e, r).next((e)=>{
                e || t.removeEntry(r, $70fd6868680e912c$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Ri = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.fi(e, t).next((e)=>{
            e ? this.mi.delete(t.toString()) : this.mi.add(t.toString());
        });
    }
    Pi(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    fi(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.or([
            ()=>$70fd6868680e912c$var$PersistencePromise.resolve(this.Ai.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Ei(e, t)
        ]);
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.gi = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static Vi(e, t) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Ii() {}
    di(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    mr(e) {
        const t = this.yr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    yr(e) {
        let t = 0;
        return this.gr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    gr(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.gi, (n, r)=>this.Sr(e, n, r).next((e)=>e ? $70fd6868680e912c$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.ri(e, (r)=>this.Sr(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $70fd6868680e912c$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.gi.set(t, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.gi.set(n, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.gi.set(n, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.gi.set(t, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    Pi(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $70fd6868680e912c$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    Sr(e, t, n) {
        return $70fd6868680e912c$var$PersistencePromise.or([
            ()=>this.persistence.Ei(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.gi.get(t);
                return $70fd6868680e912c$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $70fd6868680e912c$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ q(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($70fd6868680e912c$var$J);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($70fd6868680e912c$var$Y, {
                keyPath: $70fd6868680e912c$var$Z
            });
            const t = e.createObjectStore($70fd6868680e912c$var$X, {
                keyPath: $70fd6868680e912c$var$ee,
                autoIncrement: !0
            });
            t.createIndex($70fd6868680e912c$var$te, $70fd6868680e912c$var$ne, {
                unique: !0
            }), e.createObjectStore($70fd6868680e912c$var$ie);
        }(e), $70fd6868680e912c$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($70fd6868680e912c$var$j);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $70fd6868680e912c$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($70fd6868680e912c$var$de), e.deleteObjectStore($70fd6868680e912c$var$Pe), e.deleteObjectStore($70fd6868680e912c$var$me);
        }(e), $70fd6868680e912c$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($70fd6868680e912c$var$me), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $70fd6868680e912c$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($70fd6868680e912c$var$Ve, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($70fd6868680e912c$var$X);
                return n.j().next((n)=>{
                    e.deleteObjectStore($70fd6868680e912c$var$X);
                    e.createObjectStore($70fd6868680e912c$var$X, {
                        keyPath: $70fd6868680e912c$var$ee,
                        autoIncrement: !0
                    }).createIndex($70fd6868680e912c$var$te, $70fd6868680e912c$var$ne, {
                        unique: !0
                    });
                    const r = t.store($70fd6868680e912c$var$X), i = n.map((e)=>r.put(e));
                    return $70fd6868680e912c$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($70fd6868680e912c$var$pe, {
                    keyPath: $70fd6868680e912c$var$ye
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.pi(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($70fd6868680e912c$var$le);
            })(e), this.yi(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.wi(i))), n < 8 && r >= 8 && (s = s.next(()=>this.Si(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.bi(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($70fd6868680e912c$var$we, {
                    keyPath: $70fd6868680e912c$var$Se
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($70fd6868680e912c$var$be, {
                    keyPath: $70fd6868680e912c$var$De
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($70fd6868680e912c$var$$e, {
                    keyPath: $70fd6868680e912c$var$Ue
                });
                t.createIndex($70fd6868680e912c$var$Ke, $70fd6868680e912c$var$We, {
                    unique: !1
                }), t.createIndex($70fd6868680e912c$var$Ge, $70fd6868680e912c$var$ze, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($70fd6868680e912c$var$se, {
                    keyPath: $70fd6868680e912c$var$oe
                });
                t.createIndex($70fd6868680e912c$var$_e, $70fd6868680e912c$var$ae), t.createIndex($70fd6868680e912c$var$ue, $70fd6868680e912c$var$ce);
            })(e)).next(()=>this.Di(e, i)).next(()=>e.deleteObjectStore($70fd6868680e912c$var$j))), n < 14 && r >= 14 && (s = s.next(()=>this.Ci(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($70fd6868680e912c$var$ve, {
                    keyPath: $70fd6868680e912c$var$Ce,
                    autoIncrement: !0
                });
                t.createIndex($70fd6868680e912c$var$Fe, $70fd6868680e912c$var$Me, {
                    unique: !1
                });
                const n = e.createObjectStore($70fd6868680e912c$var$xe, {
                    keyPath: $70fd6868680e912c$var$Oe
                });
                n.createIndex($70fd6868680e912c$var$Ne, $70fd6868680e912c$var$Be, {
                    unique: !1
                });
                const r = e.createObjectStore($70fd6868680e912c$var$Le, {
                    keyPath: $70fd6868680e912c$var$ke
                });
                r.createIndex($70fd6868680e912c$var$qe, $70fd6868680e912c$var$Qe, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($70fd6868680e912c$var$xe).clear();
        }).next(()=>{
            t.objectStore($70fd6868680e912c$var$Le).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($70fd6868680e912c$var$je, {
                    keyPath: $70fd6868680e912c$var$Je
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $gMVVg.isSafariOrWebkit)() && (s = s.next(()=>{
            t.objectStore($70fd6868680e912c$var$xe).clear();
        }).next(()=>{
            t.objectStore($70fd6868680e912c$var$Le).clear();
        })), s;
    }
    yi(e) {
        let t = 0;
        return e.store($70fd6868680e912c$var$j).X((e, n)=>{
            t += $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($70fd6868680e912c$var$le).put($70fd6868680e912c$var$he, n);
        });
    }
    pi(e) {
        const t = e.store($70fd6868680e912c$var$Y), n = e.store($70fd6868680e912c$var$X);
        return t.j().next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $70fd6868680e912c$var$G
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.j($70fd6868680e912c$var$te, r).next((n)=>$70fd6868680e912c$var$PersistencePromise.forEach(n, (n)=>{
                        $70fd6868680e912c$var$__PRIVATE_hardAssert(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $70fd6868680e912c$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ wi(e) {
        const t = e.store($70fd6868680e912c$var$de), n = e.store($70fd6868680e912c$var$j);
        return e.store($70fd6868680e912c$var$me).get($70fd6868680e912c$var$Ve).next((e)=>{
            const r = [];
            return n.X((n, i)=>{
                const s = new $70fd6868680e912c$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $70fd6868680e912c$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r));
        });
    }
    Si(e, t) {
        // Create the index.
        e.createObjectStore($70fd6868680e912c$var$fe, {
            keyPath: $70fd6868680e912c$var$ge
        });
        const n = t.store($70fd6868680e912c$var$fe), r = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($70fd6868680e912c$var$j).X({
            Z: !0
        }, (e, t)=>{
            const n = new $70fd6868680e912c$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($70fd6868680e912c$var$ie).X({
                Z: !0
            }, ([e, t, n], r)=>{
                const i = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    bi(e) {
        const t = e.store($70fd6868680e912c$var$Pe);
        return t.X((e, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n), i = $70fd6868680e912c$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    Di(e, t) {
        const n = t.store($70fd6868680e912c$var$j), r = [];
        return n.X((e, n)=>{
            const i = t.store($70fd6868680e912c$var$se), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $70fd6868680e912c$var$fail(36783);
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r));
    }
    Ci(e, t) {
        const n = t.store($70fd6868680e912c$var$X), r = $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence($70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer.gt);
        return n.j().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>r = r.add(e)), n.set(e.userId, r);
            }), $70fd6868680e912c$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $70fd6868680e912c$var$User(n), o = $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache.yt(this.serializer, s), _ = i.getIndexManager(s), a = $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue.yt(s, this.serializer, _, i.referenceDelegate);
                return new $70fd6868680e912c$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(t, $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue), e).next();
            });
        });
    }
}
function $70fd6868680e912c$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($70fd6868680e912c$var$de, {
        keyPath: $70fd6868680e912c$var$Ee
    }).createIndex($70fd6868680e912c$var$Ae, $70fd6868680e912c$var$Re, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($70fd6868680e912c$var$Pe, {
        keyPath: "targetId"
    }).createIndex($70fd6868680e912c$var$Te, $70fd6868680e912c$var$Ie, {
        unique: !0
    }), e.createObjectStore($70fd6868680e912c$var$me);
}
const $70fd6868680e912c$var$Nt = "IndexedDbPersistence", $70fd6868680e912c$var$Bt = 18e5, $70fd6868680e912c$var$Lt = 5e3, $70fd6868680e912c$var$kt = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $70fd6868680e912c$var$qt = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Fi = i, this.window = s, this.document = o, this.Mi = a, this.xi = u, this.Oi = c, this.ui = null, this.ci = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Ni = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Bi = null, /** The client metadata refresh task. */ this.Li = null, /** The last time we garbage collected the client metadata object store. */ this.ki = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.qi = (e)=>Promise.resolve(), !$70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence.C()) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $70fd6868680e912c$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Qi = t + $70fd6868680e912c$var$qt, this.serializer = new $70fd6868680e912c$var$__PRIVATE_LocalSerializer(_), this.$i = new $70fd6868680e912c$var$__PRIVATE_SimpleDb(this.Qi, this.Oi, new $70fd6868680e912c$var$__PRIVATE_SchemaConverter(this.serializer)), this.li = new $70fd6868680e912c$var$__PRIVATE_IndexedDbGlobalsCache, this.hi = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Ti = new $70fd6868680e912c$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ui = this.window.localStorage : (this.Ui = null, !1 === u && $70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$Nt, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.Ki().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, $70fd6868680e912c$var$kt);
            return this.Wi(), this.Gi(), this.zi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.hi.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.ui = new $70fd6868680e912c$var$__PRIVATE_ListenSequence(e, this.Mi);
        }).then(()=>{
            this.ci = !0;
        }).catch((e)=>(this.$i && this.$i.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ ji(e) {
        return this.qi = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the underlying database receives
     * an event indicating that it either has been deleted or is pending deletion
     * and must be closed.
     *
     * For example, this callback will be called in the case that multi-tab
     * IndexedDB persistence is in use and another tab calls
     * clearIndexedDbPersistence(). In that case, this Firestore instance must
     * close its IndexedDB connection in order to allow the deletion initiated by
     * the other tab to proceed.
     *
     * This method may only be called once; subsequent invocations will result in
     * an exception, refusing to supersede the previously-registered listener.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.$i.setDatabaseDeletedListener(e);
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Fi.enqueueAndForget(async ()=>{
            this.started && await this.Ki();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ Ki() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.Ji(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Fi.enqueueRetryable(()=>this.qi(!1)));
                });
            }).next(()=>this.Hi(e)).next((t)=>this.isPrimary && !t ? this.Yi(e).next(()=>!1) : !!t && this.Zi(e).next(()=>!0))).catch((e)=>{
            if ($70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Nt, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Nt, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Fi.enqueueRetryable(()=>this.qi(e)), this.isPrimary = e;
        });
    }
    Ji(e) {
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get($70fd6868680e912c$var$H).next((e)=>$70fd6868680e912c$var$PersistencePromise.resolve(this.Xi(e)));
    }
    es(e) {
        return $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async ts() {
        if (this.isPrimary && !this.ns(this.ki, $70fd6868680e912c$var$Bt)) {
            this.ki = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$pe);
                return t.j().next((e)=>{
                    const n = this.rs(e, $70fd6868680e912c$var$Bt), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $70fd6868680e912c$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Ui) for (const t of e)this.Ui.removeItem(this.ss(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ zi() {
        this.Li = this.Fi.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.Ki().then(()=>this.ts()).then(()=>this.zi()));
    }
    /** Checks whether `client` is the local client. */ Xi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Hi(e) {
        if (this.xi) return $70fd6868680e912c$var$PersistencePromise.resolve(!0);
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get($70fd6868680e912c$var$H).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.ns(t.leaseTimestampMs, $70fd6868680e912c$var$Lt) && !this._s(t.ownerId)) {
                if (this.Xi(t) && this.networkEnabled) return !0;
                if (!this.Xi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, $70fd6868680e912c$var$kt);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).j().next((e)=>void 0 === this.rs(e, $70fd6868680e912c$var$Lt).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Nt, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.ci = !1, this.us(), this.Li && (this.Li.cancel(), this.Li = null), this.cs(), this.ls(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.$i.runTransaction("shutdown", "readwrite", [
            $70fd6868680e912c$var$J,
            $70fd6868680e912c$var$pe
        ], (e)=>{
            const t = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(e, $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue);
            return this.Yi(t).next(()=>this.es(t));
        }), this.$i.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.hs();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ rs(e, t) {
        return e.filter((e)=>this.ns(e.updateTimeMs, t) && !this._s(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ps() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).j().next((e)=>this.rs(e, $70fd6868680e912c$var$Bt).map((e)=>e.clientId)));
    }
    get started() {
        return this.ci;
    }
    getGlobalsCache() {
        return this.li;
    }
    getMutationQueue(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue.yt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.hi;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.gt.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache.yt(this.serializer, e);
    }
    getBundleCache() {
        return this.Ti;
    }
    runTransaction(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Nt, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $70fd6868680e912c$var$rt : 17 === e ? $70fd6868680e912c$var$nt : 16 === e ? $70fd6868680e912c$var$tt : 15 === e ? $70fd6868680e912c$var$et : 14 === e ? $70fd6868680e912c$var$Xe : 13 === e ? $70fd6868680e912c$var$Ze : 12 === e ? $70fd6868680e912c$var$Ye : 11 === e ? $70fd6868680e912c$var$He : void $70fd6868680e912c$var$fail(60245);
        }(this.Oi);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.$i.runTransaction(e, r, i, (r)=>(s = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(r, this.ui ? this.ui.next() : $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue), "readwrite-primary" === t ? this.Ji(s).next((e)=>!!e || this.Hi(s)).next((t)=>{
                if (!t) throw $70fd6868680e912c$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Fi.enqueueRetryable(()=>this.qi(!1)), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, $70fd6868680e912c$var$$);
                return n(s);
            }).next((e)=>this.Zi(s).next(()=>e)) : this.Ts(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ts(e) {
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get($70fd6868680e912c$var$H).next((e)=>{
            if (null !== e && this.ns(e.leaseTimestampMs, $70fd6868680e912c$var$Lt) && !this._s(e.ownerId) && !this.Xi(e) && !(this.xi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, $70fd6868680e912c$var$kt);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Zi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).put($70fd6868680e912c$var$H, t);
    }
    static C() {
        return $70fd6868680e912c$var$__PRIVATE_SimpleDb.C();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Yi(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e);
        return t.get($70fd6868680e912c$var$H).next((e)=>this.Xi(e) ? ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Nt, "Releasing primary lease."), t.delete($70fd6868680e912c$var$H)) : $70fd6868680e912c$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ ns(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($70fd6868680e912c$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Wi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Bi = ()=>{
            this.Fi.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.Ki()));
        }, this.document.addEventListener("visibilitychange", this.Bi), this.inForeground = "visible" === this.document.visibilityState);
    }
    cs() {
        this.Bi && (this.document.removeEventListener("visibilitychange", this.Bi), this.Bi = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Gi() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.Ni = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.us();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $gMVVg.isSafari)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Fi.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Fi.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Ni));
    }
    ls() {
        this.Ni && (this.window.removeEventListener("pagehide", this.Ni), this.Ni = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ _s(e) {
        var t;
        try {
            const n = null !== (null === (t = this.Ui) || void 0 === t ? void 0 : t.getItem(this.ss(e)));
            return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Nt, `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$Nt, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ us() {
        if (this.Ui) try {
            this.Ui.setItem(this.ss(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $70fd6868680e912c$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ hs() {
        if (this.Ui) try {
            this.Ui.removeItem(this.ss(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    ss(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$J);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$pe);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $70fd6868680e912c$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Is = n, this.ds = r;
    }
    static Es(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), r = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $70fd6868680e912c$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $70fd6868680e912c$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryEngine {
    constructor(){
        this.As = !1, this.Rs = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Vs = 100, this.fs = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $gMVVg.isSafari)() ? 8 : $70fd6868680e912c$var$__PRIVATE_getAndroidVersion((0, $gMVVg.getUA)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.gs = e, this.indexManager = t, this.As = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.ps(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.ys(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $70fd6868680e912c$var$QueryContext;
            return this.ws(e, t, n).next((r)=>{
                if (i.result = r, this.Rs) return this.Ss(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    Ss(e, t, n, r) {
        return n.documentReadCount < this.Vs ? ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $5Z2ef.LogLevel).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Vs, "documents"), $70fd6868680e912c$var$PersistencePromise.resolve()) : ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $5Z2ef.LogLevel).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.fs * r ? ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $5Z2ef.LogLevel).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t))) : $70fd6868680e912c$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ ps(e, t) {
        if ($70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
        let n = $70fd6868680e912c$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $70fd6868680e912c$var$__PRIVATE_documentKeySet(...r);
                return this.gs.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.bs(t, r);
                        return this.Ds(t, s, i, n.readTime) ? this.ps(e, $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.vs(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ ys(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? $70fd6868680e912c$var$PersistencePromise.resolve(null) : this.gs.getDocuments(e, n).next((i)=>{
            const s = this.bs(t, i);
            return this.Ds(t, s, n, r) ? $70fd6868680e912c$var$PersistencePromise.resolve(null) : ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $5Z2ef.LogLevel).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t)), this.vs(e, s, t, $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $70fd6868680e912c$var$Q)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ bs(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $70fd6868680e912c$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Ds(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    ws(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $5Z2ef.LogLevel).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t)), this.gs.getDocumentsMatchingQuery(e, t, $70fd6868680e912c$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ vs(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.gs.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Qt = "LocalStore", $70fd6868680e912c$var$$t = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Cs = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Fs = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Ms = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), $70fd6868680e912c$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.xs = new Map, this.Os = e.getRemoteDocumentCache(), this.hi = e.getTargetCache(), this.Ti = e.getBundleCache(), this.Ns(n);
    }
    Ns(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $70fd6868680e912c$var$LocalDocumentsView(this.Os, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Os.setIndexManager(this.indexManager), this.Cs.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.Fs));
    }
}
function $70fd6868680e912c$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $70fd6868680e912c$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Ns(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Bs: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.Os.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $70fd6868680e912c$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $70fd6868680e912c$var$__PRIVATE_hardAssert(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.hi.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.Fs;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.Os.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Fs;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.hi.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.hi.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, $70fd6868680e912c$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($70fd6868680e912c$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $70fd6868680e912c$var$$t) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && o.push(n.hi.updateTargetData(e, u));
        });
        let _ = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), a = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Ls, a = e.ks;
        })), !r.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) {
            const t = n.hi.getLastRemoteSnapshotVersion(e).next((t)=>n.hi.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $70fd6868680e912c$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.Fs = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Qt, "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Ls: r,
            ks: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $70fd6868680e912c$var$G), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.hi.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $70fd6868680e912c$var$PersistencePromise.resolve(r)) : n.hi.allocateTargetId(e).next((i)=>(r = new $70fd6868680e912c$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.hi.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.Fs.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.Fs = n.Fs.insert(e.targetId, e), n.Ms.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.Fs.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Qt, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.Fs = r.Fs.remove(t), r.Ms.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let i = $70fd6868680e912c$var$SnapshotVersion.min(), s = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.Ms.get(n);
            return void 0 !== i ? $70fd6868680e912c$var$PersistencePromise.resolve(r.Fs.get(i)) : r.hi.getTargetData(t, n);
        })(r, e, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.hi.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Cs.getDocumentsMatchingQuery(e, t, n ? i : $70fd6868680e912c$var$SnapshotVersion.min(), n ? s : $70fd6868680e912c$var$__PRIVATE_documentKeySet())).next((e)=>($70fd6868680e912c$var$__PRIVATE_setMaxReadTime(r, $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                qs: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_debugCast(n.hi), i = n.Fs.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.Et(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.xs.get(t) || $70fd6868680e912c$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.Os.getAllFromCollectionGroup(e, t, $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $70fd6868680e912c$var$Q), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($70fd6868680e912c$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.xs.get(t) || $70fd6868680e912c$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.xs.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $70fd6868680e912c$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let s = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), o = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Qs(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.$s(e);
        r.setReadTime(t.Us(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.Os.newChangeBuffer({
        trackRemovals: !0
    }), a = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath($70fd6868680e912c$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.hi.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.hi.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Ls, t.ks)).next(()=>t.Ls)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $70fd6868680e912c$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $70fd6868680e912c$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e, $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Ti.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.Fs = i.Fs.insert(o.targetId, o), i.hi.updateTargetData(e, o).next(()=>i.hi.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.hi.addMatchingKeys(e, n, r.targetId)).next(()=>i.Ti.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $70fd6868680e912c$var$Ut = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $70fd6868680e912c$var$createWebStorageClientStateKey(e, t) {
    return `${$70fd6868680e912c$var$Ut}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $70fd6868680e912c$var$Kt = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $70fd6868680e912c$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$70fd6868680e912c$var$Kt}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $70fd6868680e912c$var$Wt = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$70fd6868680e912c$var$Wt}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Gt = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $70fd6868680e912c$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $70fd6868680e912c$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$Gt, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $70fd6868680e912c$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$Gt, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $70fd6868680e912c$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $70fd6868680e912c$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $70fd6868680e912c$var$__PRIVATE_RemoteClientState(e, i) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$Gt, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $70fd6868680e912c$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $70fd6868680e912c$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$Gt, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $70fd6868680e912c$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
    }
    Gs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    zs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Ws() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Fi = t, this.persistenceKey = n, this.js = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.Js = this.Hs.bind(this), this.Ys = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Zs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Xs = $70fd6868680e912c$var$createWebStorageClientStateKey(this.persistenceKey, this.js), this.eo = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Ys = this.Ys.insert(this.js, new $70fd6868680e912c$var$__PRIVATE_LocalClientState), this.no = new RegExp(`^${$70fd6868680e912c$var$Ut}_${s}_([^_]*)$`), this.ro = new RegExp(`^${$70fd6868680e912c$var$Kt}_${s}_(\\d+)(?:_(.*))?$`), this.io = new RegExp(`^${$70fd6868680e912c$var$Wt}_${s}_(\\d+)$`), this.so = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.oo = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.Js);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static C(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.Ps();
        for (const t of e){
            if (t === this.js) continue;
            const e = this.getItem($70fd6868680e912c$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $70fd6868680e912c$var$__PRIVATE_RemoteClientState.Ks(t, e);
                n && (this.Ys = this.Ys.insert(n.clientId, n));
            }
        }
        this._o();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.so);
        if (t) {
            const e = this.ao(t);
            e && this.uo(e);
        }
        for (const e of this.Zs)this.Hs(e);
        this.Zs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.eo, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.co(this.Ys);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Ys.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.lo(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.lo(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.ho(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata.Ks(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.Po.Gs(e), this._o(), n;
    }
    removeLocalQueryTarget(e) {
        this.Po.zs(e), this._o();
    }
    isLocalQueryTarget(e) {
        return this.Po.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.To(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.ho(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Io(e);
    }
    notifyBundleLoaded(e) {
        this.Eo(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.Js), this.removeItem(this.Xs), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Gt, "READ", e, t), t;
    }
    setItem(e, t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Gt, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Gt, "REMOVE", e), this.storage.removeItem(e);
    }
    Hs(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Gt, "EVENT", t.key, t.newValue), t.key === this.Xs) return void $70fd6868680e912c$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Fi.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.no.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Ao(t.key);
                                return this.Ro(e, null);
                            }
                            {
                                const e = this.Vo(t.key, t.newValue);
                                if (e) return this.Ro(e.clientId, e);
                            }
                        } else if (this.ro.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.mo(t.key, t.newValue);
                                if (e) return this.fo(e);
                            }
                        } else if (this.io.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.po(t.key, t.newValue);
                                if (e) return this.yo(e);
                            }
                        } else if (t.key === this.so) {
                            if (null !== t.newValue) {
                                const e = this.ao(t.newValue);
                                if (e) return this.uo(e);
                            }
                        } else if (t.key === this.eo) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $70fd6868680e912c$var$__PRIVATE_hardAssert("number" == typeof n, 30636, {
                                        wo: e
                                    }), t = n;
                                } catch (e) {
                                    $70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$Gt, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue && this.sequenceNumberHandler(e);
                        } else if (t.key === this.oo) {
                            const e = this.So(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.bo(e)));
                        }
                    }
                } else this.Zs.push(t);
            });
        }
    }
    get Po() {
        return this.Ys.get(this.js);
    }
    _o() {
        this.setItem(this.Xs, this.Po.Ws());
    }
    lo(e, t, n) {
        const r = new $70fd6868680e912c$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $70fd6868680e912c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Ws());
    }
    ho(e) {
        const t = $70fd6868680e912c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Io(e) {
        const t = {
            clientId: this.js,
            onlineState: e
        };
        this.storage.setItem(this.so, JSON.stringify(t));
    }
    To(e, t, n) {
        const r = $70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Ws());
    }
    Eo(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.oo, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Ao(e) {
        const t = this.no.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Vo(e, t) {
        const n = this.Ao(e);
        return $70fd6868680e912c$var$__PRIVATE_RemoteClientState.Ks(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ mo(e, t) {
        const n = this.ro.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $70fd6868680e912c$var$__PRIVATE_MutationMetadata.Ks(new $70fd6868680e912c$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ po(e, t) {
        const n = this.io.exec(e), r = Number(n[1]);
        return $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata.Ks(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ ao(e) {
        return $70fd6868680e912c$var$__PRIVATE_SharedOnlineState.Ks(e);
    }
    So(e) {
        return JSON.parse(e);
    }
    async fo(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Do(e.batchId, e.state, e.error);
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Gt, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    yo(e) {
        return this.syncEngine.vo(e.targetId, e.state, e.error);
    }
    Ro(e, t) {
        const n = t ? this.Ys.insert(e, t) : this.Ys.remove(e), r = this.co(this.Ys), i = this.co(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.Co(s, o).then(()=>{
            this.Ys = n;
        });
    }
    uo(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Ys.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    co(e) {
        let t = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.Fo = new $70fd6868680e912c$var$__PRIVATE_LocalClientState, this.Mo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.Fo.Gs(e), this.Mo[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.Mo[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.Fo.zs(e);
    }
    isLocalQueryTarget(e) {
        return this.Fo.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.Mo[e];
    }
    getAllActiveQueryTargets() {
        return this.Fo.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.Fo.activeTargetIds.has(e);
    }
    start() {
        return this.Fo = new $70fd6868680e912c$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_NoopConnectivityMonitor {
    xo(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $70fd6868680e912c$var$zt = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.Oo = ()=>this.No(), this.Bo = ()=>this.Lo(), this.ko = [], this.qo();
    }
    xo(e) {
        this.ko.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.Oo), window.removeEventListener("offline", this.Bo);
    }
    qo() {
        window.addEventListener("online", this.Oo), window.addEventListener("offline", this.Bo);
    }
    No() {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "Network connectivity changed: AVAILABLE");
        for (const e of this.ko)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    Lo() {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.ko)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static C() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $70fd6868680e912c$var$jt = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId() {
    return null === $70fd6868680e912c$var$jt ? $70fd6868680e912c$var$jt = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $70fd6868680e912c$var$jt++, "0x" + $70fd6868680e912c$var$jt.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Jt = "RestConnection", $70fd6868680e912c$var$Ht = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $70fd6868680e912c$var$__PRIVATE_RestConnection {
    get Qo() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.$o = t + "://" + e.host, this.Uo = `projects/${n}/databases/${r}`, this.Ko = this.databaseId.database === $70fd6868680e912c$var$ut ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Wo(e, t, n, r, i) {
        const s = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId(), o = this.Go(e, t.toUriEncodedString());
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Uo,
            "x-goog-request-params": this.Ko
        };
        this.zo(_, r, i);
        const { host: a } = new URL(o), u = (0, $gMVVg.isCloudWorkstation)(a);
        return this.jo(e, o, _, n, u).then((t)=>($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$Jt, `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    Jo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Wo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ zo(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $70fd6868680e912c$var$x;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    Go(e, t) {
        const n = $70fd6868680e912c$var$Ht[e];
        return `${this.$o}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $70fd6868680e912c$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Ho = e.Ho, this.Yo = e.Yo;
    }
    Zo(e) {
        this.Xo = e;
    }
    e_(e) {
        this.t_ = e;
    }
    n_(e) {
        this.r_ = e;
    }
    onMessage(e) {
        this.i_ = e;
    }
    close() {
        this.Yo();
    }
    send(e) {
        this.Ho(e);
    }
    s_() {
        this.Xo();
    }
    o_() {
        this.t_();
    }
    __(e) {
        this.r_(e);
    }
    a_(e) {
        this.i_(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Yt = "WebChannelConnection";
class $70fd6868680e912c$var$__PRIVATE_WebChannelConnection extends $70fd6868680e912c$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.u_ = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    jo(e, t, n, r, i) {
        const s = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, o)=>{
            const _ = new (0, $4rHck.XhrIo);
            _.setWithCredentials(!0), _.listenOnce((0, $4rHck.EventType).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $4rHck.ErrorCode).NO_ERROR:
                            const t = _.getResponseJson();
                            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $4rHck.ErrorCode).TIMEOUT:
                            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' ${s} timed out`), o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $4rHck.ErrorCode).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' ${s} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = null == e ? void 0 : e.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($70fd6868680e912c$var$N).indexOf(t) >= 0 ? t : $70fd6868680e912c$var$N.UNKNOWN;
                                    }(t.status);
                                    o(new $70fd6868680e912c$export$8fada0bf726bf278(e, t.message));
                                } else o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $70fd6868680e912c$var$fail(9055, {
                                c_: e,
                                streamId: s,
                                l_: _.getLastErrorCode(),
                                h_: _.getLastError()
                            });
                    }
                } finally{
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' ${s} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    P_(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.$o,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $4rHck.createWebChannelTransport)(), o = (0, $4rHck.getStatEventTarget)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), this.zo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        this.T_(c);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $70fd6868680e912c$var$__PRIVATE_StreamBridge({
            Ho: (t)=>{
                h ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            Yo: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $4rHck.WebChannel).EventType.OPEN, ()=>{
            h || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} transport opened.`), P.s_());
        }), __PRIVATE_unguardedEventListen(c, (0, $4rHck.WebChannel).EventType.CLOSE, ()=>{
            h || (h = !0, $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} transport closed`), P.__(), this.I_(c));
        }), __PRIVATE_unguardedEventListen(c, (0, $4rHck.WebChannel).EventType.ERROR, (t)=>{
            h || (h = !0, $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), P.__(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $4rHck.WebChannel).EventType.MESSAGE, (t)=>{
            var n;
            if (!h) {
                const i = t.data[0];
                $70fd6868680e912c$var$__PRIVATE_hardAssert(!!i, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = (null == s ? void 0 : s.error) || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $70fd6868680e912c$var$ft[e];
                        if (void 0 !== t) return $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = $70fd6868680e912c$var$N.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), // Mark closed so no further events are propagated
                    h = !0, P.__(new $70fd6868680e912c$export$8fada0bf726bf278(n, i)), c.close();
                } else $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} received:`, i), P.a_(i);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $4rHck.Event).STAT_EVENT, (t)=>{
            t.stat === (0, $4rHck.Stat).PROXY ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $4rHck.Stat).NOPROXY && $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.o_();
        }, 0), P;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.u_.forEach((e)=>e.close()), this.u_ = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ T_(e) {
        this.u_.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ I_(e) {
        this.u_ = this.u_.filter((t)=>t === e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $70fd6868680e912c$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $70fd6868680e912c$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_newSerializer(e) {
    return new $70fd6868680e912c$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Fi = e, this.timerId = t, this.d_ = n, this.E_ = r, this.A_ = i, this.R_ = 0, this.V_ = null, /** The last backoff attempt, as epoch milliseconds. */ this.m_ = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.R_ = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ f_() {
        this.R_ = this.A_;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ g_(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.R_ + this.p_()), n = Math.max(0, Date.now() - this.m_), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $70fd6868680e912c$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.R_} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.V_ = this.Fi.enqueueAfterDelay(this.timerId, r, ()=>(this.m_ = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.R_ *= this.E_, this.R_ < this.d_ && (this.R_ = this.d_), this.R_ > this.A_ && (this.R_ = this.A_);
    }
    y_() {
        null !== this.V_ && (this.V_.skipDelay(), this.V_ = null);
    }
    cancel() {
        null !== this.V_ && (this.V_.cancel(), this.V_ = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ p_() {
        return (Math.random() - .5) * this.R_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Zt = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.Fi = e, this.w_ = n, this.S_ = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.b_ = 0, this.D_ = null, this.v_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.C_ = 0, this.F_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ M_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.x_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ x_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.C_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.O_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.M_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ N_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.F_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ B_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.x_() && null === this.D_ && (this.D_ = this.Fi.enqueueAfterDelay(this.w_, 6e4, ()=>this.L_()));
    }
    /** Sends a message to the underlying stream. */ k_(e) {
        this.q_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async L_() {
        if (this.x_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ q_() {
        this.D_ && (this.D_.cancel(), this.D_ = null);
    }
    /** Cancels the health check delayed operation. */ Q_() {
        this.v_ && (this.v_.cancel(), this.v_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.q_(), this.Q_(), this.F_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.b_++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.F_.reset() : t && t.code === $70fd6868680e912c$var$N.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($70fd6868680e912c$var$__PRIVATE_logError(t.toString()), $70fd6868680e912c$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.F_.f_()) : t && t.code === $70fd6868680e912c$var$N.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.U_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.n_(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ U_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.K_(this.b_), t = this.b_;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.b_ === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.W_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.G_(e);
            });
        });
    }
    W_(e, t) {
        const n = this.K_(this.b_);
        this.stream = this.z_(e, t), this.stream.Zo(()=>{
            n(()=>this.listener.Zo());
        }), this.stream.e_(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.v_ = this.Fi.enqueueAfterDelay(this.S_, 1e4, ()=>(this.x_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.e_()));
        }), this.stream.n_((e)=>{
            n(()=>this.G_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.C_ ? this.j_(e) : this.onNext(e));
        });
    }
    O_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.F_.g_(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    G_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Zt, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ K_(e) {
        return (t)=>{
            this.Fi.enqueueAndForget(()=>this.b_ === e ? t() : ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Zt, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentListenStream extends $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    z_(e, t) {
        return this.connection.P_("Listen", e, t);
    }
    j_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.F_.reset();
        const t = $70fd6868680e912c$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $70fd6868680e912c$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $70fd6868680e912c$var$SnapshotVersion.min() : t.readTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime) : $70fd6868680e912c$var$SnapshotVersion.min();
        }(e);
        return this.listener.J_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ H_(e) {
        const t = {};
        t.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, r).Vt
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $70fd6868680e912c$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($70fd6868680e912c$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $70fd6868680e912c$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $70fd6868680e912c$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.k_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ Y_(e) {
        const t = {};
        t.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.k_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentWriteStream extends $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Z_() {
        return this.C_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    U_() {
        this.Z_ && this.X_([]);
    }
    z_(e, t) {
        return this.connection.P_("Write", e, t);
    }
    j_(e) {
        // Always capture the last stream token.
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.ea();
    }
    onNext(e) {
        // Always capture the last stream token.
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.F_.reset();
        const t = $70fd6868680e912c$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $70fd6868680e912c$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.ta(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ na() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.k_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ X_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$70fd6868680e912c$var$toMutation(this.serializer, e))
        };
        this.k_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $70fd6868680e912c$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $70fd6868680e912c$var$__PRIVATE_DatastoreImpl extends $70fd6868680e912c$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.ra = !1;
    }
    ia() {
        if (this.ra) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Wo(e, t, n, r) {
        return this.ia(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Wo(e, $70fd6868680e912c$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $70fd6868680e912c$var$N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ Jo(e, t, n, r, i) {
        return this.ia(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.Jo(e, $70fd6868680e912c$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $70fd6868680e912c$var$N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.ra = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $70fd6868680e912c$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.sa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.oa = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this._a = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ aa() {
        0 === this.sa && (this.ua("Unknown" /* OnlineState.Unknown */ ), this.oa = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.oa = null, this.ca("Backend didn't respond within 10 seconds."), this.ua("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ la(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.ua("Unknown" /* OnlineState.Unknown */ ) : (this.sa++, this.sa >= 1 && (this.ha(), this.ca(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.ua("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.ha(), this.sa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this._a = !1), this.ua(e);
    }
    ua(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    ca(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this._a ? ($70fd6868680e912c$var$__PRIVATE_logError(t), this._a = !1) : $70fd6868680e912c$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    ha() {
        null !== this.oa && (this.oa.cancel(), this.oa = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Xt = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $70fd6868680e912c$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Pa = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ta = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.Ia = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.da = [], this.Ea = i, this.Ea.xo((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $70fd6868680e912c$var$__PRIVATE_canUseNetwork(this) && ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Xt, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                    t.Ia.add(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), t.Aa.set("Unknown" /* OnlineState.Unknown */ ), t.Ia.delete(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.Aa = new $70fd6868680e912c$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(e) {
    if ($70fd6868680e912c$var$__PRIVATE_canUseNetwork(e)) for (const t of e.da)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.da)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    n.Ta.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.Ta.set(t.targetId, t), $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $70fd6868680e912c$var$__PRIVATE_startWatchStream(n) : $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(n).x_() && $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(n);
    n.Ta.delete(t), r.x_() && $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.Ta.size && (r.x_() ? r.B_() : $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.Aa.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.Ra.$e(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($70fd6868680e912c$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).H_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.Ra.$e(t), $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).Y_(t);
}
function $70fd6868680e912c$var$__PRIVATE_startWatchStream(e) {
    e.Ra = new $70fd6868680e912c$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        Et: (t)=>e.Ta.get(t) || null,
        lt: ()=>e.datastore.serializer.databaseId
    }), $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).start(), e.Aa.aa();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && !$70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).M_() && e.Ta.size > 0;
}
function $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $70fd6868680e912c$var$__PRIVATE_debugCast(e).Ia.size;
}
function $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.Ra = void 0;
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.Aa.set("Online" /* OnlineState.Online */ );
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamOpen(e) {
    e.Ta.forEach((t, n)=>{
        $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamClose(e, t) {
    $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) ? (e.Aa.la(t), $70fd6868680e912c$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.Aa.set("Unknown" /* OnlineState.Unknown */ );
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.Aa.set("Online" /* OnlineState.Online */ ), t instanceof $70fd6868680e912c$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.Ta.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.Ta.delete(r), e.Ra.removeTarget(r));
        }(e, t);
    } catch (n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Xt, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange ? e.Ra.Ye(t) : t instanceof $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange ? e.Ra.it(t) : e.Ra.et(t), !n.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) try {
        const t = await $70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.Ra.Pt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ta.get(r);
                    // A watched target might have been removed already.
                    i && e.Ta.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ta.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ta.set(t, r.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $70fd6868680e912c$var$TargetData(r.target, t, n, r.sequenceNumber);
                $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Xt, "Failed to raise snapshot:", t), await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.Ia.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(e), e.Aa.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Xt, "Retrying IndexedDB access"), await n(), e.Ia.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e), n = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(t);
    let r = t.Pa.length > 0 ? t.Pa[t.Pa.length - 1].batchId : $70fd6868680e912c$var$G;
    for(; $70fd6868680e912c$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Pa.length && n.B_();
            break;
        }
        r = e.batchId, $70fd6868680e912c$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(t) && $70fd6868680e912c$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $70fd6868680e912c$var$__PRIVATE_canAddToWritePipeline(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && e.Pa.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $70fd6868680e912c$var$__PRIVATE_addToWritePipeline(e, t) {
    e.Pa.push(t);
    const n = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e);
    n.x_() && n.Z_ && n.X_(t.mutations);
}
function $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && !$70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).M_() && e.Pa.length > 0;
}
function $70fd6868680e912c$var$__PRIVATE_startWriteStream(e) {
    $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteStreamOpen(e) {
    $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).na();
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Pa)t.X_(n.mutations);
}
async function $70fd6868680e912c$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.Pa.shift(), i = $70fd6868680e912c$var$MutationBatchResult.from(r, t, n);
    await $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e);
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).Z_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $70fd6868680e912c$var$__PRIVATE_isPermanentError(e) && e !== $70fd6868680e912c$var$N.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Pa.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).N_(), await $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(e) && $70fd6868680e912c$var$__PRIVATE_startWriteStream(e);
}
async function $70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Xt, "RemoteStore received new credentials");
    const r = $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.Ia.add(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.Aa.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.Ia.delete(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    t ? (n.Ia.delete(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.Ia.add(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(n), n.Aa.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e) {
    return e.Va || // Create stream (but note that it is not started yet).
    (e.Va = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        return r.ia(), new $70fd6868680e912c$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: $70fd6868680e912c$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        e_: $70fd6868680e912c$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        n_: $70fd6868680e912c$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        J_: $70fd6868680e912c$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.da.push(async (t)=>{
        t ? (e.Va.N_(), $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) ? $70fd6868680e912c$var$__PRIVATE_startWatchStream(e) : e.Aa.set("Unknown" /* OnlineState.Unknown */ )) : (await e.Va.stop(), $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.Va;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e) {
    return e.ma || // Create stream (but note that it is not started yet).
    (e.ma = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        return r.ia(), new $70fd6868680e912c$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: ()=>Promise.resolve(),
        e_: $70fd6868680e912c$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        n_: $70fd6868680e912c$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        ea: $70fd6868680e912c$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        ta: $70fd6868680e912c$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.da.push(async (t)=>{
        t ? (e.ma.N_(), // This will start the write stream if necessary.
        await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e)) : (await e.ma.stop(), e.Pa.length > 0 && ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Xt, `Stopping write stream with ${e.Pa.length} pending writes`), e.Pa = []));
    })), e.ma;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $70fd6868680e912c$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $70fd6868680e912c$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $70fd6868680e912c$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($70fd6868680e912c$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $70fd6868680e912c$var$DocumentSet {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $70fd6868680e912c$var$DocumentSet(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $70fd6868680e912c$var$documentMap(), this.sortedSet = new $70fd6868680e912c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $70fd6868680e912c$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $70fd6868680e912c$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.fa = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.fa.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.fa = this.fa.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.fa = this.fa.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.fa = this.fa.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.fa = this.fa.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.fa = this.fa.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.fa = this.fa.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.fa = this.fa.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $70fd6868680e912c$var$fail(63341, {
            At: e,
            ga: n
        }) : this.fa = this.fa.insert(t, e);
    }
    pa() {
        const e = [];
        return this.fa.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $70fd6868680e912c$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $70fd6868680e912c$var$ViewSnapshot(e, t, $70fd6868680e912c$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $70fd6868680e912c$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.ya = void 0, this.wa = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    Sa() {
        return this.wa.some((e)=>e.ba());
    }
}
class $70fd6868680e912c$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Da = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.wa)e.onError(t);
            });
        }(this, new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.ABORTED, "Firestore shutting down"));
    }
}
function $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap() {
    return new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyQuery(e), $70fd6868680e912c$var$__PRIVATE_queryEquals);
}
async function $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.Sa() && t.ba() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $70fd6868680e912c$var$__PRIVATE_QueryListenersInfo, r = t.ba() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.ya = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.ya = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$70fd6868680e912c$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.wa.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.va(n.onlineState), s.ya) t.Ca(s.ya) && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.wa.indexOf(t);
        e >= 0 && (s.wa.splice(e, 1), 0 === s.wa.length ? i = t.ba() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.Sa() && t.ba() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.wa)t.Ca(e) && (r = !0);
            i.ya = e;
        }
    }
    r && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.wa)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Da.forEach((e)=>{
        e.next();
    });
}
var $70fd6868680e912c$var$en, $70fd6868680e912c$var$tn;
/** Listen to both cache and server changes */ ($70fd6868680e912c$var$tn = $70fd6868680e912c$var$en || ($70fd6868680e912c$var$en = {})).Fa = "default", /** Listen to changes in cache only */ $70fd6868680e912c$var$tn.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.Ma = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.xa = !1, this.Oa = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Ca(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $70fd6868680e912c$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.xa ? this.Na(e) && (this.Ma.next(e), t = !0) : this.Ba(e, this.onlineState) && (this.La(e), t = !0), this.Oa = e, t;
    }
    onError(e) {
        this.Ma.error(e);
    }
    /** Returns whether a snapshot was raised. */ va(e) {
        this.onlineState = e;
        let t = !1;
        return this.Oa && !this.xa && this.Ba(this.Oa, e) && (this.La(this.Oa), t = !0), t;
    }
    Ba(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.ba()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.ka || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Na(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.Oa && this.Oa.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    La(e) {
        e = $70fd6868680e912c$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.xa = !0, this.Ma.next(e);
    }
    ba() {
        return this.options.source !== $70fd6868680e912c$var$en.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $70fd6868680e912c$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.qa = e, this.byteLength = t;
    }
    Qa() {
        return "metadata" in this.qa;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Qs(e) {
        return $70fd6868680e912c$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ $s(e) {
        return e.metadata.exists ? $70fd6868680e912c$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $70fd6868680e912c$var$MutableDocument.newNoDocument(this.Qs(e.metadata.name), this.Us(e.metadata.readTime));
    }
    Us(e) {
        return $70fd6868680e912c$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleLoader {
    constructor(e, t){
        this.$a = e, this.serializer = t, /** Batched queries to be saved into storage */ this.Ua = [], /** Batched documents to be saved into storage */ this.Ka = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.Ua;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.Ka;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Wa(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.qa.namedQuery) this.Ua.push(e.qa.namedQuery);
        else if (e.qa.documentMetadata) {
            this.Ka.push({
                metadata: e.qa.documentMetadata
            }), e.qa.documentMetadata.exists || ++t;
            const n = $70fd6868680e912c$var$ResourcePath.fromString(e.qa.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.qa.document && (this.Ka[this.Ka.length - 1].document = e.qa.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
    }
    Ga(e) {
        const t = new Map, n = new $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Qs(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $70fd6868680e912c$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async za(e) {
        const t = await $70fd6868680e912c$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl(this.serializer), this.Ka, this.$a.id), n = this.Ga(this.documents);
        for (const t of this.Ua)await $70fd6868680e912c$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            ja: this.collectionGroups,
            Ja: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $70fd6868680e912c$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Ha = t, this.Ya = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Za = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.Xa = $70fd6868680e912c$var$__PRIVATE_newQueryComparator(e), this.eu = new $70fd6868680e912c$var$DocumentSet(this.Xa);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get tu() {
        return this.Ha;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ nu(e, t) {
        const n = t ? t.ru : new $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet, r = t ? t.eu : this.eu;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $70fd6868680e912c$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.iu(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.Xa(c, _) > 0 || a && this.Xa(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            eu: s,
            ru: n,
            Ds: o,
            mutatedKeys: i
        };
    }
    iu(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.eu;
        this.eu = e.eu, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.ru.pa();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $70fd6868680e912c$var$fail(20277, {
                                At: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Xa(e.doc, t.doc)), this.su(n), r = null != r && r;
        const o = t && !r ? this.ou() : [], _ = 0 === this.Za.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.Ya;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Ya = _, 0 !== s.length || a) return {
            snapshot: new $70fd6868680e912c$var$ViewSnapshot(this.query, e.eu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            _u: o
        };
        // no changes
        return {
            _u: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ va(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            eu: this.eu,
            ru: new $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Ds: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            _u: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ au(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Ha.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.eu.has(e) && !this.eu.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ su(e) {
        e && (e.addedDocuments.forEach((e)=>this.Ha = this.Ha.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Ha = this.Ha.delete(e)), this.current = e.current);
    }
    ou() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Za;
        this.Za = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.eu.forEach((e)=>{
            this.au(e.key) && (this.Za = this.Za.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Za.has(e) || t.push(new $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Za.forEach((n)=>{
            e.has(n) || t.push(new $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    uu(e) {
        this.Ha = e.qs, this.Za = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        const t = this.nu(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    cu() {
        return $70fd6868680e912c$var$ViewSnapshot.fromInitialDocuments(this.query, this.eu, this.mutatedKeys, 0 /* SyncState.Local */  === this.Ya, this.hasCachedResults);
    }
}
const $70fd6868680e912c$var$nn = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $70fd6868680e912c$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.lu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.hu = {}, this.Pu = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyQuery(e), $70fd6868680e912c$var$__PRIVATE_queryEquals), this.Tu = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Iu = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.du = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Eu = new Map, this.Au = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.Ru = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Vu = new Map, this.mu = $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator.ur(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.fu = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.fu;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.Pu.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.cu()) : i = await $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    await $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.gu = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.nu(n);
            i.Ds && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.nu(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _._u), _.snapshot;
        })(e, t, n, r);
    const s = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $70fd6868680e912c$var$__PRIVATE_View(t, s.qs), _ = o.nu(s.documents), a = $70fd6868680e912c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, n, u._u);
    const c = new $70fd6868680e912c$var$__PRIVATE_QueryView(t, n, o);
    return e.Pu.set(t, c), e.Tu.has(n) ? e.Tu.get(n).push(t) : e.Tu.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.Pu.get(t), s = r.Tu.get(i.targetId);
    if (s.length > 1) return r.Tu.set(i.targetId, s.filter((e)=>!$70fd6868680e912c$var$__PRIVATE_queryEquals(e, t))), void r.Pu.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.Pu.get(t), i = n.Tu.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), a = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                return n.Os.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $70fd6868680e912c$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e.key, t, $70fd6868680e912c$var$__PRIVATE_extractFieldMask(t.value.mapValue), $70fd6868680e912c$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.Ru[e.currentUser.toKey()];
            r || (r = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.Ru[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Eu.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.lu = !0 : e.modifiedDocuments.size > 0 ? $70fd6868680e912c$var$__PRIVATE_hardAssert(r.lu, 14607) : e.removedDocuments.size > 0 && ($70fd6868680e912c$var$__PRIVATE_hardAssert(r.lu, 42227), r.lu = !1));
        }), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Pu.forEach((n, r)=>{
            const i = r.view.va(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.wa)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.va(t) && (r = !0);
            }), r && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.hu.J_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Eu.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $70fd6868680e912c$var$MutableDocument.newNoDocument(s, $70fd6868680e912c$var$SnapshotVersion.min()));
        const n = $70fd6868680e912c$var$__PRIVATE_documentKeySet().add(s), i = new $70fd6868680e912c$var$RemoteEvent($70fd6868680e912c$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), e, n);
        await $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.du = r.du.remove(s), r.Eu.delete(t), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $70fd6868680e912c$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $70fd6868680e912c$var$__PRIVATE_processUserCallback(r, t, n), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n.remoteStore) || $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$nn, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $70fd6868680e912c$var$G) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.Vu.get(e) || [];
        r.push(t), n.Vu.set(e, r);
    } catch (e) {
        const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Vu.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.Vu.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $70fd6868680e912c$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let i = r.Ru[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Ru[r.currentUser.toKey()] = i;
    }
}
function $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Tu.get(t))e.Pu.delete(r), n && e.hu.pu(r, n);
    if (e.Tu.delete(t), e.isPrimaryClient) e.Au.zr(t).forEach((t)=>{
        e.Au.containsKey(t) || // We removed the last reference for this key
        $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Iu.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.du.get(t);
    null !== n && ($70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.du = e.du.remove(t), e.Eu.delete(n), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument) e.Au.addReference(r.key, t), $70fd6868680e912c$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$nn, "Document no longer in limbo: " + r.key), e.Au.removeReference(r.key, t);
        e.Au.containsKey(r.key) || // We removed the last reference for this key
        $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $70fd6868680e912c$var$fail(19791, {
        yu: r
    });
}
function $70fd6868680e912c$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.du.get(n) || e.Iu.has(r) || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$nn, "New document in limbo: " + n), e.Iu.add(r), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Iu.size > 0 && e.du.size < e.maxConcurrentLimboResolutions;){
        const t = e.Iu.values().next().value;
        e.Iu.delete(t);
        const n = new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(t)), r = e.mu.next();
        e.Eu.set(r, new $70fd6868680e912c$var$LimboResolution(n)), e.du = e.du.insert(n, r), $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $70fd6868680e912c$var$TargetData($70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $70fd6868680e912c$var$__PRIVATE_ListenSequence.ue));
    }
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Pu.isEmpty() || (r.Pu.forEach((e, _)=>{
        o.push(r.gu(_, t, n).then((e)=>{
            var t;
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const i = e ? !e.fromCache : null === (t = null == n ? void 0 : n.targetChanges.get(_.targetId)) || void 0 === t ? void 0 : t.current;
                r.sharedClientState.updateQueryState(_.targetId, i ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $70fd6868680e912c$var$__PRIVATE_LocalViewChanges.Es(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.hu.J_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t.Is, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$70fd6868680e912c$var$PersistencePromise.forEach(t.ds, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Qt, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.Fs.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.Fs = n.Fs.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$nn, "User change. New user:", t.toKey());
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.Vu.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.CANCELLED, t));
                });
            }), e.Vu.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Bs);
    }
}
function $70fd6868680e912c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.Eu.get(t);
    if (r && r.lu) return $70fd6868680e912c$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        const r = n.Tu.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Pu.get(t);
            e = e.unionWith(r.view.tu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $70fd6868680e912c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.uu(r);
    return n.isPrimaryClient && $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i._u), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Xn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $70fd6868680e912c$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($70fd6868680e912c$var$__PRIVATE_processUserCallback(i, t, r || null), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $70fd6868680e912c$var$__PRIVATE_debugCast($70fd6868680e912c$var$__PRIVATE_debugCast(e).mutationQueue).rr(t);
    }(i.localStore, t)) : $70fd6868680e912c$var$fail(6720, "Unknown batchState", {
        wu: n
    }), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$nn, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if ($70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(n), $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.fu) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.fu = !0, await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$70fd6868680e912c$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.fu) {
        const e = [];
        let t = Promise.resolve();
        n.Tu.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(n, i), $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            t.Eu.forEach((e, n)=>{
                $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Au.jr(), t.Eu = new Map, t.du = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(n), n.fu = !1, await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Tu.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $70fd6868680e912c$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Pu.get(e), n = await $70fd6868680e912c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.hu.J_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $70fd6868680e912c$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $70fd6868680e912c$var$__PRIVATE_debugCast($70fd6868680e912c$var$__PRIVATE_debugCast(e).persistence).Ps();
    }($70fd6868680e912c$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (i.fu) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$nn, "Ignoring unexpected query state notification.");
    const s = i.Tu.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(s[0])), r = $70fd6868680e912c$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $70fd6868680e912c$var$fail(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.fu) {
        for (const e of t){
            if (r.Tu.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$nn, "Adding an already active target " + e);
                continue;
            }
            const t = await $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Tu.has(e) && // Release queries that are still active.
        await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $70fd6868680e912c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $70fd6868680e912c$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.hu.J_ = $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.hu.pu = $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $70fd6868680e912c$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $70fd6868680e912c$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $70fd6868680e912c$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Ti.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $70fd6868680e912c$var$__PRIVATE_BundleLoader(r, t.serializer);
            let s = await t.Su();
            for(; s;){
                const e = await i.Wa(s);
                e && n._updateProgress(e), s = await t.Su();
            }
            const o = await i.za(e.localStore);
            return await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ja, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Ti.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.ja);
        } catch (e) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$nn, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $70fd6868680e912c$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.bu(e), this.persistence = this.Du(e), await this.persistence.start(), this.localStore = this.vu(e), this.gcScheduler = this.Cu(e, this.localStore), this.indexBackfillerScheduler = this.Fu(e, this.localStore);
    }
    Cu(e, t) {
        return null;
    }
    Fu(e, t) {
        return null;
    }
    vu(e) {
        return $70fd6868680e912c$var$__PRIVATE_newLocalStore(this.persistence, new $70fd6868680e912c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Du(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence($70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer);
    }
    bu(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        var e, t;
        null === (e = this.gcScheduler) || void 0 === e || e.stop(), null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: ()=>new $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider
};
class $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Cu(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Du(e) {
        const t = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$LruParams.DEFAULT;
        return new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence((e)=>$70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate.Vi(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.Mu = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Mu.initialize(this, e), // Enqueue writes from a previous session
        await $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Mu.syncEngine), await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(this.Mu.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ji(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    vu(e) {
        return $70fd6868680e912c$var$__PRIVATE_newLocalStore(this.persistence, new $70fd6868680e912c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Cu(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Fu(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $70fd6868680e912c$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Du(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$LruParams.DEFAULT;
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $70fd6868680e912c$var$__PRIVATE_getWindow(), $70fd6868680e912c$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    bu(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.Mu = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Mu.syncEngine;
        this.sharedClientState instanceof $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Do: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            vo: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Co: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            Ps: $70fd6868680e912c$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            bo: $70fd6868680e912c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ji(async (e)=>{
            await $70fd6868680e912c$var$__PRIVATE_syncEngineApplyPrimaryState(this.Mu.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    bu(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_getWindow();
        if (!$70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState.C(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $70fd6868680e912c$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $70fd6868680e912c$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $70fd6868680e912c$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $70fd6868680e912c$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $70fd6868680e912c$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $70fd6868680e912c$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor.C() ? new $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor : new $70fd6868680e912c$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $70fd6868680e912c$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.fu = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        var e, t;
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Xt, "RemoteStore shutting down."), t.Ia.add(5 /* OfflineCause.Shutdown */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), t.Ea.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.Aa.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), null === (e = this.datastore) || void 0 === e || e.terminate(), null === (t = this.eventManager) || void 0 === t || t.terminate();
    }
}
$70fd6868680e912c$var$OnlineComponentProvider.provider = {
    build: ()=>new $70fd6868680e912c$var$OnlineComponentProvider
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $70fd6868680e912c$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.xu(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.xu(this.observer.error, e) : $70fd6868680e912c$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Ou() {
        this.muted = !0;
    }
    xu(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Nu = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $70fd6868680e912c$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Bu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.Lu().then((e)=>{
            e && e.Qa() ? this.metadata.resolve(e.qa.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.qa)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Nu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Su() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.Lu();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async Lu() {
        const e = await this.ku();
        if (null === e) return null;
        const t = this.Bu.decode(e), n = Number(t);
        isNaN(n) && this.qu(`length string (${t}) is not valid number`);
        const r = await this.Qu(n);
        return new $70fd6868680e912c$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ $u() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async ku() {
        for(; this.$u() < 0;){
            if (await this.Uu()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.$u();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.qu("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Qu(e) {
        for(; this.buffer.length < e;)await this.Uu() && this.qu("Reached the end of bundle when more is expected.");
        const t = this.Bu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    qu(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Nu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Uu() {
        const e = await this.Nu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.Su();
        if (!n || !n.Qa()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(null == n ? void 0 : n.qa)}`);
        this.metadata = n;
        do n = this.Su(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ Ku() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ Su() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.ku(), t = this.Qu(e);
        return new $70fd6868680e912c$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length how many characters to read.
     * @returns a string parsed from the bundle.
     */ Qu(e) {
        if (this.cursor + e > this.bundleData.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ ku() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $70fd6868680e912c$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$70fd6868680e912c$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.Jo("BatchGetDocuments", n.serializer.databaseId, $70fd6868680e912c$var$ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t, 55234, {
                    key: e
                }), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $70fd6868680e912c$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$70fd6868680e912c$var$toMutation(n.serializer, e))
            };
            await n.Wo("Commit", n.serializer.databaseId, $70fd6868680e912c$var$ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $70fd6868680e912c$var$fail(50498, {
                Wu: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $70fd6868680e912c$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? $70fd6868680e912c$var$Precondition.exists(!1) : $70fd6868680e912c$var$Precondition.updateTime(t) : $70fd6868680e912c$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $70fd6868680e912c$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $70fd6868680e912c$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $70fd6868680e912c$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Gu = n.maxAttempts, this.F_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ zu() {
        this.Gu -= 1, this.ju();
    }
    ju() {
        this.F_.g_(async ()=>{
            const e = new $70fd6868680e912c$var$Transaction$2(this.datastore), t = this.Ju(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Hu(e);
                    }));
            }).catch((e)=>{
                this.Hu(e);
            });
        });
    }
    Ju(e) {
        try {
            const t = this.updateFunction(e);
            return !$70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Hu(e) {
        this.Gu > 0 && this.Yu(e) ? (this.Gu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.ju(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Yu(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$70fd6868680e912c$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$rn = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $70fd6868680e912c$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $70fd6868680e912c$var$User.UNAUTHENTICATED, this.clientId = $70fd6868680e912c$export$253bcaa5572dcc83.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), t.persistence.setDatabaseDeletedListener(()=>{
        $70fd6868680e912c$export$86cd73f49cc6e0bb("Terminating Firestore due to IndexedDb database deletion"), e.terminate().then(()=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("Terminating Firestore due to IndexedDb database deletion completed successfully");
        }).catch((e)=>{
            $70fd6868680e912c$export$86cd73f49cc6e0bb("Terminating Firestore due to IndexedDb database deletion failed", e);
        });
    }), e._offlineComponents = t;
}
async function $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e);
    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Using user provided OfflineComponentProvider");
            try {
                await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $70fd6868680e912c$var$N.FAILED_PRECONDITION || e.code === $70fd6868680e912c$var$N.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $70fd6868680e912c$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, new $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider);
            }
        } else $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Using default OfflineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    }
    return e._offlineComponents;
}
async function $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Using user provided OnlineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$rn, "Using default OnlineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, new $70fd6868680e912c$var$OnlineComponentProvider))), e._onlineComponents;
}
function $70fd6868680e912c$var$__PRIVATE_getPersistence(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $70fd6868680e912c$var$__PRIVATE_getLocalStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $70fd6868680e912c$var$__PRIVATE_getDatastore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $70fd6868680e912c$var$__PRIVATE_getEventManager(e) {
    const t = await $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $70fd6868680e912c$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $70fd6868680e912c$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $70fd6868680e912c$var$__PRIVATE_getPersistence(e), n = await $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return t.Ia.delete(0 /* OfflineCause.UserDisabled */ ), $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $70fd6868680e912c$var$__PRIVATE_getPersistence(e), n = await $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            t.Ia.add(0 /* OfflineCause.UserDisabled */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.Aa.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Ou(), t.enqueueAndForget(()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $70fd6868680e912c$var$__PRIVATE_QueryListener($70fd6868680e912c$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                ka: !0
            });
            return $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $70fd6868680e912c$var$__PRIVATE_View(t, r.qs), s = i.nu(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Ou(), t.enqueueAndForget(()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $70fd6868680e912c$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                ka: !0
            });
            return $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $70fd6868680e912c$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                var r;
                const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e), { request: s, ft: o, parent: _ } = $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(i.serializer, $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(t), n);
                i.connection.Qo || delete s.parent;
                const a = (await i.Jo("RunAggregationQuery", i.serializer.databaseId, _, s, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === a.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                return Object.keys(u).reduce((e, t)=>(e[o[t]] = u[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $70fd6868680e912c$var$__PRIVATE_debugCast(e).Da.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Ou(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $70fd6868680e912c$var$__PRIVATE_debugCast(e).Da.delete(t);
            })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $70fd6868680e912c$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $70fd6868680e912c$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $70fd6868680e912c$var$__PRIVATE_syncEngineLoadBundle(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Ti.getNamedQuery(e, t));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_createBundleReaderSync(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $70fd6868680e912c$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $70fd6868680e912c$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(i)));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $70fd6868680e912c$var$__PRIVATE_debugCast(e).Cs.Rs = t;
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$sn = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $70fd6868680e912c$var$on = "firestore.googleapis.com", $70fd6868680e912c$var$_n = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $70fd6868680e912c$var$FirestoreSettingsImpl {
    constructor(e){
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $70fd6868680e912c$var$on, this.ssl = $70fd6868680e912c$var$_n;
        } else this.host = e.host, this.ssl = null !== (t = e.ssl) && void 0 !== t ? t : $70fd6868680e912c$var$_n;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $70fd6868680e912c$var$Mt;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $70fd6868680e912c$var$Ot) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $70fd6868680e912c$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $70fd6868680e912c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $70fd6868680e912c$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $70fd6868680e912c$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $70fd6868680e912c$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $70fd6868680e912c$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $70fd6868680e912c$var$sn.get(e);
            t && ($70fd6868680e912c$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $70fd6868680e912c$var$sn.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $70fd6868680e912c$export$966a03d25297d115(e, t, n, r = {}) {
    var i;
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$var$Firestore$1);
    const s = (0, $gMVVg.isCloudWorkstation)(t), o = e._getSettings(), _ = Object.assign(Object.assign({}, o), {
        emulatorOptions: e._getEmulatorOptions()
    }), a = `${t}:${n}`;
    s && ((0, $gMVVg.pingServer)(`https://${a}`), (0, $gMVVg.updateEmulatorBanner)("Firestore", !0)), o.host !== $70fd6868680e912c$var$on && o.host !== a && $70fd6868680e912c$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const u = Object.assign(Object.assign({}, o), {
        host: a,
        ssl: s,
        emulatorOptions: r
    });
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $gMVVg.deepEqual)(u, _) && (e._setSettings(u), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $70fd6868680e912c$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $gMVVg.createMockUserToken)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $70fd6868680e912c$var$User(s);
        }
        e._authCredentials = new $70fd6868680e912c$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $70fd6868680e912c$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $70fd6868680e912c$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $70fd6868680e912c$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $70fd6868680e912c$export$6be62b059fb12175._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($70fd6868680e912c$var$__PRIVATE_validateJSON(t, $70fd6868680e912c$export$6be62b059fb12175._jsonSchema)) return new $70fd6868680e912c$export$6be62b059fb12175(e, n || null, new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(t.referencePath)));
    }
}
$70fd6868680e912c$export$6be62b059fb12175._jsonSchemaVersion = "firestore/documentReference/1.0", $70fd6868680e912c$export$6be62b059fb12175._jsonSchema = {
    type: $70fd6868680e912c$var$property("string", $70fd6868680e912c$export$6be62b059fb12175._jsonSchemaVersion),
    referencePath: $70fd6868680e912c$var$property("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $70fd6868680e912c$export$ab5a1a47940a200e extends $70fd6868680e912c$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $70fd6868680e912c$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $70fd6868680e912c$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $gMVVg.getModularInstance)(e), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $70fd6868680e912c$var$Firestore$1) {
        const r = $70fd6868680e912c$var$ResourcePath.fromString(t, ...n);
        return $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(r), new $70fd6868680e912c$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($70fd6868680e912c$var$ResourcePath.fromString(t, ...n));
        return $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(r), new $70fd6868680e912c$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $70fd6868680e912c$export$473d82a73f88c107(e, t) {
    if (e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$var$Firestore$1), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $70fd6868680e912c$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $70fd6868680e912c$var$__PRIVATE_QueryImpl($70fd6868680e912c$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $70fd6868680e912c$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $gMVVg.getModularInstance)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $70fd6868680e912c$export$253bcaa5572dcc83.newId()), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $70fd6868680e912c$var$Firestore$1) {
        const r = $70fd6868680e912c$var$ResourcePath.fromString(t, ...n);
        return $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(r), new $70fd6868680e912c$export$6be62b059fb12175(e, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($70fd6868680e912c$var$ResourcePath.fromString(t, ...n));
        return $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(r), new $70fd6868680e912c$export$6be62b059fb12175(e.firestore, e instanceof $70fd6868680e912c$export$ab5a1a47940a200e ? e.converter : null, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$62a32f2da6187d11(e, t) {
    return e = (0, $gMVVg.getModularInstance)(e), t = (0, $gMVVg.getModularInstance)(t), (e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && (t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $gMVVg.getModularInstance)(e), t = (0, $gMVVg.getModularInstance)(t), e instanceof $70fd6868680e912c$export$62297b13309008b2 && t instanceof $70fd6868680e912c$export$62297b13309008b2 && e.firestore === t.firestore && $70fd6868680e912c$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$an = "AsyncQueue";
class $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Zu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Xu = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.ec = [], // visible for testing
        this.tc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.nc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.rc = !1, // List of TimerIds to fast-forward delays for.
        this.sc = [], // Backoff timer used to schedule retries for retryable operations
        this.F_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.oc = ()=>{
            const e = $70fd6868680e912c$var$getDocument();
            e && $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$an, "Visibility state changed to " + e.visibilityState), this.F_.y_();
        }, this._c = e;
        const t = $70fd6868680e912c$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.oc);
    }
    get isShuttingDown() {
        return this.Xu;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.ac(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.uc(e);
    }
    enterRestrictedMode(e) {
        if (!this.Xu) {
            this.Xu = !0, this.rc = e || !1;
            const t = $70fd6868680e912c$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.oc);
        }
    }
    enqueue(e) {
        if (this.ac(), this.Xu) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return this.uc(()=>this.Xu && this.rc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Zu.push(e), this.cc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async cc() {
        if (0 !== this.Zu.length) {
            try {
                await this.Zu[0](), this.Zu.shift(), this.F_.reset();
            } catch (e) {
                if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$an, "Operation failed with retryable error: " + e);
            }
            this.Zu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.F_.g_(()=>this.cc());
        }
    }
    uc(e) {
        const t = this._c.then(()=>(this.nc = !0, e().catch((e)=>{
                this.tc = e, this.nc = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $70fd6868680e912c$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $70fd6868680e912c$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.nc = !1, e))));
        return this._c = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.ac(), // Fast-forward delays for timerIds that have been overridden.
        this.sc.indexOf(e) > -1 && (t = 0);
        const r = $70fd6868680e912c$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.lc(e));
        return this.ec.push(r), r;
    }
    ac() {
        this.tc && $70fd6868680e912c$var$fail(47125, {
            hc: $70fd6868680e912c$var$__PRIVATE_getMessageOrStack(this.tc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async Pc() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this._c, await e;
        while (e !== this._c);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Tc(e) {
        for (const t of this.ec)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Ic(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Pc().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.ec.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.ec)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.Pc();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ dc(e) {
        this.sc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ lc(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.ec.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.ec.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $70fd6868680e912c$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $70fd6868680e912c$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $70fd6868680e912c$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $70fd6868680e912c$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $70fd6868680e912c$export$d0e2b3272814ce82 extends $70fd6868680e912c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $70fd6868680e912c$export$9061557f3e3b42f9(e, t, n) {
    n || (n = $70fd6868680e912c$var$ut);
    const r = (0, $7xvHX._getProvider)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $gMVVg.deepEqual)(i, t)) return e;
        throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $70fd6868680e912c$var$Ot) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $gMVVg.isCloudWorkstation)(t.host) && (0, $gMVVg.pingServer)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $70fd6868680e912c$export$f06a05d14c3a6678(e, n) {
    const r = "object" == typeof e ? e : (0, $7xvHX.getApp)(), i = "string" == typeof e ? e : n || $70fd6868680e912c$var$ut, s = (0, $7xvHX._getProvider)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $gMVVg.getDefaultEmulatorHostnameAndPort)("firestore");
        e && $70fd6868680e912c$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $70fd6868680e912c$export$8da5fbea04405656(e) {
    if (e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $70fd6868680e912c$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $70fd6868680e912c$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $70fd6868680e912c$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams, r.isUsingEmulator);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._componentsProvider || (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._componentsProvider = {
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    }), e._firestoreClient = new $70fd6868680e912c$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = null == e ? void 0 : e._online.build();
        return {
            _offline: null == e ? void 0 : e._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $70fd6868680e912c$export$cebe3b626a79c5f3(e, t) {
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, $70fd6868680e912c$var$OnlineComponentProvider.provider, {
        build: (e)=>new $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, null == t ? void 0 : t.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $70fd6868680e912c$export$6d4c055e91302ab9(e) {
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, $70fd6868680e912c$var$OnlineComponentProvider.provider, {
        build: (e)=>new $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82))._firestoreClient || e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $70fd6868680e912c$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $70fd6868680e912c$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$70fd6868680e912c$var$__PRIVATE_SimpleDb.C()) return Promise.resolve();
                const t = e + $70fd6868680e912c$var$qt;
                await $70fd6868680e912c$var$__PRIVATE_SimpleDb.delete(t);
            }($70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $70fd6868680e912c$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $70fd6868680e912c$export$ee6bdee8287ecc5f(e) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientEnableNetwork($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $70fd6868680e912c$export$f35b708ad73d52eb(e) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientDisableNetwork($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $70fd6868680e912c$export$9aff22d1ec357a14(e) {
    return (0, $7xvHX._removeServiceInstance)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $70fd6868680e912c$export$4b8b93c690c9810b(e, t) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), r = new $70fd6868680e912c$export$6cac12425252ec14;
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $70fd6868680e912c$export$169d2c6fe0f7f4ea(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetNamedQuery($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), t).then((t)=>t ? new $70fd6868680e912c$export$62297b13309008b2(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $70fd6868680e912c$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(e = "count", t){
        this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $70fd6868680e912c$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $70fd6868680e912c$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $70fd6868680e912c$export$9f55f2e2bf8c2fc1._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($70fd6868680e912c$var$__PRIVATE_validateJSON(e, $70fd6868680e912c$export$9f55f2e2bf8c2fc1._jsonSchema)) return $70fd6868680e912c$export$9f55f2e2bf8c2fc1.fromBase64String(e.bytes);
    }
}
$70fd6868680e912c$export$9f55f2e2bf8c2fc1._jsonSchemaVersion = "firestore/bytes/1.0", $70fd6868680e912c$export$9f55f2e2bf8c2fc1._jsonSchema = {
    type: $70fd6868680e912c$var$property("string", $70fd6868680e912c$export$9f55f2e2bf8c2fc1._jsonSchemaVersion),
    bytes: $70fd6868680e912c$var$property("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $70fd6868680e912c$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $70fd6868680e912c$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $70fd6868680e912c$export$bf6e62266977b8eb() {
    return new $70fd6868680e912c$export$a1a8fea822d17659($70fd6868680e912c$var$B);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $70fd6868680e912c$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $70fd6868680e912c$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $70fd6868680e912c$export$f9f719d1b6419c4._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($70fd6868680e912c$var$__PRIVATE_validateJSON(e, $70fd6868680e912c$export$f9f719d1b6419c4._jsonSchema)) return new $70fd6868680e912c$export$f9f719d1b6419c4(e.latitude, e.longitude);
    }
}
$70fd6868680e912c$export$f9f719d1b6419c4._jsonSchemaVersion = "firestore/geoPoint/1.0", $70fd6868680e912c$export$f9f719d1b6419c4._jsonSchema = {
    type: $70fd6868680e912c$var$property("string", $70fd6868680e912c$export$f9f719d1b6419c4._jsonSchemaVersion),
    latitude: $70fd6868680e912c$var$property("number"),
    longitude: $70fd6868680e912c$var$property("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 *
 * @class VectorValue
 */ class $70fd6868680e912c$export$994bb3d317350b37 {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $70fd6868680e912c$export$994bb3d317350b37._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($70fd6868680e912c$var$__PRIVATE_validateJSON(e, $70fd6868680e912c$export$994bb3d317350b37._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $70fd6868680e912c$export$994bb3d317350b37(e.vectorValues);
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$70fd6868680e912c$export$994bb3d317350b37._jsonSchemaVersion = "firestore/vectorValue/1.0", $70fd6868680e912c$export$994bb3d317350b37._jsonSchema = {
    type: $70fd6868680e912c$var$property("string", $70fd6868680e912c$export$994bb3d317350b37._jsonSchemaVersion),
    vectorValues: $70fd6868680e912c$var$property("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$cn = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $70fd6868680e912c$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $70fd6868680e912c$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $70fd6868680e912c$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $70fd6868680e912c$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $70fd6868680e912c$var$fail(40011, {
                Ec: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $70fd6868680e912c$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Ac(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get Ec() {
        return this.settings.Ec;
    }
    /** Returns a new context with the specified settings overwritten. */ Rc(e) {
        return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    Vc(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Rc({
            path: n,
            mc: !1
        });
        return r.fc(e), r;
    }
    gc(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Rc({
            path: n,
            mc: !1
        });
        return r.Ac(), r;
    }
    yc(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.Rc({
            path: void 0,
            mc: !0
        });
    }
    wc(e) {
        return $70fd6868680e912c$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.Sc || !1, this.path, this.settings.bc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    Ac() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.fc(this.path.get(e));
    }
    fc(e) {
        if (0 === e.length) throw this.wc("Document fields must not be empty");
        if ($70fd6868680e912c$var$__PRIVATE_isWrite(this.Ec) && $70fd6868680e912c$var$cn.test(e)) throw this.wc('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $70fd6868680e912c$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $70fd6868680e912c$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ Dc(e, t, n, r = !1) {
        return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl({
            Ec: e,
            methodName: t,
            bc: n,
            path: $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(),
            mc: !1,
            Sc: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $70fd6868680e912c$var$__PRIVATE_newSerializer(e._databaseId);
    return new $70fd6868680e912c$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $70fd6868680e912c$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.Dc(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $70fd6868680e912c$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $70fd6868680e912c$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $70fd6868680e912c$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $70fd6868680e912c$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $70fd6868680e912c$var$ParsedSetData(new $70fd6868680e912c$var$ObjectValue(_), a, u);
}
class $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.Ec) throw 1 /* UserDataSource.Update */  === e.Ec ? e.wc(`${this._methodName}() can only appear at the top level of your update data`) : e.wc(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl({
        Ec: 3 /* UserDataSource.Argument */ ,
        bc: t.settings.bc,
        methodName: e._methodName,
        mc: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $70fd6868680e912c$var$FieldTransform(e.path, new $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$70fd6868680e912c$var$__PRIVATE_parseData(e, t)), r = new $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $70fd6868680e912c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $gMVVg.deepEqual)(this.vc, e.vc);
    }
}
class $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$70fd6868680e912c$var$__PRIVATE_parseData(e, t)), r = new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $70fd6868680e912c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $gMVVg.deepEqual)(this.vc, e.vc);
    }
}
class $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Cc = t;
    }
    _toFieldTransform(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $70fd6868680e912c$var$toNumber(e.serializer, this.Cc));
        return new $70fd6868680e912c$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Cc === e.Cc;
    }
}
/** Parse update data from an update() call. */ function $70fd6868680e912c$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.Dc(1 /* UserDataSource.Update */ , t, n);
    $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $70fd6868680e912c$var$ObjectValue.empty();
    $70fd6868680e912c$var$forEach(r, (e, r)=>{
        const _ = $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $gMVVg.getModularInstance)(r);
        const a = i.gc(_);
        if (r instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $70fd6868680e912c$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $70fd6868680e912c$var$FieldMask(s);
    return new $70fd6868680e912c$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.Dc(1 /* UserDataSource.Update */ , t, n), _ = [
        $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $70fd6868680e912c$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$70fd6868680e912c$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $gMVVg.getModularInstance)(n);
        const r = o.gc(t);
        if (n instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $70fd6868680e912c$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $70fd6868680e912c$var$FieldMask(u);
    return new $70fd6868680e912c$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $70fd6868680e912c$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $70fd6868680e912c$var$__PRIVATE_parseData(n, e.Dc(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $70fd6868680e912c$var$__PRIVATE_parseData(e, t) {
    if ($70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $gMVVg.getModularInstance)(e))) return $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $70fd6868680e912c$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$70fd6868680e912c$var$__PRIVATE_isWrite(t.Ec)) throw t.wc(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.wc(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.mc && 4 /* UserDataSource.ArrayArgument */  !== t.Ec) throw t.wc("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $70fd6868680e912c$var$__PRIVATE_parseData(i, t.yc(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $gMVVg.getModularInstance)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $70fd6868680e912c$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $70fd6868680e912c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $70fd6868680e912c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $70fd6868680e912c$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $70fd6868680e912c$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $70fd6868680e912c$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.wc(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $70fd6868680e912c$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $70fd6868680e912c$export$994bb3d317350b37) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = {
                fields: {
                    [$70fd6868680e912c$var$ct]: {
                        stringValue: $70fd6868680e912c$var$Pt
                    },
                    [$70fd6868680e912c$var$Tt]: {
                        arrayValue: {
                            values: e.toArray().map((e)=>{
                                if ("number" != typeof e) throw t.wc("VectorValues must only contain numeric values.");
                                return $70fd6868680e912c$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: n
            };
        }(e, t);
        throw t.wc(`Unsupported field value: ${$70fd6868680e912c$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $70fd6868680e912c$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $70fd6868680e912c$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $70fd6868680e912c$var$forEach(e, (e, r)=>{
        const i = $70fd6868680e912c$var$__PRIVATE_parseData(r, t.Vc(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430 || e instanceof $70fd6868680e912c$export$f9f719d1b6419c4 || e instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1 || e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d || e instanceof $70fd6868680e912c$export$994bb3d317350b37);
}
function $70fd6868680e912c$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(n) || !$70fd6868680e912c$var$__PRIVATE_isPlainObject(n)) {
        const r = $70fd6868680e912c$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.wc(e + " a custom object") : t.wc(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $gMVVg.getModularInstance)(t)) instanceof $70fd6868680e912c$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $70fd6868680e912c$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $70fd6868680e912c$var$ln = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($70fd6868680e912c$var$ln) >= 0) throw $70fd6868680e912c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $70fd6868680e912c$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $70fd6868680e912c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $70fd6868680e912c$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $70fd6868680e912c$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $70fd6868680e912c$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$var$QueryDocumentSnapshot$1 extends $70fd6868680e912c$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $70fd6868680e912c$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $70fd6868680e912c$export$b0e86f2c7431df4e extends $70fd6868680e912c$var$AppliableConstraint {
}
function $70fd6868680e912c$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $70fd6868680e912c$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $70fd6868680e912c$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $70fd6868680e912c$export$f765fc5789dfd439 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $70fd6868680e912c$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            const a = $70fd6868680e912c$var$FieldFilter.create(i, s, _);
            return a;
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $70fd6868680e912c$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $70fd6868680e912c$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $70fd6868680e912c$export$6bbc7aef0717f3d2 extends $70fd6868680e912c$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $70fd6868680e912c$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $70fd6868680e912c$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(n, e), n = $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $70fd6868680e912c$export$65a9ba8bbd6ed9e3 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $70fd6868680e912c$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new $70fd6868680e912c$var$OrderBy(t, n);
            return r;
        }(e._query, this._field, this._direction);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $70fd6868680e912c$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $70fd6868680e912c$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $70fd6868680e912c$export$49bb5356ca788047 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$ee37e834aaad6f7e(e) {
    return $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber("limit", e), $70fd6868680e912c$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$f823b3589f69d3b8(e) {
    return $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $70fd6868680e912c$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $70fd6868680e912c$export$d92e2830aca1d816 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $70fd6868680e912c$export$859941c5fc8eba6b(...e) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $70fd6868680e912c$export$dd8dee5f7b804673(...e) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $70fd6868680e912c$export$fd1782fd870d1e06 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $70fd6868680e912c$export$57203950645b8b11(...e) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $70fd6868680e912c$export$28ec54a8428bdb3f(...e) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $gMVVg.getModularInstance)(n[0]), n[0] instanceof $70fd6868680e912c$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))if (n.field.isKeyField()) s.push($70fd6868680e912c$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $70fd6868680e912c$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($70fd6868680e912c$var$ResourcePath.fromString(a));
                    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(n)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $70fd6868680e912c$export$afc2e57c475b7810(n);
                    _.push($70fd6868680e912c$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $70fd6868680e912c$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $70fd6868680e912c$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $gMVVg.getModularInstance)(n))) {
        if ("" === n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($70fd6868680e912c$var$ResourcePath.fromString(n));
        if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(r)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $70fd6868680e912c$var$__PRIVATE_refValue(e, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
    if (n instanceof $70fd6868680e912c$export$6be62b059fb12175) return $70fd6868680e912c$var$__PRIVATE_refValue(e, n._key);
    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$70fd6868680e912c$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $70fd6868680e912c$export$f765fc5789dfd439 || t instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($70fd6868680e912c$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $70fd6868680e912c$var$fail(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $70fd6868680e912c$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        var t, n, r;
        const i = null === (r = null === (n = null === (t = e.fields) || void 0 === t ? void 0 : t[$70fd6868680e912c$var$Tt].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.map((e)=>$70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $70fd6868680e912c$export$994bb3d317350b37(i);
    }
    convertGeoPoint(e) {
        return new $70fd6868680e912c$export$f9f719d1b6419c4($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.latitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $70fd6868680e912c$var$ResourcePath.fromString(e);
        $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $70fd6868680e912c$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $70fd6868680e912c$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $70fd6868680e912c$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function $70fd6868680e912c$export$8a63f25cc62965f1(e) {
    return new $70fd6868680e912c$export$fada2345be8928cf("sum", $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $70fd6868680e912c$export$cc6710ee5f037d57(e) {
    return new $70fd6868680e912c$export$fada2345be8928cf("avg", $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $70fd6868680e912c$export$85b9a36db797e02b() {
    return new $70fd6868680e912c$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $70fd6868680e912c$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $70fd6868680e912c$export$fada2345be8928cf && t instanceof $70fd6868680e912c$export$fada2345be8928cf && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $70fd6868680e912c$export$104f59389a332076(e, t) {
    return $70fd6868680e912c$export$49b1d0de6ba30f41(e.query, t.query) && (0, $gMVVg.deepEqual)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$hn = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $70fd6868680e912c$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$export$acab0e6ef25eb301 extends $70fd6868680e912c$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const e = this._document, t = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (t.type = $70fd6868680e912c$export$acab0e6ef25eb301._jsonSchemaVersion, t.bundle = "", t.bundleSource = "DocumentSnapshot", t.bundleName = this._key.toString(), !e || !e.isValidDocument() || !e.isFoundDocument()) return t;
        this._userDataWriter.convertObjectMap(e.data.value.mapValue.fields, "previous");
        return t.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), t;
    }
}
function $70fd6868680e912c$export$bbac1bdeb8972634(e, t, n) {
    if ($70fd6868680e912c$var$__PRIVATE_validateJSON(t, $70fd6868680e912c$export$acab0e6ef25eb301._jsonSchema)) {
        if (t.bundle === $70fd6868680e912c$var$hn) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = $70fd6868680e912c$var$__PRIVATE_newSerializer(e._databaseId), i = $70fd6868680e912c$var$__PRIVATE_createBundleReaderSync(t.bundle, r), s = i.Ku(), o = new $70fd6868680e912c$var$__PRIVATE_BundleLoader(i.getMetadata(), r);
        for (const e of s)o.Wa(e);
        // Ensure that we have the correct number of documents in the bundle.
        const _ = o.documents;
        if (1 !== _.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${_.length} documents.`);
        // Build out the internal document data.
        const a = $70fd6868680e912c$var$__PRIVATE_fromDocument(r, _[0].document), u = new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(t.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $70fd6868680e912c$export$acab0e6ef25eb301(e, new $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter(e), u, a, new $70fd6868680e912c$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $70fd6868680e912c$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $70fd6868680e912c$export$acab0e6ef25eb301._jsonSchema = {
    type: $70fd6868680e912c$var$property("string", $70fd6868680e912c$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: $70fd6868680e912c$var$property("string", "DocumentSnapshot"),
    bundleName: $70fd6868680e912c$var$property("string"),
    bundle: $70fd6868680e912c$var$property("string")
};
class $70fd6868680e912c$export$6d4d04e42af6b03c extends $70fd6868680e912c$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $70fd6868680e912c$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $70fd6868680e912c$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $70fd6868680e912c$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $70fd6868680e912c$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $70fd6868680e912c$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $70fd6868680e912c$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $70fd6868680e912c$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $70fd6868680e912c$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = {};
        e.type = $70fd6868680e912c$export$8f21149d8133945c._jsonSchemaVersion, e.bundleSource = "QuerySnapshot", e.bundleName = $70fd6868680e912c$export$253bcaa5572dcc83.newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const t = [], n = [], r = [];
        return this.docs.forEach((e)=>{
            null !== e._document && (t.push(e._document), n.push(this._userDataWriter.convertObjectMap(e._document.data.value.mapValue.fields, "previous")), r.push(e.ref.path));
        }), e.bundle = (this._firestore, this.query._query, e.bundleName, "NOT SUPPORTED"), e;
    }
}
function $70fd6868680e912c$export$5bed7af38da9d026(e, t, n) {
    if ($70fd6868680e912c$var$__PRIVATE_validateJSON(t, $70fd6868680e912c$export$8f21149d8133945c._jsonSchema)) {
        if (t.bundle === $70fd6868680e912c$var$hn) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = $70fd6868680e912c$var$__PRIVATE_newSerializer(e._databaseId), i = $70fd6868680e912c$var$__PRIVATE_createBundleReaderSync(t.bundle, r), s = i.Ku(), o = new $70fd6868680e912c$var$__PRIVATE_BundleLoader(i.getMetadata(), r);
        for (const e of s)o.Wa(e);
        if (1 !== o.queries.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const _ = $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(o.queries[0].bundledQuery), a = o.documents;
        // Construct the arrays of document data for the query.
        let u = new $70fd6868680e912c$var$DocumentSet;
        a.map((e)=>{
            const t = $70fd6868680e912c$var$__PRIVATE_fromDocument(r, e.document);
            u = u.add(t);
        });
        // Create a view snapshot of the query and documents.
        const c = $70fd6868680e912c$var$ViewSnapshot.fromInitialDocuments(_, u, $70fd6868680e912c$var$__PRIVATE_documentKeySet(), /* fromCache= */ !1, /* hasCachedResults= */ !1), l = new $70fd6868680e912c$export$62297b13309008b2(e, n || null, _);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $70fd6868680e912c$export$8f21149d8133945c(e, new $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter(e), l, c);
    }
}
function $70fd6868680e912c$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $70fd6868680e912c$var$fail(61501, {
                type: e
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $70fd6868680e912c$export$f243a5d948512846(e, t) {
    return e instanceof $70fd6868680e912c$export$acab0e6ef25eb301 && t instanceof $70fd6868680e912c$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $70fd6868680e912c$export$8f21149d8133945c && t instanceof $70fd6868680e912c$export$8f21149d8133945c && e._firestore === t._firestore && $70fd6868680e912c$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$11eb3b5ef9574821(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($70fd6868680e912c$export$8da5fbea04405656(t), e._key).then((n)=>$70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
$70fd6868680e912c$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $70fd6868680e912c$export$8f21149d8133945c._jsonSchema = {
    type: $70fd6868680e912c$var$property("string", $70fd6868680e912c$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: $70fd6868680e912c$var$property("string", "QuerySnapshot"),
    bundleName: $70fd6868680e912c$var$property("string"),
    bundle: $70fd6868680e912c$var$property("string")
};
class $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$a58bd92642f7fb58(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $70fd6868680e912c$export$acab0e6ef25eb301(t, r, e._key, n, new $70fd6868680e912c$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$35dd759aed9686b4(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($70fd6868680e912c$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$81d3477bd73c86ef(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$3fd010f18eac1dd(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$ec7d9e44f349c77b(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
function $70fd6868680e912c$export$5ff77ddaff3c9e12(e, t, n) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const r = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $70fd6868680e912c$export$1945f8fec9dda613(r, [
        $70fd6868680e912c$var$__PRIVATE_parseSetData($70fd6868680e912c$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $70fd6868680e912c$var$Precondition.none())
    ]);
}
function $70fd6868680e912c$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const i = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $gMVVg.getModularInstance)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $70fd6868680e912c$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $70fd6868680e912c$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a4f20481fae8f78b(e) {
    return $70fd6868680e912c$export$1945f8fec9dda613($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), [
        new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e._key, $70fd6868680e912c$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a13890143fb1c2dd(e, t) {
    const n = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$export$2a111da947c407d2(e), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $70fd6868680e912c$export$1945f8fec9dda613(n, [
        $70fd6868680e912c$var$__PRIVATE_parseSetData($70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $70fd6868680e912c$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $70fd6868680e912c$export$d36370812fb26935(e, ...t) {
    var n, r, i;
    // onSnapshot for Query or Document.
    e = (0, $gMVVg.getModularInstance)(e);
    let s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || $70fd6868680e912c$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o++]);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if ($70fd6868680e912c$var$__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof $70fd6868680e912c$export$6be62b059fb12175) u = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), c = $70fd6868680e912c$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: (n)=>{
            t[o] && t[o]($70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        const n = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
        u = $70fd6868680e912c$export$572106fb5803752c(n.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), c = n._query;
        const r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: (e)=>{
                t[o] && t[o](new $70fd6868680e912c$export$8f21149d8133945c(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver(r), s = new $70fd6868680e912c$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_eventManagerListen(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.Ou(), e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), s));
        };
    }($70fd6868680e912c$export$8da5fbea04405656(u), c, _, a);
}
function $70fd6868680e912c$export$a1ef90ed3b4a87fa(e, t, ...n) {
    const r = (0, $gMVVg.getModularInstance)(e), i = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(e) {
        const t = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in e)) {
                t.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = e[r];
            if ("string" != typeof n) {
                t.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                t.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? t.bundle = n : "bundleName" === r ? t.bundleName = n : "bundleSource" === r && (t.bundleSource = n);
        }
        return t;
    }(t);
    if (i.error) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, i.error);
    let s, o = 0;
    if ("object" != typeof n[o] || $70fd6868680e912c$var$__PRIVATE_isPartialObserver(n[o]) || (s = n[o++]), "QuerySnapshot" === i.bundleSource) {
        let e = null;
        if ("object" == typeof n[o] && $70fd6868680e912c$var$__PRIVATE_isPartialObserver(n[o])) {
            const t = n[o++];
            e = {
                next: t.next,
                error: t.error,
                complete: t.complete
            };
        } else e = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(e, t, n, r, i) {
            let s, o = !1;
            const _ = $70fd6868680e912c$export$4b8b93c690c9810b(e, t.bundle);
            return _.then(()=>$70fd6868680e912c$export$169d2c6fe0f7f4ea(e, t.bundleName)).then((e)=>{
                if (e && !o) i && e.withConverter(i), s = $70fd6868680e912c$export$d36370812fb26935(e, n || {}, r);
            }).catch((e)=>(r.error && r.error(e), ()=>{})), ()=>{
                o || (o = !0, s && s());
            };
        }(r, i, s, e, n[o]);
    }
    if ("DocumentSnapshot" === i.bundleSource) {
        let e = null;
        if ("object" == typeof n[o] && $70fd6868680e912c$var$__PRIVATE_isPartialObserver(n[o])) {
            const t = n[o++];
            e = {
                next: t.next,
                error: t.error,
                complete: t.complete
            };
        } else e = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(e, t, n, r, i) {
            let s, o = !1;
            const _ = $70fd6868680e912c$export$4b8b93c690c9810b(e, t.bundle);
            return _.then(()=>{
                if (!o) {
                    const o = new $70fd6868680e912c$export$6be62b059fb12175(e, i || null, $70fd6868680e912c$export$afc2e57c475b7810.fromPath(t.bundleName));
                    s = $70fd6868680e912c$export$d36370812fb26935(o, n || {}, r);
                }
            }).catch((e)=>(r.error && r.error(e), ()=>{})), ()=>{
                o || (o = !0, s && s());
            };
        }(r, i, s, e, n[o]);
    }
    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, `unsupported bundle source: ${i.bundleSource}`);
}
function $70fd6868680e912c$export$9dff4f5aba83e348(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), $70fd6868680e912c$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $70fd6868680e912c$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_syncEngineWrite(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(e);
    return new $70fd6868680e912c$export$acab0e6ef25eb301(e, i, t._key, r, new $70fd6868680e912c$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
function $70fd6868680e912c$export$b1de1b12889d0afb(e) {
    return $70fd6868680e912c$export$a51511de2fae49b3(e, {
        count: $70fd6868680e912c$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $70fd6868680e912c$export$a51511de2fae49b3(e, t) {
    const n = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$export$8da5fbea04405656(n), i = $70fd6868680e912c$var$__PRIVATE_mapToArray(t, (e, t)=>new $70fd6868680e912c$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(e), i = new $70fd6868680e912c$export$40257fef64be808b(t, r, n);
            return i;
        })(n, e, t));
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = {
            build: ()=>new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $70fd6868680e912c$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider.provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $70fd6868680e912c$export$574728f3be606189() {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $70fd6868680e912c$export$2340f88905cc0c23(e) {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryLruGarbageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $70fd6868680e912c$export$72ef71adb739a32c(e) {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $70fd6868680e912c$export$51b321e43d5331d5(e) {
    return new $70fd6868680e912c$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $70fd6868680e912c$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $70fd6868680e912c$export$d5f96a3c009e86ac(e) {
    return new $70fd6868680e912c$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $70fd6868680e912c$export$57e9d290b0b4dc04() {
    return new $70fd6868680e912c$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Pn = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $70fd6868680e912c$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $70fd6868680e912c$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $70fd6868680e912c$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $gMVVg.getModularInstance)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $70fd6868680e912c$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(t._key, $70fd6868680e912c$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $70fd6868680e912c$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $gMVVg.getModularInstance)(e)).firestore !== t) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$var$Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), n = new $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $70fd6868680e912c$var$fail(24041);
            const r = e[0];
            if (r.isFoundDocument()) return new $70fd6868680e912c$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $70fd6868680e912c$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $70fd6868680e912c$var$fail(18433, {
                doc: r
            });
        });
    }
    set(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $70fd6868680e912c$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $gMVVg.getModularInstance)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$export$febc5573c75cefb0 extends $70fd6868680e912c$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), n = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $70fd6868680e912c$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $70fd6868680e912c$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $70fd6868680e912c$export$3c54e006bf9c93b7(e, t, n) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82);
    const r = Object.assign(Object.assign({}, $70fd6868680e912c$var$Pn), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $70fd6868680e912c$var$__PRIVATE_getDatastore(e);
            new $70fd6868680e912c$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).zu();
        }), r.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e), (n)=>t(new $70fd6868680e912c$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $70fd6868680e912c$export$2bbad96c62fdba3e() {
    return new $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $70fd6868680e912c$export$3ff8e7e00c3264b7() {
    return new $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $70fd6868680e912c$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$a2647aa13413c947(e) {
    return new $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $70fd6868680e912c$export$6074e20ba5c64bef(e) {
    return new $70fd6868680e912c$export$994bb3d317350b37(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $70fd6868680e912c$export$44cd1c9d57edd9b1(e) {
    return $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), new $70fd6868680e912c$export$d94ed661b1cfd435(e, (t)=>$70fd6868680e912c$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$export$ff1663c0c1304f1a(e, t) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82));
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $70fd6868680e912c$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $70fd6868680e912c$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $70fd6868680e912c$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $70fd6868680e912c$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $70fd6868680e912c$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $70fd6868680e912c$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $70fd6868680e912c$var$FieldIndex($70fd6868680e912c$var$FieldIndex.UNKNOWN_ID, t, r, $70fd6868680e912c$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientSetIndexConfiguration(n, r);
}
function $70fd6868680e912c$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $70fd6868680e912c$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(e){
        this._firestore = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $70fd6868680e912c$export$61c6347b57bdfa06(e) {
    var t;
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82);
    const n = $70fd6868680e912c$var$Tn.get(e);
    if (n) return n;
    if ("persistent" !== (null === (t = $70fd6868680e912c$export$8da5fbea04405656(e)._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offline.kind)) return null;
    const r = new $70fd6868680e912c$export$cf4db3c220e88bd8(e);
    return $70fd6868680e912c$var$Tn.set(e, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $70fd6868680e912c$export$9b2c0a7aacbcd151(e) {
    $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $70fd6868680e912c$export$5b460d5f48076743(e) {
    $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $70fd6868680e912c$export$72809fc2fc5083d5(e) {
    $70fd6868680e912c$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes($70fd6868680e912c$export$8da5fbea04405656(e._firestore)).then((e)=>$70fd6868680e912c$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded")).catch((e)=>$70fd6868680e912c$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e));
}
function $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    $70fd6868680e912c$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled($70fd6868680e912c$export$8da5fbea04405656(e._firestore), t).then((e)=>$70fd6868680e912c$var$__PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`)).catch((e)=>$70fd6868680e912c$export$86cd73f49cc6e0bb(`setting persistent cache index auto creation isEnabled=${t} failed`, e));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $70fd6868680e912c$var$Tn = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70fd6868680e912c$export$b22c6725d8899bb4(e) {
    var t;
    const n = null === (t = $70fd6868680e912c$export$8da5fbea04405656($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : $70fd6868680e912c$var$__PRIVATE_toQueryTarget(n, $70fd6868680e912c$var$__PRIVATE_queryToTarget(e._query)).Vt;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $70fd6868680e912c$export$5bcaa7c32a88925e(e, t) {
    var n;
    const r = $70fd6868680e912c$var$__PRIVATE_mapToArray(t, (e, t)=>new $70fd6868680e912c$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), i = null === (n = $70fd6868680e912c$export$8da5fbea04405656($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(i, $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(e._query), r, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $70fd6868680e912c$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(e) {
        return $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.Fc = new Map;
    }
    static get instance() {
        return $70fd6868680e912c$var$In || ($70fd6868680e912c$var$In = new $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if ($70fd6868680e912c$var$pt) throw new Error("a TestingHooksSpi instance is already set");
            $70fd6868680e912c$var$pt = e;
        }($70fd6868680e912c$var$In)), $70fd6868680e912c$var$In;
    }
    ct(e) {
        this.Fc.forEach((t)=>t(e));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Fc;
        return n.set(t, e), ()=>n.delete(t);
    }
}
let $70fd6868680e912c$var$In = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $70fd6868680e912c$var$x = e;
    }((0, $7xvHX.SDK_VERSION)), (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $70fd6868680e912c$export$d0e2b3272814ce82(new $70fd6868680e912c$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $70fd6868680e912c$var$__PRIVATE_FirebaseAppCheckTokenProvider(i, e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$N.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $70fd6868680e912c$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $7xvHX.registerVersion)($70fd6868680e912c$var$F, $70fd6868680e912c$var$M, e), // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $7xvHX.registerVersion)($70fd6868680e912c$var$F, $70fd6868680e912c$var$M, "esm2017");
}();

});
parcelRegister("cozvr", function(module, exports) {

$parcel$export(module.exports, "Integer", () => $906344b47e605252$export$70ffa26850098d01);
$parcel$export(module.exports, "Md5", () => $906344b47e605252$export$9f5a3dfc7a9f5dd);
var $906344b47e605252$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $906344b47e605252$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $906344b47e605252$export$70ffa26850098d01;
var $906344b47e605252$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $906344b47e605252$export$9f5a3dfc7a9f5dd = $906344b47e605252$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $906344b47e605252$export$70ffa26850098d01 = $906344b47e605252$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $906344b47e605252$var$commonjsGlobal !== 'undefined' ? $906344b47e605252$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});

parcelRegister("4rHck", function(module, exports) {

$parcel$export(module.exports, "XhrIo", () => $33cb313d667e3306$export$26404658cda3ee02);
$parcel$export(module.exports, "WebChannel", () => $33cb313d667e3306$export$aa726fb96ad3e039);
$parcel$export(module.exports, "EventType", () => $33cb313d667e3306$export$3d7865934588d77e);
$parcel$export(module.exports, "ErrorCode", () => $33cb313d667e3306$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "Stat", () => $33cb313d667e3306$export$cbbc350c1dfc80cb);
$parcel$export(module.exports, "Event", () => $33cb313d667e3306$export$d61e24a684f9e51);
$parcel$export(module.exports, "getStatEventTarget", () => $33cb313d667e3306$export$888d0d9ab79d08fc);
$parcel$export(module.exports, "createWebChannelTransport", () => $33cb313d667e3306$export$66869136fc133c3a);
var $33cb313d667e3306$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $33cb313d667e3306$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $33cb313d667e3306$export$26404658cda3ee02;
var $33cb313d667e3306$export$ddb1030448106742;
var $33cb313d667e3306$export$aa726fb96ad3e039;
var $33cb313d667e3306$export$3d7865934588d77e;
var $33cb313d667e3306$export$d4e71bc0b80dc0fb;
var $33cb313d667e3306$export$cbbc350c1dfc80cb;
var $33cb313d667e3306$export$d61e24a684f9e51;
var $33cb313d667e3306$export$888d0d9ab79d08fc;
var $33cb313d667e3306$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $33cb313d667e3306$var$commonjsGlobal && $33cb313d667e3306$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a;
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        const b = a.length;
        if (0 < b) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(let c = 1; c < arguments.length; c++){
            const d = arguments[c];
            if (ha(d)) {
                const e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(let g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    class na {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class Aa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = Ba.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var Ba = new na(()=>new Ca, (a)=>a.reset());
    class Ca {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let x, y = !1, za = new Aa, Ea = ()=>{
        const a = k.Promise.resolve(void 0);
        x = ()=>{
            a.then(Da);
        };
    };
    var Da = ()=>{
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(()=>{
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class eb extends z {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : cb(this);
        }
        N() {
            super.N();
            this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = class {
        stringify(a) {
            return k.JSON.stringify(a, void 0);
        }
        parse(a) {
            return k.JSON.parse(a, void 0);
        }
    };
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        const b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        const b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        const b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const w = P(this.g);
                var b = this.g.Ba();
                const O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            let B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        const a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    let l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            const v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            const w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            const O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            const B = a.g;
                            if (B) {
                                const ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    const db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.D);
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(const d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(let d = 0; d < b.length; d++){
            const e = a[d];
            for(let f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        let b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            const f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        const c = new vb;
        if (k.Image) {
            const d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        const c = new vb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        const d = c || "";
        try {
            nc(a, function(e, f) {
                let g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        const b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function() {
            return "include" === this.m;
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        let b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    const g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            const c = a.g, d = a.v[0] ? ()=>{} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        const b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            const e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    const e = new M(this, this.j, a);
                    let f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        const d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            let f = -1;
            for(;;){
                const g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                let m = !0;
                for(let q = 0; q < c; q++){
                    let l = e[q].g;
                    const v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        let c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            const b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $33cb313d667e3306$export$66869136fc133c3a = $33cb313d667e3306$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new hd;
    };
    $33cb313d667e3306$export$888d0d9ab79d08fc = $33cb313d667e3306$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return qb();
    };
    $33cb313d667e3306$export$d61e24a684f9e51 = $33cb313d667e3306$export$2e2bcd8739ae039.Event = I;
    $33cb313d667e3306$export$cbbc350c1dfc80cb = $33cb313d667e3306$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $33cb313d667e3306$export$d4e71bc0b80dc0fb = $33cb313d667e3306$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $33cb313d667e3306$export$3d7865934588d77e = $33cb313d667e3306$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $33cb313d667e3306$export$aa726fb96ad3e039 = $33cb313d667e3306$export$2e2bcd8739ae039.WebChannel = mb;
    $33cb313d667e3306$export$ddb1030448106742 = $33cb313d667e3306$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $33cb313d667e3306$export$26404658cda3ee02 = $33cb313d667e3306$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $33cb313d667e3306$var$commonjsGlobal !== 'undefined' ? $33cb313d667e3306$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





//# sourceMappingURL=index.esm.5c7d6d23.js.map
